function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n3 = 0, F = function F() {}; return { s: F, n: function n() { return _n3 >= r.length ? { done: !0 } : { done: !1, value: r[_n3++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
window.theme = window.theme || {};
window.themeInfo = {
  name: "Vantage"
};
(function vendorLazySizes() {
  /*! lazysizes - v4.0.1 */
  !function (a, b) {
    var c = b(a, a.document);
    a.lazySizes = c, "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports && (module.exports = c);
  }(window, function (a, b) {
    "use strict";

    if (b.getElementsByClassName) {
      var c,
        d,
        e = b.documentElement,
        f = a.Date,
        g = a.HTMLPictureElement,
        h = "addEventListener",
        i = "getAttribute",
        j = a[h],
        k = a.setTimeout,
        l = a.requestAnimationFrame || k,
        m = a.requestIdleCallback,
        n = /^picture$/i,
        o = ["load", "error", "lazyincluded", "_lazyloaded"],
        p = {},
        q = Array.prototype.forEach,
        r = function r(a, b) {
          return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b];
        },
        s = function s(a, b) {
          r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b);
        },
        t = function t(a, b) {
          var c;
          (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "));
        },
        _u = function u(a, b, c) {
          var d = c ? h : "removeEventListener";
          c && _u(a, b), o.forEach(function (c) {
            a[d](c, b);
          });
        },
        v = function v(a, d, e, f, g) {
          var h = b.createEvent("CustomEvent");
          return e || (e = {}), e.instance = c, h.initCustomEvent(d, !f, !g, e), a.dispatchEvent(h), h;
        },
        w = function w(b, c) {
          var e;
          !g && (e = a.picturefill || d.pf) ? e({
            reevaluate: !0,
            elements: [b]
          }) : c && c.src && (b.src = c.src);
        },
        x = function x(a, b) {
          return (getComputedStyle(a, null) || {})[b];
        },
        y = function y(a, b, c) {
          for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;) c = b.offsetWidth, b = b.parentNode;
          return c;
        },
        z = function () {
          var a,
            c,
            d = [],
            e = [],
            f = d,
            g = function g() {
              var b = f;
              for (f = d.length ? e : d, a = !0, c = !1; b.length;) b.shift()();
              a = !1;
            },
            h = function h(d, e) {
              a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g)));
            };
          return h._lsFlush = g, h;
        }(),
        A = function A(a, b) {
          return b ? function () {
            z(a);
          } : function () {
            var b = this,
              c = arguments;
            z(function () {
              a.apply(b, c);
            });
          };
        },
        B = function B(a) {
          var b,
            c = 0,
            e = 125,
            g = d.ricTimeout,
            h = function h() {
              b = !1, c = f.now(), a();
            },
            i = m && d.ricTimeout ? function () {
              m(h, {
                timeout: g
              }), g !== d.ricTimeout && (g = d.ricTimeout);
            } : A(function () {
              k(h);
            }, !0);
          return function (a) {
            var d;
            (a = a === !0) && (g = 33), b || (b = !0, d = e - (f.now() - c), 0 > d && (d = 0), a || 9 > d && m ? i() : k(i, d));
          };
        },
        C = function C(a) {
          var b,
            c,
            d = 99,
            e = function e() {
              b = null, a();
            },
            _g = function g() {
              var a = f.now() - c;
              d > a ? k(_g, d - a) : (m || e)(e);
            };
          return function () {
            c = f.now(), b || (b = k(_g, d));
          };
        };
      !function () {
        var b,
          c = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            autosizesClass: "lazyautosizes",
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            minSize: 40,
            customMedia: {},
            init: !0,
            expFactor: 1.5,
            hFac: .8,
            loadMode: 2,
            loadHidden: !0,
            ricTimeout: 300
          };
        d = a.lazySizesConfig || a.lazysizesConfig || {};
        for (b in c) b in d || (d[b] = c[b]);
        a.lazySizesConfig = d, k(function () {
          d.init && _F();
        });
      }();
      var D = function () {
          var g,
            l,
            m,
            o,
            p,
            y,
            D,
            F,
            G,
            H,
            I,
            J,
            K,
            L,
            M = /^img$/i,
            N = /^iframe$/i,
            O = "onscroll" in a && !/glebot/.test(navigator.userAgent),
            P = 0,
            Q = 0,
            R = 0,
            S = -1,
            _T = function T(a) {
              R--, a && a.target && _u(a.target, _T), (!a || 0 > R || !a.target) && (R = 0);
            },
            U = function U(a, c) {
              var d,
                f = a,
                g = "hidden" == x(b.body, "visibility") || "hidden" != x(a, "visibility");
              for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;) g = (x(f, "opacity") || 1) > 0, g && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1);
              return g;
            },
            V = function V() {
              var a,
                f,
                h,
                j,
                k,
                m,
                n,
                p,
                q,
                r = c.elements;
              if ((o = d.loadMode) && 8 > R && (a = r.length)) {
                f = 0, S++, null == K && ("expand" in d || (d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370), J = d.expand, K = J * d.expFactor), K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? (Q = K, S = 0) : Q = o > 1 && S > 1 && 6 > R ? J : P;
                for (; a > f; f++) if (r[f] && !r[f]._lazyRace) if (O) {
                  if ((p = r[f][i]("data-expand")) && (m = 1 * p) || (m = Q), q !== m && (y = innerWidth + m * L, D = innerHeight + m, n = -1 * m, q = m), h = r[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * L && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || "hidden" != x(r[f], "visibility")) && (l && 3 > R && !p && (3 > o || 4 > S) || U(r[f], m))) {
                    if (ba(r[f]), k = !0, R > 9) break;
                  } else !k && l && !j && 4 > R && 4 > S && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != r[f][i](d.sizesAttr))) && (j = g[0] || r[f]);
                } else ba(r[f]);
                j && !k && ba(j);
              }
            },
            W = B(V),
            X = function X(a) {
              s(a.target, d.loadedClass), t(a.target, d.loadingClass), _u(a.target, Z), v(a.target, "lazyloaded");
            },
            Y = A(X),
            Z = function Z(a) {
              Y({
                target: a.target
              });
            },
            $ = function $(a, b) {
              try {
                a.contentWindow.location.replace(b);
              } catch (c) {
                a.src = b;
              }
            },
            _ = function _(a) {
              var b,
                c = a[i](d.srcsetAttr);
              (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c);
            },
            aa = A(function (a, b, c, e, f) {
              var g, h, j, l, o, p;
              (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = {
                target: a
              }, p && (_u(a, _T, !0), clearTimeout(m), m = k(_T, 2500), s(a, d.loadingClass), _u(a, Z, !0)), l && q.call(j.getElementsByTagName("source"), _), h ? a.setAttribute("srcset", h) : g && !l && (N.test(a.nodeName) ? $(a, g) : a.src = g), f && (h || l) && w(a, {
                src: g
              })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () {
                (!p || a.complete && a.naturalWidth > 1) && (p ? _T(o) : R--, X(o));
              }, !0);
            }),
            ba = function ba(a) {
              var b,
                c = M.test(a.nodeName),
                e = c && (a[i](d.sizesAttr) || a[i]("sizes")),
                f = "auto" == e;
              (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, R++, aa(a, b, f, e, c));
            },
            _ca = function ca() {
              if (!l) {
                if (f.now() - p < 999) return void k(_ca, 999);
                var a = C(function () {
                  d.loadMode = 3, W();
                });
                l = !0, d.loadMode = 3, W(), j("scroll", function () {
                  3 == d.loadMode && (d.loadMode = 2), a();
                }, !0);
              }
            };
          return {
            _: function _() {
              p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), L = d.hFac, j("scroll", W, !0), j("resize", W, !0), a.MutationObserver ? new MutationObserver(W).observe(e, {
                childList: !0,
                subtree: !0,
                attributes: !0
              }) : (e[h]("DOMNodeInserted", W, !0), e[h]("DOMAttrModified", W, !0), setInterval(W, 999)), j("hashchange", W, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) {
                b[h](a, W, !0);
              }), /d$|^c/.test(b.readyState) ? _ca() : (j("load", _ca), b[h]("DOMContentLoaded", W), k(_ca, 2e4)), c.elements.length ? (V(), z._lsFlush()) : W();
            },
            checkElems: W,
            unveil: ba
          };
        }(),
        E = function () {
          var a,
            c = A(function (a, b, c, d) {
              var e, f, g;
              if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; g > f; f++) e[f].setAttribute("sizes", d);
              c.detail.dataAttr || w(a, c.detail);
            }),
            e = function e(a, b, d) {
              var e,
                f = a.parentNode;
              f && (d = y(a, f, d), e = v(a, "lazybeforesizes", {
                width: d,
                dataAttr: !!b
              }), e.defaultPrevented || (d = e.detail.width, d && d !== a._lazysizesWidth && c(a, f, e, d)));
            },
            f = function f() {
              var b,
                c = a.length;
              if (c) for (b = 0; c > b; b++) e(a[b]);
            },
            g = C(f);
          return {
            _: function _() {
              a = b.getElementsByClassName(d.autosizesClass), j("resize", g);
            },
            checkElems: g,
            updateElem: e
          };
        }(),
        _F = function F() {
          _F.i || (_F.i = !0, E._(), D._());
        };
      return c = {
        cfg: d,
        autoSizer: E,
        loader: D,
        init: _F,
        uP: w,
        aC: s,
        rC: t,
        hC: r,
        fire: v,
        gW: y,
        rAF: z
      };
    }
  });

  /*! lazysizes Bgset - v4.0.1 */
  !function (a, b) {
    var _c = function c() {
      b(a.lazySizes), a.removeEventListener("lazyunveilread", _c, !0);
    };
    b = b.bind(null, a, a.document), "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? b(require("lazysizes")) : a.lazySizes ? _c() : a.addEventListener("lazyunveilread", _c, !0);
  }(window, function (a, b, c) {
    "use strict";

    if (a.addEventListener) {
      var d = /\s+/g,
        e = /\s*\|\s+|\s+\|\s*/g,
        f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
        g = /\(|\)|'/,
        h = {
          contain: 1,
          cover: 1
        },
        i = function i(a) {
          var b = c.gW(a, a.parentNode);
          return (!a._lazysizesWidth || b > a._lazysizesWidth) && (a._lazysizesWidth = b), a._lazysizesWidth;
        },
        j = function j(a) {
          var b;
          return b = (getComputedStyle(a) || {
            getPropertyValue: function getPropertyValue() {}
          }).getPropertyValue("background-size"), !h[b] && h[a.style.backgroundSize] && (b = a.style.backgroundSize), b;
        },
        k = function k(a, c, g) {
          var h = b.createElement("picture"),
            i = c.getAttribute(lazySizesConfig.sizesAttr),
            j = c.getAttribute("data-ratio"),
            k = c.getAttribute("data-optimumx");
          c._lazybgset && c._lazybgset.parentNode == c && c.removeChild(c._lazybgset), Object.defineProperty(g, "_lazybgset", {
            value: c,
            writable: !0
          }), Object.defineProperty(c, "_lazybgset", {
            value: h,
            writable: !0
          }), a = a.replace(d, " ").split(e), h.style.display = "none", g.className = lazySizesConfig.lazyClass, 1 != a.length || i || (i = "auto"), a.forEach(function (a) {
            var c = b.createElement("source");
            i && "auto" != i && c.setAttribute("sizes", i), a.match(f) && (c.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && c.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)), h.appendChild(c);
          }), i && (g.setAttribute(lazySizesConfig.sizesAttr, i), c.removeAttribute(lazySizesConfig.sizesAttr), c.removeAttribute("sizes")), k && g.setAttribute("data-optimumx", k), j && g.setAttribute("data-ratio", j), h.appendChild(g), c.appendChild(h);
        },
        l = function l(a) {
          if (a.target._lazybgset) {
            var b = a.target,
              d = b._lazybgset,
              e = b.currentSrc || b.src;
            e && (d.style.backgroundImage = "url(" + (g.test(e) ? JSON.stringify(e) : e) + ")"), b._lazybgsetLoading && (c.fire(d, "_lazyloaded", {}, !1, !0), delete b._lazybgsetLoading);
          }
        };
      addEventListener("lazybeforeunveil", function (a) {
        var d, e, f;
        !a.defaultPrevented && (d = a.target.getAttribute("data-bgset")) && (f = a.target, e = b.createElement("img"), e.alt = "", e._lazybgsetLoading = !0, a.detail.firesLoad = !0, k(d, f, e), setTimeout(function () {
          c.loader.unveil(e), c.rAF(function () {
            c.fire(e, "_lazyloaded", {}, !0, !0), e.complete && l({
              target: e
            });
          });
        }));
      }), b.addEventListener("load", l, !0), a.addEventListener("lazybeforesizes", function (a) {
        if (a.detail.instance == c && a.target._lazybgset && a.detail.dataAttr) {
          var b = a.target._lazybgset,
            d = j(b);
          h[d] && (a.target._lazysizesParentFit = d, c.rAF(function () {
            a.target.setAttribute("data-parent-fit", d), a.target._lazysizesParentFit && delete a.target._lazysizesParentFit;
          }));
        }
      }, !0), b.documentElement.addEventListener("lazybeforesizes", function (a) {
        !a.defaultPrevented && a.target._lazybgset && a.detail.instance == c && (a.detail.width = i(a.target._lazybgset));
      });
    }
  });

  /*! lazysizes rias - v4.0.1 */
  !function (a, b) {
    var _c2 = function c() {
      b(a.lazySizes), a.removeEventListener("lazyunveilread", _c2, !0);
    };
    b = b.bind(null, a, a.document), "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? b(require("lazysizes")) : a.lazySizes ? _c2() : a.addEventListener("lazyunveilread", _c2, !0);
  }(window, function (a, b, c) {
    "use strict";

    function d(b, c) {
      var d,
        e,
        f,
        g,
        h = a.getComputedStyle(b);
      e = b.parentNode, g = {
        isPicture: !(!e || !m.test(e.nodeName || ""))
      }, f = function f(a, c) {
        var d = b.getAttribute("data-" + a);
        if (!d) {
          var e = h.getPropertyValue("--ls-" + a);
          e && (d = e.trim());
        }
        if (d) {
          if ("true" == d) d = !0;else if ("false" == d) d = !1;else if (l.test(d)) d = parseFloat(d);else if ("function" == typeof j[a]) d = j[a](b, d);else if (q.test(d)) try {
            d = JSON.parse(d);
          } catch (f) {}
          g[a] = d;
        } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d));
      };
      for (d in j) f(d);
      return c.replace(p, function (a, b) {
        b in g || f(b, !0);
      }), g;
    }
    function e(a, b) {
      var c = [],
        d = function d(a, c) {
          return k[_typeof(b[c])] ? b[c] : a;
        };
      return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) {
        var e = b.widthmap[d] || d,
          f = {
            u: a.replace(n, e).replace(o, b.ratio ? Math.round(d * b.ratio) : ""),
            w: d
          };
        c.push(f), c.srcset.push(f.c = f.u + " " + d + "w");
      }), c;
    }
    function f(a, c, d) {
      var f = 0,
        g = 0,
        h = d;
      if (a) {
        if ("container" === c.ratio) {
          for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);) h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight;
          f && g && (c.ratio = g / f);
        }
        a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", {
          value: a,
          writable: !0
        });
      }
    }
    function g(a, b) {
      var e = d(a, b);
      return j.modifyOptions.call(a, {
        target: a,
        details: e,
        detail: e
      }), c.fire(a, "lazyriasmodifyoptions", e), e;
    }
    function h(a) {
      return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "";
    }
    var i,
      j,
      k = {
        string: 1,
        number: 1
      },
      l = /^\-*\+*\d+\.*\d*$/,
      m = /^picture$/i,
      n = /\s*\{\s*width\s*\}\s*/i,
      o = /\s*\{\s*height\s*\}\s*/i,
      p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      q = /^\[.*\]|\{.*\}$/,
      r = /^(?:auto|\d+(px)?)$/,
      s = b.createElement("a"),
      t = b.createElement("img"),
      u = "srcset" in t && !("sizes" in t),
      v = !!a.HTMLPictureElement && !u;
    !function () {
      var b,
        d = function d() {},
        e = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: !1,
          modifyOptions: d,
          widthmap: {},
          ratio: !1
        };
      i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) {
        return !a;
      }), i.rias || (i.rias = {}), j = i.rias, "widths" in j || (j.widths = [], function (a) {
        for (var b, c = 0; !b || 3e3 > b;) c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b);
      }(j.widths));
      for (b in e) b in j || (j[b] = e[b]);
    }(), addEventListener("lazybeforesizes", function (a) {
      if (a.detail.instance == c) {
        var b, d, e, k, l, m, o, p, q, s, t, u, x;
        if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) {
          if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; o > m; m++) (t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0);
          t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", {
            value: x,
            writable: !0
          })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = {
            width: parseInt(q, 10)
          }, w({
            target: b,
            detail: s
          })));
        }
      }
    }, !0);
    var w = function () {
      var d = function d(a, b) {
          return a.w - b.w;
        },
        e = function e(a) {
          var b,
            c,
            d = a.length,
            e = a[d - 1],
            f = 0;
          for (f; d > f; f++) if (e = a[f], e.d = e.w / a.w, e.d >= a.d) {
            !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b));
            break;
          }
          return e;
        },
        f = function f(a, b) {
          var d;
          return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", {
            value: d,
            writable: !0
          }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias;
        },
        g = function g(b) {
          var d = a.devicePixelRatio || 1,
            e = c.getX && c.getX(b);
          return Math.min(e || d, 2.4, d);
        },
        h = function h(b, c) {
          var h, i, j, k, l, m;
          if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; j > i; i++) if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) {
            l = h[i]._lazyrias;
            break;
          }
          return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m;
        },
        _j = function j(d) {
          if (d.detail.instance == c) {
            var e,
              g = d.target;
            return !u && (a.respimage || a.picturefill || lazySizesConfig.pf) ? void b.removeEventListener("lazybeforesizes", _j) : void (("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width), e && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () {
              g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u);
            }))));
          }
        };
      return v ? _j = function _j() {} : addEventListener("lazybeforesizes", _j), _j;
    }();
  });
})();
(function polyfillNodeList() {
  /* For IE 11+ Nodelist forEach Function */
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }

  /* IE 11 Includes Polyfill */
  if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
      'use strict';

      if (typeof start !== 'number') {
        start = 0;
      }
      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }
  /* IE11 Polyfill for remove */
  (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
})();
(function vendorModernizr() {
  /* Modernizr 2.8.2 (Custom Build) | MIT & BSD
   * Build: http://modernizr.com/download/#-fontface-csstransforms-csstransforms3d-touch-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-cssclassprefix:supports!
   */
  ;
  window.Modernizr = function (a, b, c) {
    function z(a) {
      j.cssText = a;
    }
    function A(a, b) {
      return z(m.join(a + ";") + (b || ""));
    }
    function B(a, b) {
      return _typeof(a) === b;
    }
    function C(a, b) {
      return !!~("" + a).indexOf(b);
    }
    function D(a, b) {
      for (var d in a) {
        var e = a[d];
        if (!C(e, "-") && j[e] !== c) return b == "pfx" ? e : !0;
      }
      return !1;
    }
    function E(a, b, d) {
      for (var e in a) {
        var f = b[a[e]];
        if (f !== c) return d === !1 ? a[e] : B(f, "function") ? f.bind(d || b) : f;
      }
      return !1;
    }
    function F(a, b, c) {
      var d = a.charAt(0).toUpperCase() + a.slice(1),
        e = (a + " " + o.join(d + " ") + d).split(" ");
      return B(b, "string") || B(b, "undefined") ? D(e, b) : (e = (a + " " + p.join(d + " ") + d).split(" "), E(e, b, c));
    }
    var d = "2.8.2",
      e = {},
      f = !0,
      g = b.documentElement,
      h = "modernizr",
      i = b.createElement(h),
      j = i.style,
      k,
      l = {}.toString,
      m = " -webkit- -moz- -o- -ms- ".split(" "),
      n = "Webkit Moz O ms",
      o = n.split(" "),
      p = n.toLowerCase().split(" "),
      q = {},
      r = {},
      s = {},
      t = [],
      u = t.slice,
      v,
      w = function w(a, c, d, e) {
        var f,
          i,
          j,
          k,
          l = b.createElement("div"),
          m = b.body,
          n = m || b.createElement("body");
        if (parseInt(d, 10)) while (d--) j = b.createElement("div"), j.id = e ? e[d] : h + (d + 1), l.appendChild(j);
        return f = ["&#173;", '<style id="s', h, '">', a, "</style>"].join(""), l.id = h, (m ? l : n).innerHTML += f, n.appendChild(l), m || (n.style.background = "", n.style.overflow = "hidden", k = g.style.overflow, g.style.overflow = "hidden", g.appendChild(n)), i = c(l, a), m ? l.parentNode.removeChild(l) : (n.parentNode.removeChild(n), g.style.overflow = k), !!i;
      },
      x = {}.hasOwnProperty,
      y;
    !B(x, "undefined") && !B(x.call, "undefined") ? y = function y(a, b) {
      return x.call(a, b);
    } : y = function y(a, b) {
      return b in a && B(a.constructor.prototype[b], "undefined");
    }, Function.prototype.bind || (Function.prototype.bind = function (b) {
      var c = this;
      if (typeof c != "function") throw new TypeError();
      var d = u.call(arguments, 1),
        _e = function e() {
          if (this instanceof _e) {
            var a = function a() {};
            a.prototype = c.prototype;
            var f = new a(),
              g = c.apply(f, d.concat(u.call(arguments)));
            return Object(g) === g ? g : f;
          }
          return c.apply(b, d.concat(u.call(arguments)));
        };
      return _e;
    }), q.touch = function () {
      var c;
      return "ontouchstart" in a || a.DocumentTouch && b instanceof DocumentTouch ? c = !0 : w(["@media (", m.join("touch-enabled),("), h, ")", "{#modernizr{top:9px;position:absolute}}"].join(""), function (a) {
        c = a.offsetTop === 9;
      }), c;
    }, q.csstransforms = function () {
      return !!F("transform");
    }, q.csstransforms3d = function () {
      var a = !!F("perspective");
      return a && "webkitPerspective" in g.style && w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function (b, c) {
        a = b.offsetLeft === 9 && b.offsetHeight === 3;
      }), a;
    }, q.fontface = function () {
      var a;
      return w('@font-face {font-family:"font";src:url("https://")}', function (c, d) {
        var e = b.getElementById("smodernizr"),
          f = e.sheet || e.styleSheet,
          g = f ? f.cssRules && f.cssRules[0] ? f.cssRules[0].cssText : f.cssText || "" : "";
        a = /src/i.test(g) && g.indexOf(d.split(" ")[0]) === 0;
      }), a;
    };
    for (var G in q) y(q, G) && (v = G.toLowerCase(), e[v] = q[G](), t.push((e[v] ? "" : "no-") + v));
    return e.addTest = function (a, b) {
      if (_typeof(a) == "object") for (var d in a) y(a, d) && e.addTest(d, a[d]);else {
        a = a.toLowerCase();
        if (e[a] !== c) return e;
        b = typeof b == "function" ? b() : b, typeof f != "undefined" && f && (g.className += " supports-" + (b ? "" : "no-") + a), e[a] = b;
      }
      return e;
    }, z(""), i = k = null, e._version = d, e._prefixes = m, e._domPrefixes = p, e._cssomPrefixes = o, e.testProp = function (a) {
      return D([a]);
    }, e.testAllProps = F, e.testStyles = w, g.className = g.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + (f ? " supports-js supports-" + t.join(" supports-") : ""), e;
  }(this, this.document);
})();
(function helperCookie() {
  !function (e) {
    var n;
    if ("function" == typeof define && define.amd && (define(e), n = !0), "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && (module.exports = e(), n = !0), !n) {
      var t = window.Cookies,
        o = window.Cookies = e();
      o.noConflict = function () {
        return window.Cookies = t, o;
      };
    }
  }(function () {
    function e() {
      for (var e = 0, n = {}; e < arguments.length; e++) {
        var t = arguments[e];
        for (var o in t) n[o] = t[o];
      }
      return n;
    }
    function n(e) {
      return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    return function t(o) {
      function r() {}
      function i(n, t, i) {
        if ("undefined" != typeof document) {
          "number" == typeof (i = e({
            path: "/"
          }, r.defaults, i)).expires && (i.expires = new Date(1 * new Date() + 864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() : "";
          try {
            var c = JSON.stringify(t);
            /^[\{\[]/.test(c) && (t = c);
          } catch (e) {}
          t = o.write ? o.write(t, n) : encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), n = encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var f = "";
          for (var u in i) i[u] && (f += "; " + u, !0 !== i[u] && (f += "=" + i[u].split(";")[0]));
          return document.cookie = n + "=" + t + f;
        }
      }
      function c(e, t) {
        if ("undefined" != typeof document) {
          for (var r = {}, i = document.cookie ? document.cookie.split("; ") : [], c = 0; c < i.length; c++) {
            var f = i[c].split("="),
              u = f.slice(1).join("=");
            t || '"' !== u.charAt(0) || (u = u.slice(1, -1));
            try {
              var a = n(f[0]);
              if (u = (o.read || o)(u, a) || n(u), t) try {
                u = JSON.parse(u);
              } catch (e) {}
              if (r[a] = u, e === a) break;
            } catch (e) {}
          }
          return e ? r[e] : r;
        }
      }
      return r.set = i, r.get = function (e) {
        return c(e, !1);
      }, r.getJSON = function (e) {
        return c(e, !0);
      }, r.remove = function (n, t) {
        i(n, "", e(t, {
          expires: -1
        }));
      }, r.defaults = {}, r.withConverter = t, r;
    }(function () {});
  });
})();
(function vendorLodash() {
  // lodash.core.min.js

  /**
   * @license
   * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
   * Build: `lodash core -o ./dist/lodash.core.js`
   */
  ;
  (function () {
    function n(n, t) {
      for (var r = -1, e = t.length, u = n.length; ++r < e;) n[u + r] = t[r];
      return n;
    }
    function t(n, t, r) {
      for (var e = -1, u = n.length; ++e < u;) {
        var o = n[e],
          i = t(o);
        if (null != i && (c === an ? i === i : r(i, c))) var c = i,
          f = o;
      }
      return f;
    }
    function r(n, t, r) {
      var e;
      return r(n, function (n, r, u) {
        return t(n, r, u) ? (e = n, false) : void 0;
      }), e;
    }
    function e(n, t, r, e, u) {
      return u(n, function (n, u, o) {
        r = e ? (e = false, n) : t(r, n, u, o);
      }), r;
    }
    function u(n, t) {
      return O(t, function (t) {
        return n[t];
      });
    }
    function o(n) {
      return n && n.Object === Object ? n : null;
    }
    function i(n) {
      return vn[n];
    }
    function c(n) {
      var t = false;
      if (null != n && typeof n.toString != "function") try {
        t = !!(n + "");
      } catch (r) {}
      return t;
    }
    function f(n, t) {
      return n = typeof n == "number" || hn.test(n) ? +n : -1, n > -1 && 0 == n % 1 && (null == t ? 9007199254740991 : t) > n;
    }
    function a(n) {
      if (Y(n) && !Pn(n)) {
        if (n instanceof l) return n;
        if (En.call(n, "__wrapped__")) {
          var t = new l(n.__wrapped__, n.__chain__);
          return t.__actions__ = N(n.__actions__), t;
        }
      }
      return new l(n);
    }
    function l(n, t) {
      this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t;
    }
    function p(n, t, r, e) {
      var u;
      return (u = n === an) || (u = xn[r], u = (n === u || n !== n && u !== u) && !En.call(e, r)), u ? t : n;
    }
    function s(n) {
      return X(n) ? Fn(n) : {};
    }
    function h(n, t, r) {
      if (typeof n != "function") throw new TypeError("Expected a function");
      return setTimeout(function () {
        n.apply(an, r);
      }, t);
    }
    function v(n, t) {
      var r = true;
      return $n(n, function (n, e, u) {
        return r = !!t(n, e, u);
      }), r;
    }
    function y(n, t) {
      var r = [];
      return $n(n, function (n, e, u) {
        t(n, e, u) && r.push(n);
      }), r;
    }
    function _(t, r, e, u) {
      u || (u = []);
      for (var o = -1, i = t.length; ++o < i;) {
        var c = t[o];
        r > 0 && Y(c) && L(c) && (e || Pn(c) || K(c)) ? r > 1 ? _(c, r - 1, e, u) : n(u, c) : e || (u[u.length] = c);
      }
      return u;
    }
    function g(n, t) {
      return n && qn(n, t, en);
    }
    function b(n, t) {
      return y(t, function (t) {
        return Q(n[t]);
      });
    }
    function j(n, t, r, e, u) {
      return n === t ? true : null == n || null == t || !X(n) && !Y(t) ? n !== n && t !== t : m(n, t, j, r, e, u);
    }
    function m(n, t, r, e, u, o) {
      var i = Pn(n),
        f = Pn(t),
        a = "[object Array]",
        l = "[object Array]";
      i || (a = kn.call(n), "[object Arguments]" == a && (a = "[object Object]")), f || (l = kn.call(t), "[object Arguments]" == l && (l = "[object Object]"));
      var p = "[object Object]" == a && !c(n),
        f = "[object Object]" == l && !c(t);
      return !(l = a == l) || i || p ? 2 & u || (a = p && En.call(n, "__wrapped__"), f = f && En.call(t, "__wrapped__"), !a && !f) ? l ? (o || (o = []), (a = J(o, function (t) {
        return t[0] === n;
      })) && a[1] ? a[1] == t : (o.push([n, t]), t = (i ? I : q)(n, t, r, e, u, o), o.pop(), t)) : false : r(a ? n.value() : n, f ? t.value() : t, e, u, o) : $(n, t, a);
    }
    function d(n) {
      var t = _typeof(n);
      return "function" == t ? n : null == n ? cn : ("object" == t ? x : A)(n);
    }
    function w(n) {
      n = null == n ? n : Object(n);
      var t,
        r = [];
      for (t in n) r.push(t);
      return r;
    }
    function O(n, t) {
      var r = -1,
        e = L(n) ? Array(n.length) : [];
      return $n(n, function (n, u, o) {
        e[++r] = t(n, u, o);
      }), e;
    }
    function x(n) {
      var t = en(n);
      return function (r) {
        var e = t.length;
        if (null == r) return !e;
        for (r = Object(r); e--;) {
          var u = t[e];
          if (!(u in r && j(n[u], r[u], an, 3))) return false;
        }
        return true;
      };
    }
    function E(n, t) {
      return n = Object(n), P(t, function (t, r) {
        return r in n && (t[r] = n[r]), t;
      }, {});
    }
    function A(n) {
      return function (t) {
        return null == t ? an : t[n];
      };
    }
    function k(n, t, r) {
      var e = -1,
        u = n.length;
      for (0 > t && (t = -t > u ? 0 : u + t), r = r > u ? u : r, 0 > r && (r += u), u = t > r ? 0 : r - t >>> 0, t >>>= 0, r = Array(u); ++e < u;) r[e] = n[e + t];
      return r;
    }
    function N(n) {
      return k(n, 0, n.length);
    }
    function S(n, t) {
      var r;
      return $n(n, function (n, e, u) {
        return r = t(n, e, u), !r;
      }), !!r;
    }
    function T(t, r) {
      return P(r, function (t, r) {
        return r.func.apply(r.thisArg, n([t], r.args));
      }, t);
    }
    function F(n, t, r, e) {
      r || (r = {});
      for (var u = -1, o = t.length; ++u < o;) {
        var i = t[u],
          c = e ? e(r[i], n[i], i, r, n) : n[i],
          f = r,
          a = f[i];
        En.call(f, i) && (a === c || a !== a && c !== c) && (c !== an || i in f) || (f[i] = c);
      }
      return r;
    }
    function R(n) {
      return V(function (t, r) {
        var e = -1,
          u = r.length,
          o = u > 1 ? r[u - 1] : an,
          o = typeof o == "function" ? (u--, o) : an;
        for (t = Object(t); ++e < u;) {
          var i = r[e];
          i && n(t, i, e, o);
        }
        return t;
      });
    }
    function B(n) {
      return function () {
        var t = arguments,
          r = s(n.prototype),
          t = n.apply(r, t);
        return X(t) ? t : r;
      };
    }
    function D(n, t, r) {
      function e() {
        for (var o = -1, i = arguments.length, c = -1, f = r.length, a = Array(f + i), l = this && this !== wn && this instanceof e ? u : n; ++c < f;) a[c] = r[c];
        for (; i--;) a[c++] = arguments[++o];
        return l.apply(t, a);
      }
      if (typeof n != "function") throw new TypeError("Expected a function");
      var u = B(n);
      return e;
    }
    function I(n, t, r, e, u, o) {
      var i = -1,
        c = 1 & u,
        f = n.length,
        a = t.length;
      if (f != a && !(2 & u && a > f)) return false;
      for (a = true; ++i < f;) {
        var l = n[i],
          p = t[i];
        if (void 0 !== an) {
          a = false;
          break;
        }
        if (c) {
          if (!S(t, function (n) {
            return l === n || r(l, n, e, u, o);
          })) {
            a = false;
            break;
          }
        } else if (l !== p && !r(l, p, e, u, o)) {
          a = false;
          break;
        }
      }
      return a;
    }
    function $(n, t, r) {
      switch (r) {
        case "[object Boolean]":
        case "[object Date]":
          return +n == +t;
        case "[object Error]":
          return n.name == t.name && n.message == t.message;
        case "[object Number]":
          return n != +n ? t != +t : n == +t;
        case "[object RegExp]":
        case "[object String]":
          return n == t + "";
      }
      return false;
    }
    function q(n, t, r, e, u, o) {
      var i = 2 & u,
        c = en(n),
        f = c.length,
        a = en(t).length;
      if (f != a && !i) return false;
      for (var l = f; l--;) {
        var p = c[l];
        if (!(i ? p in t : En.call(t, p))) return false;
      }
      for (a = true; ++l < f;) {
        var p = c[l],
          s = n[p],
          h = t[p];
        if (void 0 !== an || s !== h && !r(s, h, e, u, o)) {
          a = false;
          break;
        }
        i || (i = "constructor" == p);
      }
      return a && !i && (r = n.constructor, e = t.constructor, r != e && "constructor" in n && "constructor" in t && !(typeof r == "function" && r instanceof r && typeof e == "function" && e instanceof e) && (a = false)), a;
    }
    function z(n) {
      var t = n ? n.length : an;
      if (W(t) && (Pn(n) || nn(n) || K(n))) {
        n = String;
        for (var r = -1, e = Array(t); ++r < t;) e[r] = n(r);
        t = e;
      } else t = null;
      return t;
    }
    function C(n) {
      var t = n && n.constructor,
        t = Q(t) && t.prototype || xn;
      return n === t;
    }
    function G(n) {
      return n ? n[0] : an;
    }
    function J(n, t) {
      return r(n, d(t), $n);
    }
    function M(n, t) {
      return $n(n, typeof t == "function" ? t : cn);
    }
    function P(n, t, r) {
      return e(n, d(t), r, 3 > arguments.length, $n);
    }
    function U(n, t) {
      var r;
      if (typeof t != "function") throw new TypeError("Expected a function");
      return n = Un(n), function () {
        return 0 < --n && (r = t.apply(this, arguments)), 1 >= n && (t = an), r;
      };
    }
    function V(n) {
      var t;
      if (typeof n != "function") throw new TypeError("Expected a function");
      return t = In(t === an ? n.length - 1 : Un(t), 0), function () {
        for (var r = arguments, e = -1, u = In(r.length - t, 0), o = Array(u); ++e < u;) o[e] = r[t + e];
        for (u = Array(t + 1), e = -1; ++e < t;) u[e] = r[e];
        return u[t] = o, n.apply(this, u);
      };
    }
    function H(n, t) {
      return n > t;
    }
    function K(n) {
      return Y(n) && L(n) && En.call(n, "callee") && (!Rn.call(n, "callee") || "[object Arguments]" == kn.call(n));
    }
    function L(n) {
      return null != n && !(typeof n == "function" && Q(n)) && W(zn(n));
    }
    function Q(n) {
      return n = X(n) ? kn.call(n) : "", "[object Function]" == n || "[object GeneratorFunction]" == n;
    }
    function W(n) {
      return typeof n == "number" && n > -1 && 0 == n % 1 && 9007199254740991 >= n;
    }
    function X(n) {
      var t = _typeof(n);
      return !!n && ("object" == t || "function" == t);
    }
    function Y(n) {
      return !!n && _typeof(n) == "object";
    }
    function Z(n) {
      return typeof n == "number" || Y(n) && "[object Number]" == kn.call(n);
    }
    function nn(n) {
      return typeof n == "string" || !Pn(n) && Y(n) && "[object String]" == kn.call(n);
    }
    function tn(n, t) {
      return t > n;
    }
    function rn(n) {
      return typeof n == "string" ? n : null == n ? "" : n + "";
    }
    function en(n) {
      var t = C(n);
      if (!t && !L(n)) return Dn(Object(n));
      var r,
        e = z(n),
        u = !!e,
        e = e || [],
        o = e.length;
      for (r in n) !En.call(n, r) || u && ("length" == r || f(r, o)) || t && "constructor" == r || e.push(r);
      return e;
    }
    function un(n) {
      for (var t = -1, r = C(n), e = w(n), u = e.length, o = z(n), i = !!o, o = o || [], c = o.length; ++t < u;) {
        var a = e[t];
        i && ("length" == a || f(a, c)) || "constructor" == a && (r || !En.call(n, a)) || o.push(a);
      }
      return o;
    }
    function on(n) {
      return n ? u(n, en(n)) : [];
    }
    function cn(n) {
      return n;
    }
    function fn(t, r, e) {
      var u = en(r),
        o = b(r, u);
      null != e || X(r) && (o.length || !u.length) || (e = r, r = t, t = this, o = b(r, en(r)));
      var i = X(e) && "chain" in e ? e.chain : true,
        c = Q(t);
      return $n(o, function (e) {
        var u = r[e];
        t[e] = u, c && (t.prototype[e] = function () {
          var r = this.__chain__;
          if (i || r) {
            var e = t(this.__wrapped__);
            return (e.__actions__ = N(this.__actions__)).push({
              func: u,
              args: arguments,
              thisArg: t
            }), e.__chain__ = r, e;
          }
          return u.apply(t, n([this.value()], arguments));
        });
      }), t;
    }
    var an,
      ln = 1 / 0,
      pn = /[&<>"'`]/g,
      sn = RegExp(pn.source),
      hn = /^(?:0|[1-9]\d*)$/,
      vn = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "`": "&#96;"
      },
      yn = {
        "function": true,
        object: true
      },
      _n = yn[typeof exports === "undefined" ? "undefined" : _typeof(exports)] && exports && !exports.nodeType ? exports : an,
      gn = yn[typeof module === "undefined" ? "undefined" : _typeof(module)] && module && !module.nodeType ? module : an,
      bn = gn && gn.exports === _n ? _n : an,
      jn = o(yn[typeof self === "undefined" ? "undefined" : _typeof(self)] && self),
      mn = o(yn[typeof window === "undefined" ? "undefined" : _typeof(window)] && window),
      dn = o(yn[_typeof(this)] && this),
      wn = o(_n && gn && (typeof global === "undefined" ? "undefined" : _typeof(global)) == "object" && global) || mn !== (dn && dn.window) && mn || jn || dn || Function("return this")(),
      On = Array.prototype,
      xn = Object.prototype,
      En = xn.hasOwnProperty,
      An = 0,
      kn = xn.toString,
      Nn = wn._,
      Sn = wn.Reflect,
      Tn = Sn ? Sn.f : an,
      Fn = Object.create,
      Rn = xn.propertyIsEnumerable,
      Bn = wn.isFinite,
      Dn = Object.keys,
      In = Math.max,
      $n = function (n, t) {
        return function (r, e) {
          if (null == r) return r;
          if (!L(r)) return n(r, e);
          for (var u = r.length, o = t ? u : -1, i = Object(r); (t ? o-- : ++o < u) && false !== e(i[o], o, i););
          return r;
        };
      }(g),
      qn = function (n) {
        return function (t, r, e) {
          var u = -1,
            o = Object(t);
          e = e(t);
          for (var i = e.length; i--;) {
            var c = e[n ? i : ++u];
            if (false === r(o[c], c, o)) break;
          }
          return t;
        };
      }();
    Tn && !Rn.call({
      valueOf: 1
    }, "valueOf") && (w = function w(n) {
      n = Tn(n);
      for (var t, r = []; !(t = n.next()).done;) r.push(t.value);
      return r;
    });
    var zn = A("length"),
      Cn = V(function (t, r) {
        return Pn(t) || (t = null == t ? [] : [Object(t)]), _(r, 1), n(N(t), on);
      }),
      Gn = V(function (n, t, r) {
        return D(n, t, r);
      }),
      Jn = V(function (n, t) {
        return h(n, 1, t);
      }),
      Mn = V(function (n, t, r) {
        return h(n, Vn(t) || 0, r);
      }),
      Pn = Array.isArray,
      Un = Number,
      Vn = Number,
      Hn = R(function (n, t) {
        F(t, en(t), n);
      }),
      Kn = R(function (n, t) {
        F(t, un(t), n);
      }),
      Ln = R(function (n, t, r, e) {
        F(t, un(t), n, e);
      }),
      Qn = V(function (n) {
        return n.push(an, p), Ln.apply(an, n);
      }),
      Wn = V(function (n, t) {
        return null == n ? {} : E(n, _(t, 1));
      }),
      Xn = d;
    l.prototype = s(a.prototype), l.prototype.constructor = l, a.assignIn = Kn, a.before = U, a.bind = Gn, a.chain = function (n) {
      return n = a(n), n.__chain__ = true, n;
    }, a.compact = function (n) {
      return y(n, Boolean);
    }, a.concat = Cn, a.create = function (n, t) {
      var r = s(n);
      return t ? Hn(r, t) : r;
    }, a.defaults = Qn, a.defer = Jn, a.delay = Mn, a.filter = function (n, t) {
      return y(n, d(t));
    }, a.flatten = function (n) {
      return n && n.length ? _(n, 1) : [];
    }, a.flattenDeep = function (n) {
      return n && n.length ? _(n, ln) : [];
    }, a.iteratee = Xn, a.keys = en, a.map = function (n, t) {
      return O(n, d(t));
    }, a.matches = function (n) {
      return x(Hn({}, n));
    }, a.mixin = fn, a.negate = function (n) {
      if (typeof n != "function") throw new TypeError("Expected a function");
      return function () {
        return !n.apply(this, arguments);
      };
    }, a.once = function (n) {
      return U(2, n);
    }, a.pick = Wn, a.slice = function (n, t, r) {
      var e = n ? n.length : 0;
      return r = r === an ? e : +r, e ? k(n, null == t ? 0 : +t, r) : [];
    }, a.sortBy = function (n, t) {
      var r = 0;
      return t = d(t), O(O(n, function (n, e, u) {
        return {
          c: n,
          b: r++,
          a: t(n, e, u)
        };
      }).sort(function (n, t) {
        var r;
        n: {
          r = n.a;
          var e = t.a;
          if (r !== e) {
            var u = null === r,
              o = r === an,
              i = r === r,
              c = null === e,
              f = e === an,
              a = e === e;
            if (r > e && !c || !i || u && !f && a || o && a) {
              r = 1;
              break n;
            }
            if (e > r && !u || !a || c && !o && i || f && i) {
              r = -1;
              break n;
            }
          }
          r = 0;
        }
        return r || n.b - t.b;
      }), A("c"));
    }, a.tap = function (n, t) {
      return t(n), n;
    }, a.thru = function (n, t) {
      return t(n);
    }, a.toArray = function (n) {
      return L(n) ? n.length ? N(n) : [] : on(n);
    }, a.values = on, a.extend = Kn, fn(a, a), a.clone = function (n) {
      return X(n) ? Pn(n) ? N(n) : F(n, en(n)) : n;
    }, a.escape = function (n) {
      return (n = rn(n)) && sn.test(n) ? n.replace(pn, i) : n;
    }, a.every = function (n, t, r) {
      return t = r ? an : t, v(n, d(t));
    }, a.find = J, a.forEach = M, a.has = function (n, t) {
      return null != n && En.call(n, t);
    }, a.head = G, a.identity = cn, a.indexOf = function (n, t, r) {
      var e = n ? n.length : 0;
      r = typeof r == "number" ? 0 > r ? In(e + r, 0) : r : 0, r = (r || 0) - 1;
      for (var u = t === t; ++r < e;) {
        var o = n[r];
        if (u ? o === t : o !== o) return r;
      }
      return -1;
    }, a.isArguments = K, a.isArray = Pn, a.isBoolean = function (n) {
      return true === n || false === n || Y(n) && "[object Boolean]" == kn.call(n);
    }, a.isDate = function (n) {
      return Y(n) && "[object Date]" == kn.call(n);
    }, a.isEmpty = function (n) {
      if (L(n) && (Pn(n) || nn(n) || Q(n.splice) || K(n))) return !n.length;
      for (var t in n) if (En.call(n, t)) return false;
      return true;
    }, a.isEqual = function (n, t) {
      return j(n, t);
    }, a.isFinite = function (n) {
      return typeof n == "number" && Bn(n);
    }, a.isFunction = Q, a.isNaN = function (n) {
      return Z(n) && n != +n;
    }, a.isNull = function (n) {
      return null === n;
    }, a.isNumber = Z, a.isObject = X, a.isRegExp = function (n) {
      return X(n) && "[object RegExp]" == kn.call(n);
    }, a.isString = nn, a.isUndefined = function (n) {
      return n === an;
    }, a.last = function (n) {
      var t = n ? n.length : 0;
      return t ? n[t - 1] : an;
    }, a.max = function (n) {
      return n && n.length ? t(n, cn, H) : an;
    }, a.min = function (n) {
      return n && n.length ? t(n, cn, tn) : an;
    }, a.noConflict = function () {
      return wn._ === this && (wn._ = Nn), this;
    }, a.noop = function () {}, a.reduce = P, a.result = function (n, t, r) {
      return t = null == n ? an : n[t], t === an && (t = r), Q(t) ? t.call(n) : t;
    }, a.size = function (n) {
      return null == n ? 0 : (n = L(n) ? n : en(n), n.length);
    }, a.some = function (n, t, r) {
      return t = r ? an : t, S(n, d(t));
    }, a.uniqueId = function (n) {
      var t = ++An;
      return rn(n) + t;
    }, a.each = M, a.first = G, fn(a, function () {
      var n = {};
      return g(a, function (t, r) {
        En.call(a.prototype, r) || (n[r] = t);
      }), n;
    }(), {
      chain: false
    }), a.VERSION = "4.5.1", $n("pop join replace reverse split push shift sort splice unshift".split(" "), function (n) {
      var t = (/^(?:replace|split)$/.test(n) ? String.prototype : On)[n],
        r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru",
        e = /^(?:pop|join|replace|shift)$/.test(n);
      a.prototype[n] = function () {
        var n = arguments;
        return e && !this.__chain__ ? t.apply(this.value(), n) : this[r](function (r) {
          return t.apply(r, n);
        });
      };
    }), a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = function () {
      return T(this.__wrapped__, this.__actions__);
    }, (mn || jn || {})._ = a, typeof define == "function" && _typeof(define.amd) == "object" && define.amd ? define(function () {
      return a;
    }) : _n && gn ? (bn && ((gn.exports = a)._ = a), _n._ = a) : wn._ = a;
  }).call(this);
})();
(function vendorPhotoSwipe() {
  /*! PhotoSwipe - v4.1.3 - 2019-01-08
  * http://photoswipe.com
  * Copyright (c) 2019 Dmitry Semenov; */
  !function (a, b) {
    "function" == typeof define && define.amd ? define(b) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b() : a.PhotoSwipe = b();
  }(this, function () {
    "use strict";

    var a = function a(_a3, b, c, d) {
      var e = {
        features: null,
        bind: function bind(a, b, c, d) {
          var e = (d ? "remove" : "add") + "EventListener";
          b = b.split(" ");
          for (var f = 0; f < b.length; f++) b[f] && a[e](b[f], c, !1);
        },
        isArray: function isArray(a) {
          return a instanceof Array;
        },
        createEl: function createEl(a, b) {
          var c = document.createElement(b || "div");
          return a && (c.className = a), c;
        },
        getScrollY: function getScrollY() {
          var a = window.pageYOffset;
          return void 0 !== a ? a : document.documentElement.scrollTop;
        },
        unbind: function unbind(a, b, c) {
          e.bind(a, b, c, !0);
        },
        removeClass: function removeClass(a, b) {
          var c = new RegExp("(\\s|^)" + b + "(\\s|$)");
          a.className = a.className.replace(c, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
        },
        addClass: function addClass(a, b) {
          e.hasClass(a, b) || (a.className += (a.className ? " " : "") + b);
        },
        hasClass: function hasClass(a, b) {
          return a.className && new RegExp("(^|\\s)" + b + "(\\s|$)").test(a.className);
        },
        getChildByClass: function getChildByClass(a, b) {
          for (var c = a.firstChild; c;) {
            if (e.hasClass(c, b)) return c;
            c = c.nextSibling;
          }
        },
        arraySearch: function arraySearch(a, b, c) {
          for (var d = a.length; d--;) if (a[d][c] === b) return d;
          return -1;
        },
        extend: function extend(a, b, c) {
          for (var d in b) if (b.hasOwnProperty(d)) {
            if (c && a.hasOwnProperty(d)) continue;
            a[d] = b[d];
          }
        },
        easing: {
          sine: {
            out: function out(a) {
              return Math.sin(a * (Math.PI / 2));
            },
            inOut: function inOut(a) {
              return -(Math.cos(Math.PI * a) - 1) / 2;
            }
          },
          cubic: {
            out: function out(a) {
              return --a * a * a + 1;
            }
          }
        },
        detectFeatures: function detectFeatures() {
          if (e.features) return e.features;
          var a = e.createEl(),
            b = a.style,
            c = "",
            d = {};
          if (d.oldIE = document.all && !document.addEventListener, d.touch = "ontouchstart" in window, window.requestAnimationFrame && (d.raf = window.requestAnimationFrame, d.caf = window.cancelAnimationFrame), d.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !d.pointerEvent) {
            var f = navigator.userAgent;
            if (/iP(hone|od)/.test(navigator.platform)) {
              var g = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
              g && g.length > 0 && (g = parseInt(g[1], 10), g >= 1 && g < 8 && (d.isOldIOSPhone = !0));
            }
            var h = f.match(/Android\s([0-9\.]*)/),
              i = h ? h[1] : 0;
            i = parseFloat(i), i >= 1 && (i < 4.4 && (d.isOldAndroid = !0), d.androidVersion = i), d.isMobileOpera = /opera mini|opera mobi/i.test(f);
          }
          for (var j, k, l = ["transform", "perspective", "animationName"], m = ["", "webkit", "Moz", "ms", "O"], n = 0; n < 4; n++) {
            c = m[n];
            for (var o = 0; o < 3; o++) j = l[o], k = c + (c ? j.charAt(0).toUpperCase() + j.slice(1) : j), !d[j] && k in b && (d[j] = k);
            c && !d.raf && (c = c.toLowerCase(), d.raf = window[c + "RequestAnimationFrame"], d.raf && (d.caf = window[c + "CancelAnimationFrame"] || window[c + "CancelRequestAnimationFrame"]));
          }
          if (!d.raf) {
            var p = 0;
            d.raf = function (a) {
              var b = new Date().getTime(),
                c = Math.max(0, 16 - (b - p)),
                d = window.setTimeout(function () {
                  a(b + c);
                }, c);
              return p = b + c, d;
            }, d.caf = function (a) {
              clearTimeout(a);
            };
          }
          return d.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, e.features = d, d;
        }
      };
      e.detectFeatures(), e.features.oldIE && (e.bind = function (a, b, c, d) {
        b = b.split(" ");
        for (var e, f = (d ? "detach" : "attach") + "Event", g = function g() {
            c.handleEvent.call(c);
          }, h = 0; h < b.length; h++) if (e = b[h]) if ("object" == _typeof(c) && c.handleEvent) {
          if (d) {
            if (!c["oldIE" + e]) return !1;
          } else c["oldIE" + e] = g;
          a[f]("on" + e, c["oldIE" + e]);
        } else a[f]("on" + e, c);
      });
      var f = this,
        g = 25,
        h = 3,
        i = {
          allowPanToNext: !0,
          spacing: .12,
          bgOpacity: 1,
          mouseUsed: !1,
          loop: !0,
          pinchToClose: !0,
          closeOnScroll: !0,
          closeOnVerticalDrag: !0,
          verticalDragRange: .75,
          hideAnimationDuration: 333,
          showAnimationDuration: 333,
          showHideOpacity: !1,
          focus: !0,
          escKey: !0,
          arrowKeys: !0,
          mainScrollEndFriction: .35,
          panEndFriction: .35,
          isClickableElement: function isClickableElement(a) {
            return "A" === a.tagName;
          },
          getDoubleTapZoom: function getDoubleTapZoom(a, b) {
            return a ? 1 : b.initialZoomLevel < .7 ? 1 : 1.33;
          },
          maxSpreadZoom: 1.33,
          modal: !0,
          scaleMode: "fit"
        };
      e.extend(i, d);
      var j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t,
        u,
        v,
        w,
        x,
        y,
        z,
        A,
        B,
        C,
        D,
        E,
        F,
        G,
        H,
        I,
        J,
        K,
        L,
        M,
        N,
        O,
        P,
        Q,
        R,
        S,
        T,
        U,
        V,
        W,
        X,
        Y,
        Z,
        $,
        _,
        aa,
        ba,
        ca,
        da,
        ea,
        fa,
        ga,
        ha,
        ia,
        ja,
        ka,
        la,
        ma = function ma() {
          return {
            x: 0,
            y: 0
          };
        },
        na = ma(),
        oa = ma(),
        pa = ma(),
        qa = {},
        ra = 0,
        sa = {},
        ta = ma(),
        ua = 0,
        va = !0,
        wa = [],
        xa = {},
        ya = !1,
        za = function za(a, b) {
          e.extend(f, b.publicMethods), wa.push(a);
        },
        Aa = function Aa(a) {
          var b = ac();
          return a > b - 1 ? a - b : a < 0 ? b + a : a;
        },
        Ba = {},
        Ca = function Ca(a, b) {
          return Ba[a] || (Ba[a] = []), Ba[a].push(b);
        },
        Da = function Da(a) {
          var b = Ba[a];
          if (b) {
            var c = Array.prototype.slice.call(arguments);
            c.shift();
            for (var d = 0; d < b.length; d++) b[d].apply(f, c);
          }
        },
        Ea = function Ea() {
          return new Date().getTime();
        },
        Fa = function Fa(a) {
          ja = a, f.bg.style.opacity = a * i.bgOpacity;
        },
        Ga = function Ga(a, b, c, d, e) {
          (!ya || e && e !== f.currItem) && (d /= e ? e.fitRatio : f.currItem.fitRatio), a[E] = u + b + "px, " + c + "px" + v + " scale(" + d + ")";
        },
        Ha = function Ha(a) {
          ea && (a && (s > f.currItem.fitRatio ? ya || (mc(f.currItem, !1, !0), ya = !0) : ya && (mc(f.currItem), ya = !1)), Ga(ea, pa.x, pa.y, s));
        },
        Ia = function Ia(a) {
          a.container && Ga(a.container.style, a.initialPosition.x, a.initialPosition.y, a.initialZoomLevel, a);
        },
        Ja = function Ja(a, b) {
          b[E] = u + a + "px, 0px" + v;
        },
        Ka = function Ka(a, b) {
          if (!i.loop && b) {
            var c = m + (ta.x * ra - a) / ta.x,
              d = Math.round(a - tb.x);
            (c < 0 && d > 0 || c >= ac() - 1 && d < 0) && (a = tb.x + d * i.mainScrollEndFriction);
          }
          tb.x = a, Ja(a, n);
        },
        La = function La(a, b) {
          var c = ub[a] - sa[a];
          return oa[a] + na[a] + c - c * (b / t);
        },
        Ma = function Ma(a, b) {
          a.x = b.x, a.y = b.y, b.id && (a.id = b.id);
        },
        Na = function Na(a) {
          a.x = Math.round(a.x), a.y = Math.round(a.y);
        },
        Oa = null,
        _Pa = function Pa() {
          Oa && (e.unbind(document, "mousemove", _Pa), e.addClass(_a3, "pswp--has_mouse"), i.mouseUsed = !0, Da("mouseUsed")), Oa = setTimeout(function () {
            Oa = null;
          }, 100);
        },
        Qa = function Qa() {
          e.bind(document, "keydown", f), N.transform && e.bind(f.scrollWrap, "click", f), i.mouseUsed || e.bind(document, "mousemove", _Pa), e.bind(window, "resize scroll orientationchange", f), Da("bindEvents");
        },
        Ra = function Ra() {
          e.unbind(window, "resize scroll orientationchange", f), e.unbind(window, "scroll", r.scroll), e.unbind(document, "keydown", f), e.unbind(document, "mousemove", _Pa), N.transform && e.unbind(f.scrollWrap, "click", f), V && e.unbind(window, p, f), clearTimeout(O), Da("unbindEvents");
        },
        Sa = function Sa(a, b) {
          var c = ic(f.currItem, qa, a);
          return b && (da = c), c;
        },
        Ta = function Ta(a) {
          return a || (a = f.currItem), a.initialZoomLevel;
        },
        Ua = function Ua(a) {
          return a || (a = f.currItem), a.w > 0 ? i.maxSpreadZoom : 1;
        },
        Va = function Va(a, b, c, d) {
          return d === f.currItem.initialZoomLevel ? (c[a] = f.currItem.initialPosition[a], !0) : (c[a] = La(a, d), c[a] > b.min[a] ? (c[a] = b.min[a], !0) : c[a] < b.max[a] && (c[a] = b.max[a], !0));
        },
        Wa = function Wa() {
          if (E) {
            var b = N.perspective && !G;
            return u = "translate" + (b ? "3d(" : "("), void (v = N.perspective ? ", 0px)" : ")");
          }
          E = "left", e.addClass(_a3, "pswp--ie"), Ja = function Ja(a, b) {
            b.left = a + "px";
          }, Ia = function Ia(a) {
            var b = a.fitRatio > 1 ? 1 : a.fitRatio,
              c = a.container.style,
              d = b * a.w,
              e = b * a.h;
            c.width = d + "px", c.height = e + "px", c.left = a.initialPosition.x + "px", c.top = a.initialPosition.y + "px";
          }, Ha = function Ha() {
            if (ea) {
              var a = ea,
                b = f.currItem,
                c = b.fitRatio > 1 ? 1 : b.fitRatio,
                d = c * b.w,
                e = c * b.h;
              a.width = d + "px", a.height = e + "px", a.left = pa.x + "px", a.top = pa.y + "px";
            }
          };
        },
        Xa = function Xa(a) {
          var b = "";
          i.escKey && 27 === a.keyCode ? b = "close" : i.arrowKeys && (37 === a.keyCode ? b = "prev" : 39 === a.keyCode && (b = "next")), b && (a.ctrlKey || a.altKey || a.shiftKey || a.metaKey || (a.preventDefault ? a.preventDefault() : a.returnValue = !1, f[b]()));
        },
        Ya = function Ya(a) {
          a && (Y || X || fa || T) && (a.preventDefault(), a.stopPropagation());
        },
        Za = function Za() {
          f.setScrollOffset(0, e.getScrollY());
        },
        $a = {},
        _a = 0,
        ab = function ab(a) {
          $a[a] && ($a[a].raf && I($a[a].raf), _a--, delete $a[a]);
        },
        bb = function bb(a) {
          $a[a] && ab(a), $a[a] || (_a++, $a[a] = {});
        },
        cb = function cb() {
          for (var a in $a) $a.hasOwnProperty(a) && ab(a);
        },
        db = function db(a, b, c, d, e, f, g) {
          var h,
            i = Ea();
          bb(a);
          var _j2 = function j() {
            if ($a[a]) {
              if (h = Ea() - i, h >= d) return ab(a), f(c), void (g && g());
              f((c - b) * e(h / d) + b), $a[a].raf = H(_j2);
            }
          };
          _j2();
        },
        eb = {
          shout: Da,
          listen: Ca,
          viewportSize: qa,
          options: i,
          isMainScrollAnimating: function isMainScrollAnimating() {
            return fa;
          },
          getZoomLevel: function getZoomLevel() {
            return s;
          },
          getCurrentIndex: function getCurrentIndex() {
            return m;
          },
          isDragging: function isDragging() {
            return V;
          },
          isZooming: function isZooming() {
            return aa;
          },
          setScrollOffset: function setScrollOffset(a, b) {
            sa.x = a, M = sa.y = b, Da("updateScrollOffset", sa);
          },
          applyZoomPan: function applyZoomPan(a, b, c, d) {
            pa.x = b, pa.y = c, s = a, Ha(d);
          },
          init: function init() {
            if (!j && !k) {
              var c;
              f.framework = e, f.template = _a3, f.bg = e.getChildByClass(_a3, "pswp__bg"), J = _a3.className, j = !0, N = e.detectFeatures(), H = N.raf, I = N.caf, E = N.transform, L = N.oldIE, f.scrollWrap = e.getChildByClass(_a3, "pswp__scroll-wrap"), f.container = e.getChildByClass(f.scrollWrap, "pswp__container"), n = f.container.style, f.itemHolders = y = [{
                el: f.container.children[0],
                wrap: 0,
                index: -1
              }, {
                el: f.container.children[1],
                wrap: 0,
                index: -1
              }, {
                el: f.container.children[2],
                wrap: 0,
                index: -1
              }], y[0].el.style.display = y[2].el.style.display = "none", Wa(), r = {
                resize: f.updateSize,
                orientationchange: function orientationchange() {
                  clearTimeout(O), O = setTimeout(function () {
                    qa.x !== f.scrollWrap.clientWidth && f.updateSize();
                  }, 500);
                },
                scroll: Za,
                keydown: Xa,
                click: Ya
              };
              var d = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
              for (N.animationName && N.transform && !d || (i.showAnimationDuration = i.hideAnimationDuration = 0), c = 0; c < wa.length; c++) f["init" + wa[c]]();
              if (b) {
                var g = f.ui = new b(f, e);
                g.init();
              }
              Da("firstUpdate"), m = m || i.index || 0, (isNaN(m) || m < 0 || m >= ac()) && (m = 0), f.currItem = _b(m), (N.isOldIOSPhone || N.isOldAndroid) && (va = !1), _a3.setAttribute("aria-hidden", "false"), i.modal && (va ? _a3.style.position = "fixed" : (_a3.style.position = "absolute", _a3.style.top = e.getScrollY() + "px")), void 0 === M && (Da("initialLayout"), M = K = e.getScrollY());
              var l = "pswp--open ";
              for (i.mainClass && (l += i.mainClass + " "), i.showHideOpacity && (l += "pswp--animate_opacity "), l += G ? "pswp--touch" : "pswp--notouch", l += N.animationName ? " pswp--css_animation" : "", l += N.svg ? " pswp--svg" : "", e.addClass(_a3, l), f.updateSize(), o = -1, ua = null, c = 0; c < h; c++) Ja((c + o) * ta.x, y[c].el.style);
              L || e.bind(f.scrollWrap, q, f), Ca("initialZoomInEnd", function () {
                f.setContent(y[0], m - 1), f.setContent(y[2], m + 1), y[0].el.style.display = y[2].el.style.display = "block", i.focus && _a3.focus(), Qa();
              }), f.setContent(y[1], m), f.updateCurrItem(), Da("afterInit"), va || (w = setInterval(function () {
                _a || V || aa || s !== f.currItem.initialZoomLevel || f.updateSize();
              }, 1e3)), e.addClass(_a3, "pswp--visible");
            }
          },
          close: function close() {
            j && (j = !1, k = !0, Da("close"), Ra(), cc(f.currItem, null, !0, f.destroy));
          },
          destroy: function destroy() {
            Da("destroy"), Xb && clearTimeout(Xb), _a3.setAttribute("aria-hidden", "true"), _a3.className = J, w && clearInterval(w), e.unbind(f.scrollWrap, q, f), e.unbind(window, "scroll", f), zb(), cb(), Ba = null;
          },
          panTo: function panTo(a, b, c) {
            c || (a > da.min.x ? a = da.min.x : a < da.max.x && (a = da.max.x), b > da.min.y ? b = da.min.y : b < da.max.y && (b = da.max.y)), pa.x = a, pa.y = b, Ha();
          },
          handleEvent: function handleEvent(a) {
            a = a || window.event, r[a.type] && r[a.type](a);
          },
          goTo: function goTo(a) {
            a = Aa(a);
            var b = a - m;
            ua = b, m = a, f.currItem = _b(m), ra -= b, Ka(ta.x * ra), cb(), fa = !1, f.updateCurrItem();
          },
          next: function next() {
            f.goTo(m + 1);
          },
          prev: function prev() {
            f.goTo(m - 1);
          },
          updateCurrZoomItem: function updateCurrZoomItem(a) {
            if (a && Da("beforeChange", 0), y[1].el.children.length) {
              var b = y[1].el.children[0];
              ea = e.hasClass(b, "pswp__zoom-wrap") ? b.style : null;
            } else ea = null;
            da = f.currItem.bounds, t = s = f.currItem.initialZoomLevel, pa.x = da.center.x, pa.y = da.center.y, a && Da("afterChange");
          },
          invalidateCurrItems: function invalidateCurrItems() {
            x = !0;
            for (var a = 0; a < h; a++) y[a].item && (y[a].item.needsUpdate = !0);
          },
          updateCurrItem: function updateCurrItem(a) {
            if (0 !== ua) {
              var b,
                c = Math.abs(ua);
              if (!(a && c < 2)) {
                f.currItem = _b(m), ya = !1, Da("beforeChange", ua), c >= h && (o += ua + (ua > 0 ? -h : h), c = h);
                for (var d = 0; d < c; d++) ua > 0 ? (b = y.shift(), y[h - 1] = b, o++, Ja((o + 2) * ta.x, b.el.style), f.setContent(b, m - c + d + 1 + 1)) : (b = y.pop(), y.unshift(b), o--, Ja(o * ta.x, b.el.style), f.setContent(b, m + c - d - 1 - 1));
                if (ea && 1 === Math.abs(ua)) {
                  var e = _b(z);
                  e.initialZoomLevel !== s && (ic(e, qa), mc(e), Ia(e));
                }
                ua = 0, f.updateCurrZoomItem(), z = m, Da("afterChange");
              }
            }
          },
          updateSize: function updateSize(b) {
            if (!va && i.modal) {
              var c = e.getScrollY();
              if (M !== c && (_a3.style.top = c + "px", M = c), !b && xa.x === window.innerWidth && xa.y === window.innerHeight) return;
              xa.x = window.innerWidth, xa.y = window.innerHeight, _a3.style.height = xa.y + "px";
            }
            if (qa.x = f.scrollWrap.clientWidth, qa.y = f.scrollWrap.clientHeight, Za(), ta.x = qa.x + Math.round(qa.x * i.spacing), ta.y = qa.y, Ka(ta.x * ra), Da("beforeResize"), void 0 !== o) {
              for (var d, g, j, k = 0; k < h; k++) d = y[k], Ja((k + o) * ta.x, d.el.style), j = m + k - 1, i.loop && ac() > 2 && (j = Aa(j)), g = _b(j), g && (x || g.needsUpdate || !g.bounds) ? (f.cleanSlide(g), f.setContent(d, j), 1 === k && (f.currItem = g, f.updateCurrZoomItem(!0)), g.needsUpdate = !1) : d.index === -1 && j >= 0 && f.setContent(d, j), g && g.container && (ic(g, qa), mc(g), Ia(g));
              x = !1;
            }
            t = s = f.currItem.initialZoomLevel, da = f.currItem.bounds, da && (pa.x = da.center.x, pa.y = da.center.y, Ha(!0)), Da("resize");
          },
          zoomTo: function zoomTo(a, b, c, d, f) {
            b && (t = s, ub.x = Math.abs(b.x) - pa.x, ub.y = Math.abs(b.y) - pa.y, Ma(oa, pa));
            var g = Sa(a, !1),
              h = {};
            Va("x", g, h, a), Va("y", g, h, a);
            var i = s,
              j = {
                x: pa.x,
                y: pa.y
              };
            Na(h);
            var k = function k(b) {
              1 === b ? (s = a, pa.x = h.x, pa.y = h.y) : (s = (a - i) * b + i, pa.x = (h.x - j.x) * b + j.x, pa.y = (h.y - j.y) * b + j.y), f && f(b), Ha(1 === b);
            };
            c ? db("customZoomTo", 0, 1, c, d || e.easing.sine.inOut, k) : k(1);
          }
        },
        fb = 30,
        gb = 10,
        hb = {},
        ib = {},
        jb = {},
        kb = {},
        lb = {},
        mb = [],
        nb = {},
        ob = [],
        pb = {},
        qb = 0,
        rb = ma(),
        sb = 0,
        tb = ma(),
        ub = ma(),
        vb = ma(),
        wb = function wb(a, b) {
          return a.x === b.x && a.y === b.y;
        },
        xb = function xb(a, b) {
          return Math.abs(a.x - b.x) < g && Math.abs(a.y - b.y) < g;
        },
        yb = function yb(a, b) {
          return pb.x = Math.abs(a.x - b.x), pb.y = Math.abs(a.y - b.y), Math.sqrt(pb.x * pb.x + pb.y * pb.y);
        },
        zb = function zb() {
          Z && (I(Z), Z = null);
        },
        _Ab = function Ab() {
          V && (Z = H(_Ab), Qb());
        },
        Bb = function Bb() {
          return !("fit" === i.scaleMode && s === f.currItem.initialZoomLevel);
        },
        _Cb = function Cb(a, b) {
          return !(!a || a === document) && !(a.getAttribute("class") && a.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (b(a) ? a : _Cb(a.parentNode, b));
        },
        Db = {},
        Eb = function Eb(a, b) {
          return Db.prevent = !_Cb(a.target, i.isClickableElement), Da("preventDragEvent", a, b, Db), Db.prevent;
        },
        Fb = function Fb(a, b) {
          return b.x = a.pageX, b.y = a.pageY, b.id = a.identifier, b;
        },
        Gb = function Gb(a, b, c) {
          c.x = .5 * (a.x + b.x), c.y = .5 * (a.y + b.y);
        },
        Hb = function Hb(a, b, c) {
          if (a - Q > 50) {
            var d = ob.length > 2 ? ob.shift() : {};
            d.x = b, d.y = c, ob.push(d), Q = a;
          }
        },
        Ib = function Ib() {
          var a = pa.y - f.currItem.initialPosition.y;
          return 1 - Math.abs(a / (qa.y / 2));
        },
        Jb = {},
        Kb = {},
        Lb = [],
        Mb = function Mb(a) {
          for (; Lb.length > 0;) Lb.pop();
          return F ? (la = 0, mb.forEach(function (a) {
            0 === la ? Lb[0] = a : 1 === la && (Lb[1] = a), la++;
          })) : a.type.indexOf("touch") > -1 ? a.touches && a.touches.length > 0 && (Lb[0] = Fb(a.touches[0], Jb), a.touches.length > 1 && (Lb[1] = Fb(a.touches[1], Kb))) : (Jb.x = a.pageX, Jb.y = a.pageY, Jb.id = "", Lb[0] = Jb), Lb;
        },
        Nb = function Nb(a, b) {
          var c,
            d,
            e,
            g,
            h = 0,
            j = pa[a] + b[a],
            k = b[a] > 0,
            l = tb.x + b.x,
            m = tb.x - nb.x;
          return c = j > da.min[a] || j < da.max[a] ? i.panEndFriction : 1, j = pa[a] + b[a] * c, !i.allowPanToNext && s !== f.currItem.initialZoomLevel || (ea ? "h" !== ga || "x" !== a || X || (k ? (j > da.min[a] && (c = i.panEndFriction, h = da.min[a] - j, d = da.min[a] - oa[a]), (d <= 0 || m < 0) && ac() > 1 ? (g = l, m < 0 && l > nb.x && (g = nb.x)) : da.min.x !== da.max.x && (e = j)) : (j < da.max[a] && (c = i.panEndFriction, h = j - da.max[a], d = oa[a] - da.max[a]), (d <= 0 || m > 0) && ac() > 1 ? (g = l, m > 0 && l < nb.x && (g = nb.x)) : da.min.x !== da.max.x && (e = j))) : g = l, "x" !== a) ? void (fa || $ || s > f.currItem.fitRatio && (pa[a] += b[a] * c)) : (void 0 !== g && (Ka(g, !0), $ = g !== nb.x), da.min.x !== da.max.x && (void 0 !== e ? pa.x = e : $ || (pa.x += b.x * c)), void 0 !== g);
        },
        Ob = function Ob(a) {
          if (!("mousedown" === a.type && a.button > 0)) {
            if ($b) return void a.preventDefault();
            if (!U || "mousedown" !== a.type) {
              if (Eb(a, !0) && a.preventDefault(), Da("pointerDown"), F) {
                var b = e.arraySearch(mb, a.pointerId, "id");
                b < 0 && (b = mb.length), mb[b] = {
                  x: a.pageX,
                  y: a.pageY,
                  id: a.pointerId
                };
              }
              var c = Mb(a),
                d = c.length;
              _ = null, cb(), V && 1 !== d || (V = ha = !0, e.bind(window, p, f), S = ka = ia = T = $ = Y = W = X = !1, ga = null, Da("firstTouchStart", c), Ma(oa, pa), na.x = na.y = 0, Ma(kb, c[0]), Ma(lb, kb), nb.x = ta.x * ra, ob = [{
                x: kb.x,
                y: kb.y
              }], Q = P = Ea(), Sa(s, !0), zb(), _Ab()), !aa && d > 1 && !fa && !$ && (t = s, X = !1, aa = W = !0, na.y = na.x = 0, Ma(oa, pa), Ma(hb, c[0]), Ma(ib, c[1]), Gb(hb, ib, vb), ub.x = Math.abs(vb.x) - pa.x, ub.y = Math.abs(vb.y) - pa.y, ba = ca = yb(hb, ib));
            }
          }
        },
        Pb = function Pb(a) {
          if (a.preventDefault(), F) {
            var b = e.arraySearch(mb, a.pointerId, "id");
            if (b > -1) {
              var c = mb[b];
              c.x = a.pageX, c.y = a.pageY;
            }
          }
          if (V) {
            var d = Mb(a);
            if (ga || Y || aa) _ = d;else if (tb.x !== ta.x * ra) ga = "h";else {
              var f = Math.abs(d[0].x - kb.x) - Math.abs(d[0].y - kb.y);
              Math.abs(f) >= gb && (ga = f > 0 ? "h" : "v", _ = d);
            }
          }
        },
        Qb = function Qb() {
          if (_) {
            var a = _.length;
            if (0 !== a) if (Ma(hb, _[0]), jb.x = hb.x - kb.x, jb.y = hb.y - kb.y, aa && a > 1) {
              if (kb.x = hb.x, kb.y = hb.y, !jb.x && !jb.y && wb(_[1], ib)) return;
              Ma(ib, _[1]), X || (X = !0, Da("zoomGestureStarted"));
              var b = yb(hb, ib),
                c = Vb(b);
              c > f.currItem.initialZoomLevel + f.currItem.initialZoomLevel / 15 && (ka = !0);
              var d = 1,
                e = Ta(),
                g = Ua();
              if (c < e) {
                if (i.pinchToClose && !ka && t <= f.currItem.initialZoomLevel) {
                  var h = e - c,
                    j = 1 - h / (e / 1.2);
                  Fa(j), Da("onPinchClose", j), ia = !0;
                } else d = (e - c) / e, d > 1 && (d = 1), c = e - d * (e / 3);
              } else c > g && (d = (c - g) / (6 * e), d > 1 && (d = 1), c = g + d * e);
              d < 0 && (d = 0), ba = b, Gb(hb, ib, rb), na.x += rb.x - vb.x, na.y += rb.y - vb.y, Ma(vb, rb), pa.x = La("x", c), pa.y = La("y", c), S = c > s, s = c, Ha();
            } else {
              if (!ga) return;
              if (ha && (ha = !1, Math.abs(jb.x) >= gb && (jb.x -= _[0].x - lb.x), Math.abs(jb.y) >= gb && (jb.y -= _[0].y - lb.y)), kb.x = hb.x, kb.y = hb.y, 0 === jb.x && 0 === jb.y) return;
              if ("v" === ga && i.closeOnVerticalDrag && !Bb()) {
                na.y += jb.y, pa.y += jb.y;
                var k = Ib();
                return T = !0, Da("onVerticalDrag", k), Fa(k), void Ha();
              }
              Hb(Ea(), hb.x, hb.y), Y = !0, da = f.currItem.bounds;
              var l = Nb("x", jb);
              l || (Nb("y", jb), Na(pa), Ha());
            }
          }
        },
        Rb = function Rb(a) {
          if (N.isOldAndroid) {
            if (U && "mouseup" === a.type) return;
            a.type.indexOf("touch") > -1 && (clearTimeout(U), U = setTimeout(function () {
              U = 0;
            }, 600));
          }
          Da("pointerUp"), Eb(a, !1) && a.preventDefault();
          var b;
          if (F) {
            var c = e.arraySearch(mb, a.pointerId, "id");
            if (c > -1) if (b = mb.splice(c, 1)[0], navigator.msPointerEnabled) {
              var d = {
                4: "mouse",
                2: "touch",
                3: "pen"
              };
              b.type = d[a.pointerType], b.type || (b.type = a.pointerType || "mouse");
            } else b.type = a.pointerType || "mouse";
          }
          var g,
            h = Mb(a),
            j = h.length;
          if ("mouseup" === a.type && (j = 0), 2 === j) return _ = null, !0;
          1 === j && Ma(lb, h[0]), 0 !== j || ga || fa || (b || ("mouseup" === a.type ? b = {
            x: a.pageX,
            y: a.pageY,
            type: "mouse"
          } : a.changedTouches && a.changedTouches[0] && (b = {
            x: a.changedTouches[0].pageX,
            y: a.changedTouches[0].pageY,
            type: "touch"
          })), Da("touchRelease", a, b));
          var k = -1;
          if (0 === j && (V = !1, e.unbind(window, p, f), zb(), aa ? k = 0 : sb !== -1 && (k = Ea() - sb)), sb = 1 === j ? Ea() : -1, g = k !== -1 && k < 150 ? "zoom" : "swipe", aa && j < 2 && (aa = !1, 1 === j && (g = "zoomPointerUp"), Da("zoomGestureEnded")), _ = null, Y || X || fa || T) if (cb(), R || (R = Sb()), R.calculateSwipeSpeed("x"), T) {
            var l = Ib();
            if (l < i.verticalDragRange) f.close();else {
              var m = pa.y,
                n = ja;
              db("verticalDrag", 0, 1, 300, e.easing.cubic.out, function (a) {
                pa.y = (f.currItem.initialPosition.y - m) * a + m, Fa((1 - n) * a + n), Ha();
              }), Da("onVerticalDrag", 1);
            }
          } else {
            if (($ || fa) && 0 === j) {
              var o = Ub(g, R);
              if (o) return;
              g = "zoomPointerUp";
            }
            if (!fa) return "swipe" !== g ? void Wb() : void (!$ && s > f.currItem.fitRatio && Tb(R));
          }
        },
        Sb = function Sb() {
          var a,
            b,
            c = {
              lastFlickOffset: {},
              lastFlickDist: {},
              lastFlickSpeed: {},
              slowDownRatio: {},
              slowDownRatioReverse: {},
              speedDecelerationRatio: {},
              speedDecelerationRatioAbs: {},
              distanceOffset: {},
              backAnimDestination: {},
              backAnimStarted: {},
              calculateSwipeSpeed: function calculateSwipeSpeed(d) {
                ob.length > 1 ? (a = Ea() - Q + 50, b = ob[ob.length - 2][d]) : (a = Ea() - P, b = lb[d]), c.lastFlickOffset[d] = kb[d] - b, c.lastFlickDist[d] = Math.abs(c.lastFlickOffset[d]), c.lastFlickDist[d] > 20 ? c.lastFlickSpeed[d] = c.lastFlickOffset[d] / a : c.lastFlickSpeed[d] = 0, Math.abs(c.lastFlickSpeed[d]) < .1 && (c.lastFlickSpeed[d] = 0), c.slowDownRatio[d] = .95, c.slowDownRatioReverse[d] = 1 - c.slowDownRatio[d], c.speedDecelerationRatio[d] = 1;
              },
              calculateOverBoundsAnimOffset: function calculateOverBoundsAnimOffset(a, b) {
                c.backAnimStarted[a] || (pa[a] > da.min[a] ? c.backAnimDestination[a] = da.min[a] : pa[a] < da.max[a] && (c.backAnimDestination[a] = da.max[a]), void 0 !== c.backAnimDestination[a] && (c.slowDownRatio[a] = .7, c.slowDownRatioReverse[a] = 1 - c.slowDownRatio[a], c.speedDecelerationRatioAbs[a] < .05 && (c.lastFlickSpeed[a] = 0, c.backAnimStarted[a] = !0, db("bounceZoomPan" + a, pa[a], c.backAnimDestination[a], b || 300, e.easing.sine.out, function (b) {
                  pa[a] = b, Ha();
                }))));
              },
              calculateAnimOffset: function calculateAnimOffset(a) {
                c.backAnimStarted[a] || (c.speedDecelerationRatio[a] = c.speedDecelerationRatio[a] * (c.slowDownRatio[a] + c.slowDownRatioReverse[a] - c.slowDownRatioReverse[a] * c.timeDiff / 10), c.speedDecelerationRatioAbs[a] = Math.abs(c.lastFlickSpeed[a] * c.speedDecelerationRatio[a]), c.distanceOffset[a] = c.lastFlickSpeed[a] * c.speedDecelerationRatio[a] * c.timeDiff, pa[a] += c.distanceOffset[a]);
              },
              panAnimLoop: function panAnimLoop() {
                if ($a.zoomPan && ($a.zoomPan.raf = H(c.panAnimLoop), c.now = Ea(), c.timeDiff = c.now - c.lastNow, c.lastNow = c.now, c.calculateAnimOffset("x"), c.calculateAnimOffset("y"), Ha(), c.calculateOverBoundsAnimOffset("x"), c.calculateOverBoundsAnimOffset("y"), c.speedDecelerationRatioAbs.x < .05 && c.speedDecelerationRatioAbs.y < .05)) return pa.x = Math.round(pa.x), pa.y = Math.round(pa.y), Ha(), void ab("zoomPan");
              }
            };
          return c;
        },
        Tb = function Tb(a) {
          return a.calculateSwipeSpeed("y"), da = f.currItem.bounds, a.backAnimDestination = {}, a.backAnimStarted = {}, Math.abs(a.lastFlickSpeed.x) <= .05 && Math.abs(a.lastFlickSpeed.y) <= .05 ? (a.speedDecelerationRatioAbs.x = a.speedDecelerationRatioAbs.y = 0, a.calculateOverBoundsAnimOffset("x"), a.calculateOverBoundsAnimOffset("y"), !0) : (bb("zoomPan"), a.lastNow = Ea(), void a.panAnimLoop());
        },
        Ub = function Ub(a, b) {
          var c;
          fa || (qb = m);
          var d;
          if ("swipe" === a) {
            var g = kb.x - lb.x,
              h = b.lastFlickDist.x < 10;
            g > fb && (h || b.lastFlickOffset.x > 20) ? d = -1 : g < -fb && (h || b.lastFlickOffset.x < -20) && (d = 1);
          }
          var j;
          d && (m += d, m < 0 ? (m = i.loop ? ac() - 1 : 0, j = !0) : m >= ac() && (m = i.loop ? 0 : ac() - 1, j = !0), j && !i.loop || (ua += d, ra -= d, c = !0));
          var k,
            l = ta.x * ra,
            n = Math.abs(l - tb.x);
          return c || l > tb.x == b.lastFlickSpeed.x > 0 ? (k = Math.abs(b.lastFlickSpeed.x) > 0 ? n / Math.abs(b.lastFlickSpeed.x) : 333, k = Math.min(k, 400), k = Math.max(k, 250)) : k = 333, qb === m && (c = !1), fa = !0, Da("mainScrollAnimStart"), db("mainScroll", tb.x, l, k, e.easing.cubic.out, Ka, function () {
            cb(), fa = !1, qb = -1, (c || qb !== m) && f.updateCurrItem(), Da("mainScrollAnimComplete");
          }), c && f.updateCurrItem(!0), c;
        },
        Vb = function Vb(a) {
          return 1 / ca * a * t;
        },
        Wb = function Wb() {
          var a = s,
            b = Ta(),
            c = Ua();
          s < b ? a = b : s > c && (a = c);
          var d,
            g = 1,
            h = ja;
          return ia && !S && !ka && s < b ? (f.close(), !0) : (ia && (d = function d(a) {
            Fa((g - h) * a + h);
          }), f.zoomTo(a, 0, 200, e.easing.cubic.out, d), !0);
        };
      za("Gestures", {
        publicMethods: {
          initGestures: function initGestures() {
            var a = function a(_a2, b, c, d, e) {
              A = _a2 + b, B = _a2 + c, C = _a2 + d, D = e ? _a2 + e : "";
            };
            F = N.pointerEvent, F && N.touch && (N.touch = !1), F ? navigator.msPointerEnabled ? a("MSPointer", "Down", "Move", "Up", "Cancel") : a("pointer", "down", "move", "up", "cancel") : N.touch ? (a("touch", "start", "move", "end", "cancel"), G = !0) : a("mouse", "down", "move", "up"), p = B + " " + C + " " + D, q = A, F && !G && (G = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), f.likelyTouchDevice = G, r[A] = Ob, r[B] = Pb, r[C] = Rb, D && (r[D] = r[C]), N.touch && (q += " mousedown", p += " mousemove mouseup", r.mousedown = r[A], r.mousemove = r[B], r.mouseup = r[C]), G || (i.allowPanToNext = !1);
          }
        }
      });
      var Xb,
        Yb,
        Zb,
        $b,
        _b,
        ac,
        bc,
        cc = function cc(b, c, d, g) {
          Xb && clearTimeout(Xb), $b = !0, Zb = !0;
          var h;
          b.initialLayout ? (h = b.initialLayout, b.initialLayout = null) : h = i.getThumbBoundsFn && i.getThumbBoundsFn(m);
          var j = d ? i.hideAnimationDuration : i.showAnimationDuration,
            k = function k() {
              ab("initialZoom"), d ? (f.template.removeAttribute("style"), f.bg.removeAttribute("style")) : (Fa(1), c && (c.style.display = "block"), e.addClass(_a3, "pswp--animated-in"), Da("initialZoom" + (d ? "OutEnd" : "InEnd"))), g && g(), $b = !1;
            };
          if (!j || !h || void 0 === h.x) return Da("initialZoom" + (d ? "Out" : "In")), s = b.initialZoomLevel, Ma(pa, b.initialPosition), Ha(), _a3.style.opacity = d ? 0 : 1, Fa(1), void (j ? setTimeout(function () {
            k();
          }, j) : k());
          var n = function n() {
            var c = l,
              g = !f.currItem.src || f.currItem.loadError || i.showHideOpacity;
            b.miniImg && (b.miniImg.style.webkitBackfaceVisibility = "hidden"), d || (s = h.w / b.w, pa.x = h.x, pa.y = h.y - K, f[g ? "template" : "bg"].style.opacity = .001, Ha()), bb("initialZoom"), d && !c && e.removeClass(_a3, "pswp--animated-in"), g && (d ? e[(c ? "remove" : "add") + "Class"](_a3, "pswp--animate_opacity") : setTimeout(function () {
              e.addClass(_a3, "pswp--animate_opacity");
            }, 30)), Xb = setTimeout(function () {
              if (Da("initialZoom" + (d ? "Out" : "In")), d) {
                var f = h.w / b.w,
                  i = {
                    x: pa.x,
                    y: pa.y
                  },
                  l = s,
                  m = ja,
                  n = function n(b) {
                    1 === b ? (s = f, pa.x = h.x, pa.y = h.y - M) : (s = (f - l) * b + l, pa.x = (h.x - i.x) * b + i.x, pa.y = (h.y - M - i.y) * b + i.y), Ha(), g ? _a3.style.opacity = 1 - b : Fa(m - b * m);
                  };
                c ? db("initialZoom", 0, 1, j, e.easing.cubic.out, n, k) : (n(1), Xb = setTimeout(k, j + 20));
              } else s = b.initialZoomLevel, Ma(pa, b.initialPosition), Ha(), Fa(1), g ? _a3.style.opacity = 1 : Fa(1), Xb = setTimeout(k, j + 20);
            }, d ? 25 : 90);
          };
          n();
        },
        dc = {},
        ec = [],
        fc = {
          index: 0,
          errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
          forceProgressiveLoading: !1,
          preload: [1, 1],
          getNumItemsFn: function getNumItemsFn() {
            return Yb.length;
          }
        },
        gc = function gc() {
          return {
            center: {
              x: 0,
              y: 0
            },
            max: {
              x: 0,
              y: 0
            },
            min: {
              x: 0,
              y: 0
            }
          };
        },
        hc = function hc(a, b, c) {
          var d = a.bounds;
          d.center.x = Math.round((dc.x - b) / 2), d.center.y = Math.round((dc.y - c) / 2) + a.vGap.top, d.max.x = b > dc.x ? Math.round(dc.x - b) : d.center.x, d.max.y = c > dc.y ? Math.round(dc.y - c) + a.vGap.top : d.center.y, d.min.x = b > dc.x ? 0 : d.center.x, d.min.y = c > dc.y ? a.vGap.top : d.center.y;
        },
        ic = function ic(a, b, c) {
          if (a.src && !a.loadError) {
            var d = !c;
            if (d && (a.vGap || (a.vGap = {
              top: 0,
              bottom: 0
            }), Da("parseVerticalMargin", a)), dc.x = b.x, dc.y = b.y - a.vGap.top - a.vGap.bottom, d) {
              var e = dc.x / a.w,
                f = dc.y / a.h;
              a.fitRatio = e < f ? e : f;
              var g = i.scaleMode;
              "orig" === g ? c = 1 : "fit" === g && (c = a.fitRatio), c > 1 && (c = 1), a.initialZoomLevel = c, a.bounds || (a.bounds = gc());
            }
            if (!c) return;
            return hc(a, a.w * c, a.h * c), d && c === a.initialZoomLevel && (a.initialPosition = a.bounds.center), a.bounds;
          }
          return a.w = a.h = 0, a.initialZoomLevel = a.fitRatio = 1, a.bounds = gc(), a.initialPosition = a.bounds.center, a.bounds;
        },
        jc = function jc(a, b, c, d, e, g) {
          b.loadError || d && (b.imageAppended = !0, mc(b, d, b === f.currItem && ya), c.appendChild(d), g && setTimeout(function () {
            b && b.loaded && b.placeholder && (b.placeholder.style.display = "none", b.placeholder = null);
          }, 500));
        },
        kc = function kc(a) {
          a.loading = !0, a.loaded = !1;
          var b = a.img = e.createEl("pswp__img", "img"),
            c = function c() {
              a.loading = !1, a.loaded = !0, a.loadComplete ? a.loadComplete(a) : a.img = null, b.onload = b.onerror = null, b = null;
            };
          return b.onload = c, b.onerror = function () {
            a.loadError = !0, c();
          }, b.src = a.src, b;
        },
        lc = function lc(a, b) {
          if (a.src && a.loadError && a.container) return b && (a.container.innerHTML = ""), a.container.innerHTML = i.errorMsg.replace("%url%", a.src), !0;
        },
        mc = function mc(a, b, c) {
          if (a.src) {
            b || (b = a.container.lastChild);
            var d = c ? a.w : Math.round(a.w * a.fitRatio),
              e = c ? a.h : Math.round(a.h * a.fitRatio);
            a.placeholder && !a.loaded && (a.placeholder.style.width = d + "px", a.placeholder.style.height = e + "px"), b.style.width = d + "px", b.style.height = e + "px";
          }
        },
        nc = function nc() {
          if (ec.length) {
            for (var a, b = 0; b < ec.length; b++) a = ec[b], a.holder.index === a.index && jc(a.index, a.item, a.baseDiv, a.img, !1, a.clearPlaceholder);
            ec = [];
          }
        };
      za("Controller", {
        publicMethods: {
          lazyLoadItem: function lazyLoadItem(a) {
            a = Aa(a);
            var b = _b(a);
            b && (!b.loaded && !b.loading || x) && (Da("gettingData", a, b), b.src && kc(b));
          },
          initController: function initController() {
            e.extend(i, fc, !0), f.items = Yb = c, _b = f.getItemAt, ac = i.getNumItemsFn, bc = i.loop, ac() < 3 && (i.loop = !1), Ca("beforeChange", function (a) {
              var b,
                c = i.preload,
                d = null === a || a >= 0,
                e = Math.min(c[0], ac()),
                g = Math.min(c[1], ac());
              for (b = 1; b <= (d ? g : e); b++) f.lazyLoadItem(m + b);
              for (b = 1; b <= (d ? e : g); b++) f.lazyLoadItem(m - b);
            }), Ca("initialLayout", function () {
              f.currItem.initialLayout = i.getThumbBoundsFn && i.getThumbBoundsFn(m);
            }), Ca("mainScrollAnimComplete", nc), Ca("initialZoomInEnd", nc), Ca("destroy", function () {
              for (var a, b = 0; b < Yb.length; b++) a = Yb[b], a.container && (a.container = null), a.placeholder && (a.placeholder = null), a.img && (a.img = null), a.preloader && (a.preloader = null), a.loadError && (a.loaded = a.loadError = !1);
              ec = null;
            });
          },
          getItemAt: function getItemAt(a) {
            return a >= 0 && void 0 !== Yb[a] && Yb[a];
          },
          allowProgressiveImg: function allowProgressiveImg() {
            return i.forceProgressiveLoading || !G || i.mouseUsed || screen.width > 1200;
          },
          setContent: function setContent(a, b) {
            i.loop && (b = Aa(b));
            var c = f.getItemAt(a.index);
            c && (c.container = null);
            var d,
              g = f.getItemAt(b);
            if (!g) return void (a.el.innerHTML = "");
            Da("gettingData", b, g), a.index = b, a.item = g;
            var h = g.container = e.createEl("pswp__zoom-wrap");
            if (!g.src && g.html && (g.html.tagName ? h.appendChild(g.html) : h.innerHTML = g.html), lc(g), ic(g, qa), !g.src || g.loadError || g.loaded) g.src && !g.loadError && (d = e.createEl("pswp__img", "img"), d.style.opacity = 1, d.src = g.src, mc(g, d), jc(b, g, h, d, !0));else {
              if (g.loadComplete = function (c) {
                if (j) {
                  if (a && a.index === b) {
                    if (lc(c, !0)) return c.loadComplete = c.img = null, ic(c, qa), Ia(c), void (a.index === m && f.updateCurrZoomItem());
                    c.imageAppended ? !$b && c.placeholder && (c.placeholder.style.display = "none", c.placeholder = null) : N.transform && (fa || $b) ? ec.push({
                      item: c,
                      baseDiv: h,
                      img: c.img,
                      index: b,
                      holder: a,
                      clearPlaceholder: !0
                    }) : jc(b, c, h, c.img, fa || $b, !0);
                  }
                  c.loadComplete = null, c.img = null, Da("imageLoadComplete", b, c);
                }
              }, e.features.transform) {
                var k = "pswp__img pswp__img--placeholder";
                k += g.msrc ? "" : " pswp__img--placeholder--blank";
                var l = e.createEl(k, g.msrc ? "img" : "");
                g.msrc && (l.src = g.msrc), mc(g, l), h.appendChild(l), g.placeholder = l;
              }
              g.loading || kc(g), f.allowProgressiveImg() && (!Zb && N.transform ? ec.push({
                item: g,
                baseDiv: h,
                img: g.img,
                index: b,
                holder: a
              }) : jc(b, g, h, g.img, !0, !0));
            }
            Zb || b !== m ? Ia(g) : (ea = h.style, cc(g, d || g.img)), a.el.innerHTML = "", a.el.appendChild(h);
          },
          cleanSlide: function cleanSlide(a) {
            a.img && (a.img.onload = a.img.onerror = null), a.loaded = a.loading = a.img = a.imageAppended = !1;
          }
        }
      });
      var oc,
        pc = {},
        qc = function qc(a, b, c) {
          var d = document.createEvent("CustomEvent"),
            e = {
              origEvent: a,
              target: a.target,
              releasePoint: b,
              pointerType: c || "touch"
            };
          d.initCustomEvent("pswpTap", !0, !0, e), a.target.dispatchEvent(d);
        };
      za("Tap", {
        publicMethods: {
          initTap: function initTap() {
            Ca("firstTouchStart", f.onTapStart), Ca("touchRelease", f.onTapRelease), Ca("destroy", function () {
              pc = {}, oc = null;
            });
          },
          onTapStart: function onTapStart(a) {
            a.length > 1 && (clearTimeout(oc), oc = null);
          },
          onTapRelease: function onTapRelease(a, b) {
            if (b && !Y && !W && !_a) {
              var c = b;
              if (oc && (clearTimeout(oc), oc = null, xb(c, pc))) return void Da("doubleTap", c);
              if ("mouse" === b.type) return void qc(a, b, "mouse");
              var d = a.target.tagName.toUpperCase();
              if ("BUTTON" === d || e.hasClass(a.target, "pswp__single-tap")) return void qc(a, b);
              Ma(pc, c), oc = setTimeout(function () {
                qc(a, b), oc = null;
              }, 300);
            }
          }
        }
      });
      var rc;
      za("DesktopZoom", {
        publicMethods: {
          initDesktopZoom: function initDesktopZoom() {
            L || (G ? Ca("mouseUsed", function () {
              f.setupDesktopZoom();
            }) : f.setupDesktopZoom(!0));
          },
          setupDesktopZoom: function setupDesktopZoom(b) {
            rc = {};
            var c = "wheel mousewheel DOMMouseScroll";
            Ca("bindEvents", function () {
              e.bind(_a3, c, f.handleMouseWheel);
            }), Ca("unbindEvents", function () {
              rc && e.unbind(_a3, c, f.handleMouseWheel);
            }), f.mouseZoomedIn = !1;
            var d,
              g = function g() {
                f.mouseZoomedIn && (e.removeClass(_a3, "pswp--zoomed-in"), f.mouseZoomedIn = !1), s < 1 ? e.addClass(_a3, "pswp--zoom-allowed") : e.removeClass(_a3, "pswp--zoom-allowed"), h();
              },
              h = function h() {
                d && (e.removeClass(_a3, "pswp--dragging"), d = !1);
              };
            Ca("resize", g), Ca("afterChange", g), Ca("pointerDown", function () {
              f.mouseZoomedIn && (d = !0, e.addClass(_a3, "pswp--dragging"));
            }), Ca("pointerUp", h), b || g();
          },
          handleMouseWheel: function handleMouseWheel(a) {
            if (s <= f.currItem.fitRatio) return i.modal && (!i.closeOnScroll || _a || V ? a.preventDefault() : E && Math.abs(a.deltaY) > 2 && (l = !0, f.close())), !0;
            if (a.stopPropagation(), rc.x = 0, "deltaX" in a) 1 === a.deltaMode ? (rc.x = 18 * a.deltaX, rc.y = 18 * a.deltaY) : (rc.x = a.deltaX, rc.y = a.deltaY);else if ("wheelDelta" in a) a.wheelDeltaX && (rc.x = -.16 * a.wheelDeltaX), a.wheelDeltaY ? rc.y = -.16 * a.wheelDeltaY : rc.y = -.16 * a.wheelDelta;else {
              if (!("detail" in a)) return;
              rc.y = a.detail;
            }
            Sa(s, !0);
            var b = pa.x - rc.x,
              c = pa.y - rc.y;
            (i.modal || b <= da.min.x && b >= da.max.x && c <= da.min.y && c >= da.max.y) && a.preventDefault(), f.panTo(b, c);
          },
          toggleDesktopZoom: function toggleDesktopZoom(b) {
            b = b || {
              x: qa.x / 2 + sa.x,
              y: qa.y / 2 + sa.y
            };
            var c = i.getDoubleTapZoom(!0, f.currItem),
              d = s === c;
            f.mouseZoomedIn = !d, f.zoomTo(d ? f.currItem.initialZoomLevel : c, b, 333), e[(d ? "remove" : "add") + "Class"](_a3, "pswp--zoomed-in");
          }
        }
      });
      var sc,
        tc,
        uc,
        vc,
        wc,
        xc,
        yc,
        zc,
        Ac,
        Bc,
        Cc,
        Dc,
        Ec = {
          history: !0,
          galleryUID: 1
        },
        Fc = function Fc() {
          return Cc.hash.substring(1);
        },
        Gc = function Gc() {
          sc && clearTimeout(sc), uc && clearTimeout(uc);
        },
        Hc = function Hc() {
          var a = Fc(),
            b = {};
          if (a.length < 5) return b;
          var c,
            d = a.split("&");
          for (c = 0; c < d.length; c++) if (d[c]) {
            var e = d[c].split("=");
            e.length < 2 || (b[e[0]] = e[1]);
          }
          if (i.galleryPIDs) {
            var f = b.pid;
            for (b.pid = 0, c = 0; c < Yb.length; c++) if (Yb[c].pid === f) {
              b.pid = c;
              break;
            }
          } else b.pid = parseInt(b.pid, 10) - 1;
          return b.pid < 0 && (b.pid = 0), b;
        },
        _Ic = function Ic() {
          if (uc && clearTimeout(uc), _a || V) return void (uc = setTimeout(_Ic, 500));
          vc ? clearTimeout(tc) : vc = !0;
          var a = m + 1,
            b = _b(m);
          b.hasOwnProperty("pid") && (a = b.pid);
          var c = yc + "&gid=" + i.galleryUID + "&pid=" + a;
          zc || Cc.hash.indexOf(c) === -1 && (Bc = !0);
          var d = Cc.href.split("#")[0] + "#" + c;
          Dc ? "#" + c !== window.location.hash && history[zc ? "replaceState" : "pushState"]("", document.title, d) : zc ? Cc.replace(d) : Cc.hash = c, zc = !0, tc = setTimeout(function () {
            vc = !1;
          }, 60);
        };
      za("History", {
        publicMethods: {
          initHistory: function initHistory() {
            if (e.extend(i, Ec, !0), i.history) {
              Cc = window.location, Bc = !1, Ac = !1, zc = !1, yc = Fc(), Dc = "pushState" in history, yc.indexOf("gid=") > -1 && (yc = yc.split("&gid=")[0], yc = yc.split("?gid=")[0]), Ca("afterChange", f.updateURL), Ca("unbindEvents", function () {
                e.unbind(window, "hashchange", f.onHashChange);
              });
              var a = function a() {
                xc = !0, Ac || (Bc ? history.back() : yc ? Cc.hash = yc : Dc ? history.pushState("", document.title, Cc.pathname + Cc.search) : Cc.hash = ""), Gc();
              };
              Ca("unbindEvents", function () {
                l && a();
              }), Ca("destroy", function () {
                xc || a();
              }), Ca("firstUpdate", function () {
                m = Hc().pid;
              });
              var b = yc.indexOf("pid=");
              b > -1 && (yc = yc.substring(0, b), "&" === yc.slice(-1) && (yc = yc.slice(0, -1))), setTimeout(function () {
                j && e.bind(window, "hashchange", f.onHashChange);
              }, 40);
            }
          },
          onHashChange: function onHashChange() {
            return Fc() === yc ? (Ac = !0, void f.close()) : void (vc || (wc = !0, f.goTo(Hc().pid), wc = !1));
          },
          updateURL: function updateURL() {
            Gc(), wc || (zc ? sc = setTimeout(_Ic, 800) : _Ic());
          }
        }
      }), e.extend(f, eb);
    };
    return a;
  });

  /*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
  * http://photoswipe.com
  * Copyright (c) 2019 Dmitry Semenov; */
  !function (a, b) {
    "function" == typeof define && define.amd ? define(b) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b() : a.PhotoSwipeUI_Default = b();
  }(this, function () {
    "use strict";

    var a = function a(_a4, b) {
      var c,
        d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t,
        u,
        v = this,
        w = !1,
        x = !0,
        y = !0,
        z = {
          barsSize: {
            top: 44,
            bottom: "auto"
          },
          closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
          timeToIdle: 4e3,
          timeToIdleOutside: 1e3,
          loadingIndicatorDelay: 1e3,
          addCaptionHTMLFn: function addCaptionHTMLFn(a, b) {
            return a.title ? (b.children[0].innerHTML = a.title, !0) : (b.children[0].innerHTML = "", !1);
          },
          closeEl: !0,
          captionEl: !0,
          fullscreenEl: !0,
          zoomEl: !0,
          shareEl: !0,
          counterEl: !0,
          arrowEl: !0,
          preloaderEl: !0,
          tapToClose: !1,
          tapToToggleControls: !0,
          clickToCloseNonZoomable: !0,
          shareButtons: [{
            id: "facebook",
            label: "Share on Facebook",
            url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
          }, {
            id: "twitter",
            label: "Tweet",
            url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
          }, {
            id: "pinterest",
            label: "Pin it",
            url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
          }, {
            id: "download",
            label: "Download image",
            url: "{{raw_image_url}}",
            download: !0
          }],
          getImageURLForShare: function getImageURLForShare() {
            return _a4.currItem.src || "";
          },
          getPageURLForShare: function getPageURLForShare() {
            return window.location.href;
          },
          getTextForShare: function getTextForShare() {
            return _a4.currItem.title || "";
          },
          indexIndicatorSep: " / ",
          fitControlsWidth: 1200
        },
        A = function A(a) {
          if (r) return !0;
          a = a || window.event, q.timeToIdle && q.mouseUsed && !k && K();
          for (var c, d, e = a.target || a.srcElement, f = e.getAttribute("class") || "", g = 0; g < S.length; g++) c = S[g], c.onTap && f.indexOf("pswp__" + c.name) > -1 && (c.onTap(), d = !0);
          if (d) {
            a.stopPropagation && a.stopPropagation(), r = !0;
            var h = b.features.isOldAndroid ? 600 : 30;
            s = setTimeout(function () {
              r = !1;
            }, h);
          }
        },
        B = function B() {
          return !_a4.likelyTouchDevice || q.mouseUsed || screen.width > q.fitControlsWidth;
        },
        C = function C(a, c, d) {
          b[(d ? "add" : "remove") + "Class"](a, "pswp__" + c);
        },
        D = function D() {
          var a = 1 === q.getNumItemsFn();
          a !== p && (C(d, "ui--one-slide", a), p = a);
        },
        E = function E() {
          C(i, "share-modal--hidden", y);
        },
        F = function F() {
          return y = !y, y ? (b.removeClass(i, "pswp__share-modal--fade-in"), setTimeout(function () {
            y && E();
          }, 300)) : (E(), setTimeout(function () {
            y || b.addClass(i, "pswp__share-modal--fade-in");
          }, 30)), y || H(), !1;
        },
        G = function G(b) {
          b = b || window.event;
          var c = b.target || b.srcElement;
          return _a4.shout("shareLinkClick", b, c), !!c.href && (!!c.hasAttribute("download") || (window.open(c.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), y || F(), !1));
        },
        H = function H() {
          for (var a, b, c, d, e, f = "", g = 0; g < q.shareButtons.length; g++) a = q.shareButtons[g], c = q.getImageURLForShare(a), d = q.getPageURLForShare(a), e = q.getTextForShare(a), b = a.url.replace("{{url}}", encodeURIComponent(d)).replace("{{image_url}}", encodeURIComponent(c)).replace("{{raw_image_url}}", c).replace("{{text}}", encodeURIComponent(e)), f += '<a href="' + b + '" target="_blank" class="pswp__share--' + a.id + '"' + (a.download ? "download" : "") + ">" + a.label + "</a>", q.parseShareButtonOut && (f = q.parseShareButtonOut(a, f));
          i.children[0].innerHTML = f, i.children[0].onclick = G;
        },
        I = function I(a) {
          for (var c = 0; c < q.closeElClasses.length; c++) if (b.hasClass(a, "pswp__" + q.closeElClasses[c])) return !0;
        },
        J = 0,
        K = function K() {
          clearTimeout(u), J = 0, k && v.setIdle(!1);
        },
        L = function L(a) {
          a = a ? a : window.event;
          var b = a.relatedTarget || a.toElement;
          b && "HTML" !== b.nodeName || (clearTimeout(u), u = setTimeout(function () {
            v.setIdle(!0);
          }, q.timeToIdleOutside));
        },
        M = function M() {
          q.fullscreenEl && !b.features.isOldAndroid && (c || (c = v.getFullscreenAPI()), c ? (b.bind(document, c.eventK, v.updateFullscreen), v.updateFullscreen(), b.addClass(_a4.template, "pswp--supports-fs")) : b.removeClass(_a4.template, "pswp--supports-fs"));
        },
        N = function N() {
          q.preloaderEl && (O(!0), l("beforeChange", function () {
            clearTimeout(o), o = setTimeout(function () {
              _a4.currItem && _a4.currItem.loading ? (!_a4.allowProgressiveImg() || _a4.currItem.img && !_a4.currItem.img.naturalWidth) && O(!1) : O(!0);
            }, q.loadingIndicatorDelay);
          }), l("imageLoadComplete", function (b, c) {
            _a4.currItem === c && O(!0);
          }));
        },
        O = function O(a) {
          n !== a && (C(m, "preloader--active", !a), n = a);
        },
        P = function P(a) {
          var c = a.vGap;
          if (B()) {
            var g = q.barsSize;
            if (q.captionEl && "auto" === g.bottom) {
              if (f || (f = b.createEl("pswp__caption pswp__caption--fake"), f.appendChild(b.createEl("pswp__caption__center")), d.insertBefore(f, e), b.addClass(d, "pswp__ui--fit")), q.addCaptionHTMLFn(a, f, !0)) {
                var h = f.clientHeight;
                c.bottom = parseInt(h, 10) || 44;
              } else c.bottom = g.top;
            } else c.bottom = "auto" === g.bottom ? 0 : g.bottom;
            c.top = g.top;
          } else c.top = c.bottom = 0;
        },
        Q = function Q() {
          q.timeToIdle && l("mouseUsed", function () {
            b.bind(document, "mousemove", K), b.bind(document, "mouseout", L), t = setInterval(function () {
              J++, 2 === J && v.setIdle(!0);
            }, q.timeToIdle / 2);
          });
        },
        R = function R() {
          l("onVerticalDrag", function (a) {
            x && a < .95 ? v.hideControls() : !x && a >= .95 && v.showControls();
          });
          var a;
          l("onPinchClose", function (b) {
            x && b < .9 ? (v.hideControls(), a = !0) : a && !x && b > .9 && v.showControls();
          }), l("zoomGestureEnded", function () {
            a = !1, a && !x && v.showControls();
          });
        },
        S = [{
          name: "caption",
          option: "captionEl",
          onInit: function onInit(a) {
            e = a;
          }
        }, {
          name: "share-modal",
          option: "shareEl",
          onInit: function onInit(a) {
            i = a;
          },
          onTap: function onTap() {
            F();
          }
        }, {
          name: "button--share",
          option: "shareEl",
          onInit: function onInit(a) {
            h = a;
          },
          onTap: function onTap() {
            F();
          }
        }, {
          name: "button--zoom",
          option: "zoomEl",
          onTap: _a4.toggleDesktopZoom
        }, {
          name: "counter",
          option: "counterEl",
          onInit: function onInit(a) {
            g = a;
          }
        }, {
          name: "button--close",
          option: "closeEl",
          onTap: _a4.close
        }, {
          name: "button--arrow--left",
          option: "arrowEl",
          onTap: _a4.prev
        }, {
          name: "button--arrow--right",
          option: "arrowEl",
          onTap: _a4.next
        }, {
          name: "button--fs",
          option: "fullscreenEl",
          onTap: function onTap() {
            c.isFullscreen() ? c.exit() : c.enter();
          }
        }, {
          name: "preloader",
          option: "preloaderEl",
          onInit: function onInit(a) {
            m = a;
          }
        }],
        T = function T() {
          var a,
            c,
            e,
            f = function f(d) {
              if (d) for (var f = d.length, g = 0; g < f; g++) {
                a = d[g], c = a.className;
                for (var h = 0; h < S.length; h++) e = S[h], c.indexOf("pswp__" + e.name) > -1 && (q[e.option] ? (b.removeClass(a, "pswp__element--disabled"), e.onInit && e.onInit(a)) : b.addClass(a, "pswp__element--disabled"));
              }
            };
          f(d.children);
          var g = b.getChildByClass(d, "pswp__top-bar");
          g && f(g.children);
        };
      v.init = function () {
        b.extend(_a4.options, z, !0), q = _a4.options, d = b.getChildByClass(_a4.scrollWrap, "pswp__ui"), l = _a4.listen, R(), l("beforeChange", v.update), l("doubleTap", function (b) {
          var c = _a4.currItem.initialZoomLevel;
          _a4.getZoomLevel() !== c ? _a4.zoomTo(c, b, 333) : _a4.zoomTo(q.getDoubleTapZoom(!1, _a4.currItem), b, 333);
        }), l("preventDragEvent", function (a, b, c) {
          var d = a.target || a.srcElement;
          d && d.getAttribute("class") && a.type.indexOf("mouse") > -1 && (d.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(d.tagName)) && (c.prevent = !1);
        }), l("bindEvents", function () {
          b.bind(d, "pswpTap click", A), b.bind(_a4.scrollWrap, "pswpTap", v.onGlobalTap), _a4.likelyTouchDevice || b.bind(_a4.scrollWrap, "mouseover", v.onMouseOver);
        }), l("unbindEvents", function () {
          y || F(), t && clearInterval(t), b.unbind(document, "mouseout", L), b.unbind(document, "mousemove", K), b.unbind(d, "pswpTap click", A), b.unbind(_a4.scrollWrap, "pswpTap", v.onGlobalTap), b.unbind(_a4.scrollWrap, "mouseover", v.onMouseOver), c && (b.unbind(document, c.eventK, v.updateFullscreen), c.isFullscreen() && (q.hideAnimationDuration = 0, c.exit()), c = null);
        }), l("destroy", function () {
          q.captionEl && (f && d.removeChild(f), b.removeClass(e, "pswp__caption--empty")), i && (i.children[0].onclick = null), b.removeClass(d, "pswp__ui--over-close"), b.addClass(d, "pswp__ui--hidden"), v.setIdle(!1);
        }), q.showAnimationDuration || b.removeClass(d, "pswp__ui--hidden"), l("initialZoomIn", function () {
          q.showAnimationDuration && b.removeClass(d, "pswp__ui--hidden");
        }), l("initialZoomOut", function () {
          b.addClass(d, "pswp__ui--hidden");
        }), l("parseVerticalMargin", P), T(), q.shareEl && h && i && (y = !0), D(), Q(), M(), N();
      }, v.setIdle = function (a) {
        k = a, C(d, "ui--idle", a);
      }, v.update = function () {
        x && _a4.currItem ? (v.updateIndexIndicator(), q.captionEl && (q.addCaptionHTMLFn(_a4.currItem, e), C(e, "caption--empty", !_a4.currItem.title)), w = !0) : w = !1, y || F(), D();
      }, v.updateFullscreen = function (d) {
        d && setTimeout(function () {
          _a4.setScrollOffset(0, b.getScrollY());
        }, 50), b[(c.isFullscreen() ? "add" : "remove") + "Class"](_a4.template, "pswp--fs");
      }, v.updateIndexIndicator = function () {
        q.counterEl && (g.innerHTML = _a4.getCurrentIndex() + 1 + q.indexIndicatorSep + q.getNumItemsFn());
      }, v.onGlobalTap = function (c) {
        c = c || window.event;
        var d = c.target || c.srcElement;
        if (!r) if (c.detail && "mouse" === c.detail.pointerType) {
          if (I(d)) return void _a4.close();
          b.hasClass(d, "pswp__img") && (1 === _a4.getZoomLevel() && _a4.getZoomLevel() <= _a4.currItem.fitRatio ? q.clickToCloseNonZoomable && _a4.close() : _a4.toggleDesktopZoom(c.detail.releasePoint));
        } else if (q.tapToToggleControls && (x ? v.hideControls() : v.showControls()), q.tapToClose && (b.hasClass(d, "pswp__img") || I(d))) return void _a4.close();
      }, v.onMouseOver = function (a) {
        a = a || window.event;
        var b = a.target || a.srcElement;
        C(d, "ui--over-close", I(b));
      }, v.hideControls = function () {
        b.addClass(d, "pswp__ui--hidden"), x = !1;
      }, v.showControls = function () {
        x = !0, w || v.update(), b.removeClass(d, "pswp__ui--hidden");
      }, v.supportsFullscreen = function () {
        var a = document;
        return !!(a.exitFullscreen || a.mozCancelFullScreen || a.webkitExitFullscreen || a.msExitFullscreen);
      }, v.getFullscreenAPI = function () {
        var b,
          c = document.documentElement,
          d = "fullscreenchange";
        return c.requestFullscreen ? b = {
          enterK: "requestFullscreen",
          exitK: "exitFullscreen",
          elementK: "fullscreenElement",
          eventK: d
        } : c.mozRequestFullScreen ? b = {
          enterK: "mozRequestFullScreen",
          exitK: "mozCancelFullScreen",
          elementK: "mozFullScreenElement",
          eventK: "moz" + d
        } : c.webkitRequestFullscreen ? b = {
          enterK: "webkitRequestFullscreen",
          exitK: "webkitExitFullscreen",
          elementK: "webkitFullscreenElement",
          eventK: "webkit" + d
        } : c.msRequestFullscreen && (b = {
          enterK: "msRequestFullscreen",
          exitK: "msExitFullscreen",
          elementK: "msFullscreenElement",
          eventK: "MSFullscreenChange"
        }), b && (b.enter = function () {
          return j = q.closeOnScroll, q.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK ? _a4.template[this.enterK]() : void _a4.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
        }, b.exit = function () {
          return q.closeOnScroll = j, document[this.exitK]();
        }, b.isFullscreen = function () {
          return document[this.elementK];
        }), b;
      };
    };
    return a;
  });
})();
var isMobile = $(window).width() <= 740;

/*============================================================================
 Underground Functions
==============================================================================*/
var Events = new EventEmitter3();
Events.trigger = Events.emit; // trigger alias

window.WAU = window.WAU || {};
WAU.Slideout = function () {
  /*
   * Elements
   */
  var wrapper = undefined;

  /*
   * @description - Makes sure that the ESC Key works to close the menus.
   */
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeActiveSlideout();
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target === document.querySelector(".js-slideout-overlay")) {
      closeActiveSlideout();
    }
  });

  /*
   * @description - Closes the currently active slide.
   */
  function closeActiveSlideout() {
    // Find the open slideout.
    var activeSlideout = document.querySelector('.slideout--active');
    var activeSlideoutName = activeSlideout.getAttribute('data-wau-slideout');
    var opener = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + activeSlideoutName + '"]');
    var direction = opener.getAttribute('data-slideout-direction');
    var accordionsClosed = activeSlideout.getAttribute('data-wau-accordions-closed');
    if (accordionsClosed !== null) {
      WAU.Accordion.hideAll(activeSlideoutName);
    }
    close(direction, opener);
  }

  /*
   * @description - Checks if the slideout is currently open or not.
   * @return Boolean
   */
  function isOpen() {
    wrapper = document.querySelector(".js-slideout-toggle-wrapper");
    return wrapper.classList.contains("slideout-left--open") || wrapper.classList.contains("slideout-right--open");
  }

  /*
   * @description - Open a specific slideout in a specific direction.
   * @param direction:String - the drction to open the slideout in.
   * @param targetSlideoutEl:Node - The slideout element that will be opened.
   */
  function open(direction, targetSlideoutEl, opener) {
    if (isMobile) {
      var _vr = parseFloat($('html').css('--vh').replace('px', ''));
      var safariToolbar = navigator.userAgent.match(/iPhone/i) && _vr < 7;
      if (safariToolbar) {
        setTimeout(function () {
          $('.ajax-cart__cart-items').css({
            'padding-bottom': '65px'
          });
        }, 1500);
      }
    }
    wrapper.classList.add("slideout-" + direction + "--open");
    wrapper.classList.remove("slideout-" + direction + "--closed");
    targetSlideoutEl.classList.add('slideout--active');
    opener.setAttribute("aria-expanded", "true");

    // Fix body wrapper so no scrolling on mobile
    var scrollPosition = Math.abs(0 - document.querySelector('.site-wrap').getBoundingClientRect().top);

    // Set tabindex so it will tab slideout
    targetSlideoutEl.querySelectorAll('*').forEach(function (item, i) {
      item.removeAttribute('tabIndex');
    });

    /*
    wrapper.style.overflow = 'hidden';
    wrapper.style.position = 'fixed';
    wrapper.style.top = `-${scrollPosition}px`;
    wrapper.style.width = '100%';
    */
  }

  /*
   * @description - Closes all slideouts. Puts a11y focus back on the original opener.
   * @param opener:Node - the opener element.
   */
  function close(direction) {
    var activeOpenSlideouts = document.querySelectorAll('.slideout--active');
    var openers = document.querySelectorAll(".js-slideout-open");
    var closers = document.querySelectorAll(".js-slideout-close");

    // Close the slideout.
    wrapper.classList.remove("slideout-" + direction + "--open");
    wrapper.classList.add("slideout-" + direction + "--closed");

    // Close all active drawers. This is incase there is more than 1 slide on a direction.
    activeOpenSlideouts.forEach(function (activeSlideoutDrawer) {
      activeSlideoutDrawer.classList.remove('slideout--active');
      var accordionsClosed = activeSlideoutDrawer.getAttribute('data-wau-accordions-closed');
      var activeSlideoutName = activeSlideoutDrawer.getAttribute('data-wau-slideout');
      if (accordionsClosed !== null) {
        WAU.Accordion.hideAll(activeSlideoutName);
      }

      // Set tabindex so it skips hidden slideout
      activeSlideoutDrawer.querySelectorAll('*').forEach(function (item, i) {
        item.setAttribute('tabIndex', '-1');
      });
    });

    // Makes sure aria-expanded false is added to all the open and close buttons.
    openers.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    closers.forEach(function (closer) {
      closer.setAttribute('aria-expanded', 'false');
    });

    // Fix body wrapper so no scrolling on mobile
    var scrollPosition = Math.abs(0 - document.querySelector('.site-wrap').getBoundingClientRect().top);
    wrapper.style.removeProperty('overflow');
    wrapper.style.removeProperty('position');
    wrapper.style.removeProperty('top');
    wrapper.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
  }

  /*
   * @description - Closes a specific slideout given the name in data-wau-slideout attribute
   * @return void
   */
  function closeByName(name) {
    var closer = document.querySelector('[data-wau-slideout-target="' + name + '"]');
    var direction = closer.getAttribute('data-slideout-direction');
    var opener = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + name + '"]');
    close(direction, opener);
  }

  /*
   * @description - Opens a specific slideout given the name in data-wau-slideout attribute
   * @return void
   */
  function openByName(name) {
    var opener = document.querySelector('[data-wau-slideout-target="' + name + '"]');
    var direction = opener.getAttribute('data-slideout-direction');
    var targetSlideoutEl = document.querySelector('[data-wau-slideout="' + name + '"]');
    open(direction, targetSlideoutEl, opener);
  }

  /*
   * @description - Creates a new aside element to be used as a slideout.
   * @param direction:String - the direction that the slideout will open in. "left" or "right"
   * @param name:String - An explicit name to refer to the slideout by on a trigger.
   * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
   */
  function createSlideoutEl(direction, name, wrapperEl) {
    var aside = document.createElement('aside');
    var innerDiv = document.createElement('div');
    var innerContentDiv = document.createElement('div');
    var opener = document.querySelector('[data-wau-slideout-target="' + name + '"]');
    var content = document.querySelector('[data-wau-slideout-content="' + name + '"]');
    var generatedId = "slideout-" + name;
    wrapperEl = wrapperEl || wrapper;
    if (content.hasAttribute('data-wau-accordions-closed')) {
      aside.setAttribute('data-wau-accordions-closed', '');
    }

    // Create outer wrapper
    aside.classList.add('slideout');
    aside.classList.add('slideout__drawer-' + direction);
    aside.setAttribute('data-wau-slideout', name);
    aside.setAttribute('id', generatedId); // setting an id here so that we can set the aria-controls attribute on the opener.

    // Create inner wrapper and move content to it
    innerDiv.classList.add('slideout__inner-wrapper');
    innerDiv.classList.add('slideout__general-slide__wrapper');
    innerContentDiv.innerHTML = content.innerHTML;
    innerContentDiv.classList.add('slideout__inner-content-container');

    // Empty content so no conflict
    content.innerHTML = '';

    // Add close button to Inner
    if (content.dataset.wauSlideoutButton && content.dataset.wauSlideoutButton == 'true') {
      var closeDiv = createCloser(name, direction);
      innerDiv.prepend(closeDiv);
    }

    // Add inner wrapper to outer wrapper
    aside.appendChild(innerDiv);
    innerDiv.appendChild(innerContentDiv);
    opener.setAttribute('aria-controls', generatedId);
    wrapperEl.appendChild(aside);
    return aside;
  }

  /*
   * @description - Empties inner wrapper of slideout and replaces content with previous content
   */
  function reloadSlideoutContents(name) {
    var content = document.querySelector('[data-wau-slideout-content="' + name + '"]');
    var drawer = document.querySelector('aside[data-wau-slideout="' + name + '"]');
    var innerWrapper = drawer.querySelector('.slideout__inner-content-container');
    innerWrapper.innerHTML = content.innerHTML;
  }

  /*
   * @description - Initializes the plugin by adding all of the appropriate event listeners.
   */
  function init(name) {
    if (typeof name === "undefined") {
      console.log("The Slideout must have an associated name.");
      return;
    }
    wrapper = document.querySelector('.js-slideout-toggle-wrapper');
    var slideoutOpeners = document.querySelectorAll('.js-slideout-open[data-wau-slideout-target="' + name + '"]');
    var slideoutTargetEl = undefined;
    slideoutOpeners.forEach(function (slideoutOpener, i) {
      var slideoutDirection = slideoutOpener.getAttribute('data-slideout-direction');
      if (slideoutOpener) {
        slideoutTargetEl = document.querySelector("aside[data-wau-slideout=".concat(name, "]"));
      }
      if (!slideoutTargetEl && window.location.href.indexOf('before-you-checkout') === -1) {
        slideoutTargetEl = createSlideoutEl(slideoutDirection, name, wrapper);
      }

      // Trigger event for outside functions to listen and use
      Events.trigger('slideout:active:' + name);
      slideoutOpener.addEventListener('click', function () {
        if (document.querySelector('body').classList.contains('slideout-left--open')) {
          close('left');
        } else {
          open(slideoutDirection, slideoutTargetEl, slideoutOpener);
        }
      });
    });
    var slideoutClosers = document.querySelectorAll('.js-slideout-close');
    slideoutClosers.forEach(function (slideoutCloser, i) {
      var slideoutCloseDirection = slideoutCloser.getAttribute('data-slideout-direction');
      slideoutCloser.addEventListener('click', function () {
        close(slideoutCloseDirection, slideoutCloser);
      });
    });
  }
  var privateFunctions = {
    openByName: openByName,
    closeByName: closeByName,
    createSlideoutEl: createSlideoutEl,
    reloadSlideoutContents: reloadSlideoutContents
  };
  var returnObj = {};
  returnObj.init = init;

  /*
   * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
   */
  Object.keys(privateFunctions).forEach(function (pf) {
    returnObj['_' + pf] = privateFunctions[pf];
  });
  return returnObj;
}();
WAU.Modal = function () {
  /*
   * Elements
   */
  var wrapper = undefined;
  /*
   * @description - Makes sure that the ESC Key works to close the menus.
   */
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeActiveModal();
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target === document.querySelector(".js-modal-overlay")) {
      closeActiveModal();
    }
  });
  /*
   * @description - Closes the currently active modal.
   */
  function closeActiveModal() {
    // Find the open modal.
    var activeModal = document.querySelector('.modal--active');
    var activeModalName = activeModal.getAttribute('data-wau-modal');
    var closer = activeModal.querySelector('.js-modal-close');
    close(closer);
  }
  /*
   * @description - Checks if the modal is currently open or not.
   * @return Boolean
   */
  function isOpen() {
    wrapper = document.querySelector(".js-modal-toggle-wrapper");
    return wrapper.classList.contains("modal--open");
  }
  /*
   * @description - Open a specific modal.
   * @param targetSlideoutEl:Node - The modal element that will be opened.
   */
  function open(targetModalEl, opener) {
    // Fix body wrapper so no scrolling on mobile
    var scrollPosition = Math.abs(0 - document.querySelector('.site-wrap').getBoundingClientRect().top);
    wrapper.style.top = "-".concat(scrollPosition, "px");
    wrapper.style.width = '100%';

    // Stop from scrolling to top on quickview and modal cart
    if (opener.getAttribute("data-wau-modal-target") == 'quickview') {
      targetModalEl.style.top = "calc(".concat(scrollPosition, "px + 15vh)");
    } else if (targetModalEl.id == 'modal-ajax-cart' && targetModalEl.getAttribute("data-wau-modal") == 'ajax-cart') {
      targetModalEl.style.top = "calc(".concat(scrollPosition, "px + 15vh)");
    }
    if (targetModalEl.hasAttribute("data-wau-modal-full")) {
      wrapper.style.overflowY = 'hidden';
    }
    wrapper.classList.add("modal--open");
    wrapper.classList.remove("modal--closed");
    targetModalEl.classList.add('modal--active');

    // Add specific modal type class
    if (targetModalEl.getAttribute("data-wau-modal")) {
      var elClass = targetModalEl.getAttribute("data-wau-modal"),
        elClass = "modal-" + elClass + "--open";
      wrapper.classList.add(elClass);
    }
    opener.setAttribute("aria-expanded", "true");
  }
  /*
   * @description - Closes all modals. Puts a11y focus back on the original opener.
   * @param opener:Node - the opener element.
   */
  function close(openerEl) {
    var activeOpenModals = document.querySelectorAll('.modal--active');
    var openers = document.querySelectorAll(".js-modal-open");
    var closers = document.querySelectorAll(".js-modal-close");

    // Remove content if quickview
    if (openerEl && openerEl.getAttribute("aria-controls") == 'quickview') {
      document.querySelector('.js-quickview-content').innerHTML = '';
    }

    // Close the Modal.
    wrapper.classList.remove("modal--open");
    wrapper.classList.add("modal--closed");

    // Close all active modals. This is incase there is more than 1..
    activeOpenModals.forEach(function (activeModalDrawer) {
      // Remove specific modal type class
      if (activeModalDrawer.getAttribute("data-wau-modal")) {
        var elClass = activeModalDrawer.getAttribute("data-wau-modal"),
          elClass = "modal-" + elClass + "--open";
        wrapper.classList.remove(elClass);
      }
      activeModalDrawer.classList.remove('modal--active');

      // For full width modal
      if (activeModalDrawer.hasAttribute("data-wau-modal-full")) {
        wrapper.style.overflowY = 'unset';
      }
    });

    // Makes sure aria-expanded false is added to all the open and close buttons.
    openers.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    closers.forEach(function (closer) {
      closer.setAttribute('aria-expanded', 'false');
    });

    // Fix body wrapper so no scrolling on mobile
    wrapper.style.removeProperty('overflow');
    wrapper.style.removeProperty('position');
    wrapper.style.removeProperty('padding-right');
    wrapper.style.removeProperty('top');
    wrapper.style.removeProperty('width');
  }
  /*
   * @description - Closes a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
  function closeByName(name) {
    var closer = document.querySelector('[data-wau-modal-target="' + name + '"]');
    var opener = document.querySelector('.js-modal-open[data-wau-modal-target="' + name + '"]');
    close(opener);
  }
  /*
   * @description - Opens a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
  function openByName(name) {
    var opener = document.querySelector('[data-wau-modal-target="' + name + '"]');
    var targetModalEl = document.querySelector('[data-wau-modal="' + name + '"]');
    open(targetModalEl, opener);
  }
  /*
   * @description - Creates a new close button inside created modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   */
  function createCloser(name) {
    var closeDiv = document.createElement('div');
    var button = document.createElement('button');
    var icon = document.createElement('div');
    closeDiv.classList.add('slideout__trigger--close');
    closeDiv.classList.add('slideout__trigger-' + name + '__wrapper');
    closeDiv.classList.add('slideout__trigger-general-modal__wrapper');
    button.classList.add('slideout__trigger-' + name);
    button.classList.add('slideout__trigger-general-modal');
    button.classList.add('js-modal-close');
    button.setAttribute('aria-controls', 'modal-' + name);
    button.setAttribute('aria-label', 'Close modal');
    icon.classList.add('icn-close');
    button.appendChild(icon);
    closeDiv.appendChild(button);
    return closeDiv;
  }
  /*
   * @description - Creates a new div element to be used as a modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
   */
  function createModalEl(name, wrapperEl) {
    var div = document.createElement('div');
    var innerDiv = document.createElement('div');
    var innerContentDiv = document.createElement('div');
    var opener = document.querySelector('[data-wau-modal-target="' + name + '"]');
    var content = document.querySelector('[data-wau-modal-content="' + name + '"]');
    var generatedId = "modal-" + name;
    wrapperEl = wrapperEl || wrapper;

    // Create outer wrapper
    div.classList.add('modal');
    div.classList.add('modal__container');

    // Set full width
    if (content.hasAttribute('data-wau-modal-full')) {
      div.setAttribute('data-wau-modal-full', '');
    }
    div.setAttribute('data-wau-modal', name);
    div.setAttribute('id', generatedId); // setting an id here so that we can set the aria-controls attribute on the opener.
    // Create inner wrapper and move content to it
    innerDiv.classList.add('modal__inner-wrapper');
    innerDiv.classList.add('modal__general-modal__wrapper');
    innerContentDiv.innerHTML = content.innerHTML;
    innerContentDiv.classList.add('modal__inner-content-container');

    // Add close button to Inner
    var closeDiv = createCloser(name);
    innerDiv.prepend(closeDiv);

    // Add inner wrapper to outer wrapper
    div.appendChild(innerDiv);
    innerDiv.appendChild(innerContentDiv);
    opener.setAttribute('aria-controls', generatedId);
    wrapperEl.appendChild(div);
    return div;
  }
  /*
   * @description - Initializes the plugin by adding all of the appropriate event listeners.
   */
  function init(name) {
    if (typeof name === "undefined") {
      console.log("The Modal must have an associated name.");
      return;
    }
    wrapper = document.querySelector('.js-modal-toggle-wrapper');
    var modalOpeners = document.querySelectorAll('.js-modal-open[data-wau-modal-target="' + name + '"]');
    var modalTargetEl = undefined;
    if (modalOpeners) {
      modalTargetEl = document.querySelector("div[data-wau-modal=".concat(name, "]"));
    }
    if (!modalTargetEl) {
      modalTargetEl = createModalEl(name, wrapper);
    }
    modalOpeners.forEach(function (modalOpener, i) {
      modalOpener.addEventListener('click', function () {
        open(modalTargetEl, modalOpener);
      });
    });
    var modalClosers = document.querySelectorAll('.js-modal-close');
    modalClosers.forEach(function (modalCloser) {
      modalCloser.addEventListener('click', function () {
        close(modalCloser);
      });
    });
  }
  var privateFunctions = {
    openByName: openByName,
    closeByName: closeByName,
    createModalEl: createModalEl
  };
  var returnObj = {};
  returnObj.init = init;
  /*
   * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
   */
  Object.keys(privateFunctions).forEach(function (pf) {
    returnObj['_' + pf] = privateFunctions[pf];
  });
  return returnObj;
}();
WAU.Accordion = function () {
  var classes = {
    show: "is-active",
    open: "js-accordion-is-open",
    mobileNavAccordion: "js-accordion-mobile-nav"
  };
  var selectors = {
    accordion: ".js-accordion",
    accordionItem: '.c-accordion__item',
    accordionLink: ".js-accordion-link",
    accordionHeader: ".js-accordion-header",
    accordionPanel: ".c-accordion__panel"
  };
  var publicAPIs = {};

  /*
   * @description strips class period
   */
  var stripClassPeriod = function stripClassPeriod(className) {
    if (!className) return;
    return className.split('.')[1];
  };

  /*
   * @description returns class naem
   */
  publicAPIs.getConfigClass = function (className) {
    if (!className) return;
    if (classes[className] && classes[className] != '') {
      return classes[className];
    } else {
      return false;
    }
  };

  /*
   * @description Hides an accordion item
   */
  publicAPIs.hide = function (target) {
    target.setAttribute("aria-expanded", "false");
    target.parentNode.classList.remove('accordion-expanded');
    $("#".concat(target.getAttribute("aria-controls"))).attr('hidden', '').slideUp(200);
  };

  /*
   * @description Hides all accordion items at once
   */
  publicAPIs.hideAll = function (name) {
    var accordion = document.querySelector('[data-accordion-family="' + name + '"]');
    if (!accordion) return false;
    var accordionHeaders = document.querySelectorAll('[data-accordion-family="' + name + '"] > .js-accordion-header');
    accordionHeaders.forEach(function (item, i) {
      var target = item.querySelector('[data-toggle="accordion"]');

      // Close each accordion item
      target.setAttribute("aria-expanded", "false");
      target.parentNode.classList.remove('accordion-expanded');
      $("#".concat(target.getAttribute("aria-controls"))).attr('hidden', '').slideUp(200);
    });
  };

  /*
   * @description Shows an accordion item
   */
  publicAPIs.show = function (target, allowMultiple) {
    if (!target.hasAttribute('aria-controls')) return;
    var panel = document.querySelector("#".concat(target.getAttribute("aria-controls")));
    var parentElement = target.closest(panel.getAttribute("data-parent"));
    var allowMultipleFlag = allowMultiple || parentElement.hasAttribute("data-accordion-allow-multiple") ? true : false;
    var isMobileNav = parentElement.classList.contains(classes.mobileNavAccordion);
    if (!allowMultipleFlag && panel.hasAttribute("data-parent")) {
      var childSelector = '';
      if (isMobileNav) {
        childSelector = ':scope > li > [aria-expanded="true"]';
      } else {
        childSelector = ':scope > [aria-expanded="true"]';
      }
      if (!childSelector) {
        return;
      }
      var activePanels = target.closest(panel.getAttribute("data-parent")).querySelectorAll(childSelector);
      if (!activePanels) {
        return;
      }
      activePanels.forEach(function (element) {
        publicAPIs.hide(element);
      });
    }
    target.setAttribute("aria-expanded", "true");
    target.parentNode.classList.add('accordion-expanded');
    panel.removeAttribute("hidden");
    $("#".concat(target.getAttribute("aria-controls"))).slideDown(200);
  };

  /*
   * @description Toggle showing and hiding an accordion item
   */
  publicAPIs.toggle = function (target, allowMultiple) {
    if (target.getAttribute("aria-expanded") == "true") {
      publicAPIs.hide(target);
      return;
    } else {
      publicAPIs.show(target, allowMultiple);
    }
  };

  /*
   * @description Initialize function
   */
  publicAPIs.init = function () {
    // Hide add accordion panels
    document.querySelectorAll("[data-toggle=\"accordion\"]:not(.".concat(classes.open, ")")).forEach(function (element, index) {
      publicAPIs.hide(element);
    });

    // Add keyboard accessibility events
    document.addEventListener('keydown', function (event) {
      var target = event.target;
      var key = event.which && event.which.toString();
      var disablePageScroll = false;
      var pageScrollOptions = disablePageScroll ? {
        preventScroll: true
      } : {
        preventScroll: false
      };
      var isDropDownArrow = target.classList.contains('dropdown-arrow');
      if (target.classList.contains(stripClassPeriod(selectors.accordionHeader)) || target.classList.contains(stripClassPeriod(selectors.accordionLink)) || isDropDownArrow) {
        if (key.match(/38|40/)) {
          var _isMobile = target.closest(selectors.accordion).classList.contains(classes.mobileNavAccordion) ? true : false;
          var accordionSelector = _isMobile ? ":scope > li > ".concat(selectors.accordionLink) : ":scope > ".concat(selectors.accordionHeader);
          var accordions = target.closest(selectors.accordion).querySelectorAll(accordionSelector);
          if (_isMobile && isDropDownArrow) {
            target.previousElementSibling.focus(pageScrollOptions);
            return;
          }
          var indexPlace;
          accordions.forEach(function (element, index) {
            if (element == target) {
              indexPlace = index;
            }
          });
          var direction = key.match(/34|40/) ? 1 : -1;
          var length = accordions.length;
          var newIndex = (indexPlace + length + direction) % length;
          accordions[newIndex].focus(pageScrollOptions);
        }
      }
    });
    document.addEventListener("click", function (event) {
      var target = event.target.matches('[data-toggle="accordion"]') ? event.target : event.target.closest('[data-toggle="accordion"]');
      if (!target) {
        var header = event.target.closest('.js-accordion-header');
        if (header && !event.target.closest('.js-accordion-link')) {
          target = header.querySelector('[data-toggle="accordion"]');
        }
      }
      if (!target) {
        return false;
      }
      event.preventDefault();
      publicAPIs.toggle(target);
    });
    document.addEventListener("click", function (event) {
      var isMobile = $(window).width() <= 980;
      if (isMobile && event.target.classList.contains('js-accordion-link') || !isMobile && event.target.getAttribute('href') == '') {
        if ($(event.target).siblings('button').length > 0) {
          event.preventDefault();
          var target = event.target.parentNode.querySelector('[data-toggle="accordion"]');
          publicAPIs.toggle(target);
        }
      }
    });
  };
  return publicAPIs;
}();

/*============================================================================
 Theme Functions
==============================================================================*/
window.theme = window.theme || {};
theme.a11yHelpers = function () {
  var alreadySetUpKeyEvents = false;

  /*
   * @description - Sets up the aria-expanded property to true and false on hover.
   */
  function setUpAriaExpansion() {
    var ariaExpandEls = document.querySelectorAll('.js-aria-expand');
    ariaExpandEls.forEach(function (ariaExpandEl) {
      ariaExpandEl.addEventListener('mouseover', function (event) {
        ariaExpandEl.setAttribute('aria-expanded', 'true');
      });
      ariaExpandEl.addEventListener('mouseout', function (event) {
        ariaExpandEl.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /*
  * @description - Takes a parent element and focuses on the next focusable element inside of there.
  */
  function focusOnElement(parent) {
    var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    var elementToFocusOn = parent.querySelector(focussableElements);
    if (elementToFocusOn) {
      elementToFocusOn.focus();
    }
  }
  function findFocusableElement(parent, element, direction) {
    var focusableElementSelectors = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    var focusableElements = parent.querySelectorAll(focusableElementSelectors);
    var numOfFocusableElements = focusableElements.length;
    var elementIndex = 0;
    for (var i = 0; i < focusableElements.length; i += 1) {
      var currentElement = focusableElements[i];
      if (currentElement === element) {
        elementIndex = i;
      }
    }
    if (direction === 'next') {
      if (elementIndex === numOfFocusableElements - 1) {
        return focusableElements[0];
      } else {
        return focusableElements[elementIndex + 1];
      }
    }
    if (direction === 'prev') {
      if (elementIndex === 0) {
        return focusableElements[numOfFocusableElements - 1];
      } else {
        return focusableElements[elementIndex - 1];
      }
    }
  }

  /*
   * @description - Takes a parent and a dom node and returns the next element that is focusable that is not the current element.
   * @param parent:DOMNode
   * @param element:DOMNode
   * @return DOMNode
   */
  function findNextFocusableElement(parent, element) {
    return findFocusableElement(parent, element, 'next');
  }
  function findPreviousFocusableElement(parent, element) {
    return findFocusableElement(parent, element, 'prev');
  }

  /*
  * @description - Enables accessible keyboard navigation throughout the navigation menus.
  */
  function setUpAccessibleNavigationMenus() {
    function closeDropdownMenus() {
      var activeMenuItems = document.querySelectorAll('.navigation__menuitem--active');
      activeMenuItems.forEach(function (activeMenuItem) {
        activeMenuItem.classList.remove('navigation__menuitem--active');
        activeMenuItem.setAttribute('aria-expanded', 'false');
      });
    }
    function closeNestedDropdownMenus() {
      //remove the class that makes the dropdown show... the active class
      var nestedDropdowns = document.querySelectorAll(".js-menuitem-with-nested-dropdown");
      nestedDropdowns.forEach(function (nestedDropdown) {
        nestedDropdown.classList.remove("dropdown__menuitem--active");
        nestedDropdown.setAttribute('aria-expanded', 'false');
      });
    }
    function closeNestedMegaMenuDropdownMenus() {
      var nestedDropdowns = document.querySelectorAll(".js-megamenu-listitem-with-nested-dropdown");
      nestedDropdowns.forEach(function (nestedDropdown) {
        nestedDropdown.classList.remove("megamenu__listitem--active");
        nestedDropdown.setAttribute('aria-expanded', 'false');
      });
    }
    function addEdgeToDropdown(dropdown) {
      setTimeout(function () {
        if (theme.DOMHelpers.isElementPastEdge(dropdown)) {
          dropdown.classList.add("dropdown--edge");
        } else {
          dropdown.classList.remove("dropdown--edge");
        }
      }, 0);
    }
    if (!alreadySetUpKeyEvents) {
      document.addEventListener('keyup', function (event) {
        if (event.key === 'Escape') {
          var openNestedDropdownMenus = document.querySelectorAll(".dropdown__menuitem--active"),
            openDropdownMenus = document.querySelectorAll(".navigation__menuitem--active"),
            openMegaMenuNestedDropdownMenus = document.querySelectorAll(".megamenu__listitem--active");
          event.preventDefault();
          if (openNestedDropdownMenus.length >= 1) {
            closeNestedDropdownMenus();
            return;
          }
          if (openMegaMenuNestedDropdownMenus.length >= 1) {
            closeNestedMegaMenuDropdownMenus();
            return;
          }
          if (openDropdownMenus.length >= 1) {
            closeDropdownMenus();
            return;
          }
        }
      });
    }
    if (!alreadySetUpKeyEvents) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          if (document.activeElement.classList.contains("js-open-dropdown-on-key") || document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown") || document.activeElement.parentNode.classList.contains("js-megamenu-listitem-with-nested-dropdown")) {
            event.stopPropagation();
            event.preventDefault();
          }
          if (document.activeElement.parentNode.classList.contains("navigation__menuitem--active")) {
            closeDropdownMenus();
            return;
          }
          if (document.activeElement.parentNode.classList.contains("dropdown__menuitem--active")) {
            closeNestedDropdownMenus();
            return;
          }
          if (document.activeElement.parentNode.classList.contains("megamenu__listitem--active")) {
            closeNestedMegaMenuDropdownMenus();
            return;
          }
          if (document.activeElement.classList.contains("js-open-dropdown-on-key")) {
            document.activeElement.parentNode.classList.add("navigation__menuitem--active"); // Show the menu by adding the appropriate class.
            return;
          }
          if (document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown")) {
            document.activeElement.parentNode.classList.add("dropdown__menuitem--active");
            addEdgeToDropdown(document.activeElement.parentNode);
            return;
          }
          if (document.activeElement.parentNode.classList.contains("js-megamenu-listitem-with-nested-dropdown")) {
            document.activeElement.parentNode.classList.add("megamenu__listitem--active");
            addEdgeToDropdown(document.activeElement.parentNode);
            return;
          }
        }
      });
    }
    alreadySetUpKeyEvents = true;
  }
  return {
    setUpAriaExpansion: setUpAriaExpansion,
    setUpAccessibleNavigationMenus: setUpAccessibleNavigationMenus,
    focusOnElement: focusOnElement
  };
}();
theme.DOMHelpers = function () {
  /*
   * @description - Determines if an element is off screen or not.
   * @param element:<Node> - A DOMNode
   * @return Boolean
   */
  function isElementPastEdge(element) {
    var bounding = element.getBoundingClientRect(),
      l = bounding.left,
      w = bounding.width,
      docH = document.documentElement.clientHeight,
      docW = document.documentElement.clientWidth;
    return l + w >= docW;
  }

  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - Elements of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */

  function wrapTable(options) {
    options.tables.forEach(function (table) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.tableWrapperClass);
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  function wrapIframe(options) {
    options.iframes.forEach(function (iframe) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.iframeWrapperClass);
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
      iframe.src = iframe.src;
    });
  }

  /*
   * @description - Adjust element's x (horizontal) position to be on screen
   * @param element: <node> - A DOM element
   * @param number:         - How much padding to add
   * @return Boolean
   */
  function adjustElementXPosition(element, padding) {
    var bounding = element.getBoundingClientRect(),
      l = bounding.left,
      w = bounding.width,
      docH = document.documentElement.clientHeight,
      docW = document.documentElement.clientWidth;
    var adjustAmount = l + w - docW;
    if (adjustAmount > 0) {
      element.style.transform = "translateX(-".concat(adjustAmount + padding, "px)");
      return true;
    } else {
      return false;
    }
  }
  return {
    isElementPastEdge: isElementPastEdge,
    wrapIframe: wrapIframe,
    wrapTable: wrapTable,
    adjustElementXPosition: adjustElementXPosition
  };
}();
theme.Helpers = function () {
  var touchDevice = false;
  function setTouch() {
    touchDevice = true;
  }
  function isTouch() {
    return touchDevice;
  }
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
  function makeSticky(amountToScroll, elementClass, elementHeight) {
    var clearElement = document.querySelector(".js-clear-element"),
      stickyElement = document.querySelector(elementClass),
      bodyElement = document.querySelector('body'),
      height = elementHeight + "px";
    amountToScroll = Math.max(amountToScroll, 0);
    if (window.pageYOffset > amountToScroll) {
      stickyElement.classList.add('sticky--active');
      bodyElement.classList.add('sticky-header');
      clearElement.style.height = height;
      setHeaderOffset();
    } else if (!bodyElement.classList.contains('slideout-right--open')) {
      stickyElement.classList.remove('sticky--active');
      bodyElement.classList.remove('sticky-header');
      clearElement.style.height = "0px";
      setHeaderOffset();
    }
  }
  function animateCSS(element, animation) {
    var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'animate__';
    return new Promise(function (resolve, reject) {
      var animationName = "".concat(prefix).concat(animation);
      // const node = document.querySelector(element);
      var node = element;
      node.classList.add("".concat(prefix, "animated"), animationName);

      // When the animation ends, we clean the classes and resolve the Promise
      function handleAnimationEnd() {
        node.classList.remove("".concat(prefix, "animated"), animationName);
        resolve('Animation ended');
      }
      node.addEventListener('animationend', handleAnimationEnd, {
        once: true
      });
    });
  }
  ;
  function Toggle(id) {
    var element = document.getElementById(id);
    if (element.classList.contains('animate-hide')) {
      element.classList.remove("animate-hide", "fadeOut");
      element.classList.add("animate-show", "fadeIn");
      element.style.visibility = "visible";
    } else {
      element.classList.remove("animate-show", "fadeIn");
      element.classList.add("animate-hide", "fadeOut");
      element.style.visibility = "hidden";
    }
  }
  function toggleClass(id, className) {
    var element = document.getElementById(id);
    if (!element) return false;
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }
  function Accordion(container, tlink, submenu) {
    var accorContent = container.querySelector(submenu);
    if (!container.querySelector(tlink)) return false;
    container.querySelector(tlink).addEventListener('click', function (event) {
      event.preventDefault();

      // Toggle class on label and update a11y
      if (this.classList.contains('closed')) {
        this.classList.remove('closed');
        this.parentElement.classList.remove('closed');
        this.setAttribute('aria-expanded', 'true');
      } else {
        this.classList.add('closed');
        this.parentElement.classList.add('closed');
        this.setAttribute('aria-expanded', 'false');
      }

      // Show content
      if (accorContent.classList.contains('closed')) {
        accorContent.classList.remove("closed");
        accorContent.style.display = "block";
      } else {
        accorContent.classList.add("closed");
        accorContent.style.display = "none";
      }
    });
  }
  function fadeOut(el) {
    if (!el) {
      return;
    }
    el.style.opacity = 1;
    (function fade() {
      if ((el.style.opacity -= .1) < 0) {
        el.style.display = "none";
      } else {
        requestAnimationFrame(fade);
      }
    })();
  }
  function fadeIn(el, display) {
    if (!el) {
      return;
    }
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += .1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
    })();
  }
  function getScrollbarWidth() {
    // Creating invisible container
    var outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    var inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    var scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }
  function smoothScrollTo(endX, endY, duration) {
    var startX = window.scrollX || window.pageXOffset,
      startY = window.scrollY || window.pageYOffset,
      distanceX = endX - startX,
      distanceY = endY - startY,
      startTime = new Date().getTime();
    // Easing function
    var easeInOutQuart = function easeInOutQuart(time, from, distance, duration) {
      if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
      return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
    };
    var timer = window.setInterval(function () {
      var time = new Date().getTime() - startTime,
        newX = easeInOutQuart(time, startX, distanceX, duration),
        newY = easeInOutQuart(time, startY, distanceY, duration);
      if (time >= duration) {
        window.clearInterval(timer);
      }
      window.scrollTo(newX, newY);
    }, 1000 / 60); // 60 fps
  }
  function formatMoney(cents, format) {
    var moneyFormat = '${{amount}}';
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    function formatWithDelimiters(number) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
      var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(thousands));
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    setTouch: setTouch,
    isTouch: isTouch,
    debounce: debounce,
    makeSticky: makeSticky,
    animateCSS: animateCSS,
    Toggle: Toggle,
    toggleClass: toggleClass,
    Accordion: Accordion,
    fadeOut: fadeOut,
    fadeIn: fadeIn,
    getScrollbarWidth: getScrollbarWidth,
    smoothScrollTo: smoothScrollTo,
    formatMoney: formatMoney
  };
}();
theme.LibraryLoader = function () {
  var types = {
    link: 'link',
    script: 'script'
  };
  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };
  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };
  function load(libraryName, callback) {
    var library = libraries[libraryName];
    if (!library) return;
    if (library.status === status.requested) return;
    callback = callback || function () {};
    if (library.status === status.loaded) {
      callback();
      return;
    }
    library.status = status.requested;
    var tag;
    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }
    tag.id = library.tagId;
    library.element = tag;
    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }
  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }
  return {
    load: load
  };
}();
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
  document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
  document.addEventListener('shopify:section:select', this._onSelect.bind(this));
  document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
  document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
  document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');
    constructor = constructor || this.constructors[type];
    if (typeof constructor === 'undefined') {
      return;
    }
    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });
    this.instances.push(instance);
  },
  _onSectionLoad: function _onSectionLoad(evt) {
    var container = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]');
    if (container) {
      this._createInstance(container);
    }
  },
  _onSectionUnload: function _onSectionUnload(evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;
      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },
  _onSelect: function _onSelect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });
    if (typeof instance !== 'undefined' && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },
  _onDeselect: function _onDeselect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });
    if (typeof instance !== 'undefined' && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },
  _onBlockSelect: function _onBlockSelect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });
    if (typeof instance !== 'undefined' && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },
  _onBlockDeselect: function _onBlockDeselect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });
    if (typeof instance !== 'undefined' && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },
  register: function register(type, constructor) {
    this.constructors[type] = constructor;
    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(function (container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
theme.Disclosure = function () {
  var selectors = {
    disclosureForm: '[data-disclosure-form]',
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };
  var classes = {
    listVisible: 'disclosure-list--visible'
  };
  function Disclosure(disclosure) {
    this.container = disclosure;
    this._cacheSelectors();
    this._setupListeners();
  }
  Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
    _cacheSelectors: function _cacheSelectors() {
      this.cache = {
        disclosureForm: this.container.closest(selectors.disclosureForm),
        disclosureList: this.container.querySelector(selectors.disclosureList),
        disclosureToggle: this.container.querySelector(selectors.disclosureToggle),
        disclosureInput: this.container.querySelector(selectors.disclosureInput),
        disclosureOptions: this.container.querySelectorAll(selectors.disclosureOptions)
      };
    },
    _setupListeners: function _setupListeners() {
      this.eventHandlers = this._setupEventHandlers();
      this.cache.disclosureToggle.addEventListener('click', this.eventHandlers.toggleList);
      this.cache.disclosureOptions.forEach(function (disclosureOption) {
        disclosureOption.addEventListener('click', this.eventHandlers.connectOptions);
      }, this);
      this.container.addEventListener('keyup', this.eventHandlers.onDisclosureKeyUp);
      this.cache.disclosureList.addEventListener('focusout', this.eventHandlers.onDisclosureListFocusOut);
      this.cache.disclosureToggle.addEventListener('focusout', this.eventHandlers.onDisclosureToggleFocusOut);
      document.body.addEventListener('click', this.eventHandlers.onBodyClick);
    },
    _setupEventHandlers: function _setupEventHandlers() {
      return {
        connectOptions: this._connectOptions.bind(this),
        toggleList: this._toggleList.bind(this),
        onBodyClick: this._onBodyClick.bind(this),
        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
      };
    },
    _connectOptions: function _connectOptions(event) {
      event.preventDefault();
      this._submitForm(event.currentTarget.dataset.value);
    },
    _onDisclosureToggleFocusOut: function _onDisclosureToggleFocusOut(event) {
      var disclosureLostFocus = this.container.contains(event.relatedTarget) === false;
      if (disclosureLostFocus) {
        this._hideList();
      }
    },
    _onDisclosureListFocusOut: function _onDisclosureListFocusOut(event) {
      var childInFocus = event.currentTarget.contains(event.relatedTarget);
      var isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);
      if (isVisible && !childInFocus) {
        this._hideList();
      }
    },
    _onDisclosureKeyUp: function _onDisclosureKeyUp(event) {
      if (event.which !== 27) return;
      this._hideList();
      this.cache.disclosureToggle.focus();
    },
    _onBodyClick: function _onBodyClick(event) {
      var isOption = this.container.contains(event.target);
      var isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);
      if (isVisible && !isOption) {
        this._hideList();
      }
    },
    _submitForm: function _submitForm(value) {
      this.cache.disclosureInput.value = value;
      this.cache.disclosureForm.submit();
    },
    _hideList: function _hideList() {
      this.cache.disclosureList.classList.remove(classes.listVisible);
      this.cache.disclosureToggle.setAttribute('aria-expanded', false);
    },
    _toggleList: function _toggleList() {
      var ariaExpanded = this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
      this.cache.disclosureList.classList.toggle(classes.listVisible);
      this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
    },
    destroy: function destroy() {
      this.cache.disclosureToggle.removeEventListener('click', this.eventHandlers.toggleList);
      this.cache.disclosureOptions.forEach(function (disclosureOption) {
        disclosureOption.removeEventListener('click', this.eventHandlers.connectOptions);
      }, this);
      this.container.removeEventListener('keyup', this.eventHandlers.onDisclosureKeyUp);
      this.cache.disclosureList.removeEventListener('focusout', this.eventHandlers.onDisclosureListFocusOut);
      this.cache.disclosureToggle.removeEventListener('focusout', this.eventHandlers.onDisclosureToggleFocusOut);
      document.body.removeEventListener('click', this.eventHandlers.onBodyClick);
    }
  });
  return Disclosure;
}();

/*============================================================================
 Shopify Functions
==============================================================================*/
Shopify.theme.cart = function (exports) {
  'use strict';

  function getDefaultRequestConfig() {
    return JSON.parse(JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
      }
    }));
  }
  function fetchJSON(url, config) {
    return fetch(url, config).then(function (response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  function cart() {
    return fetchJSON(window.Shopify.routes.root + 'cart.js', getDefaultRequestConfig());
  }
  function cartAdd(id, attrs) {
    var config = getDefaultRequestConfig();
    config.method = 'POST';
    var body = {
      id: id,
      quantity: attrs.quantity,
      properties: attrs.properties
    };
    if (attrs.selling_plan) {
      body['selling_plan'] = attrs.selling_plan;
    }
    config.body = JSON.stringify(body);
    return fetchJSON(window.Shopify.routes.root + 'cart/add.js', config);
  }
  function cartAddMultiple(items) {
    var config = getDefaultRequestConfig();
    config.method = 'POST';
    var body = {
      items: items
    };
    config.body = JSON.stringify(body);
    return fetchJSON(window.Shopify.routes.root + 'cart/add.js', config);
  }
  function cartAddFromForm(formData) {
    var config = getDefaultRequestConfig();
    delete config.headers['Content-Type'];
    config.method = 'POST';
    config.body = formData;
    return fetchJSON(window.Shopify.routes.root + 'cart/add.js', config);
  }
  function cartChange(line, options) {
    var config = getDefaultRequestConfig();
    options = options || {};
    config.method = 'POST';
    config.body = JSON.stringify({
      line: line,
      quantity: options.quantity,
      properties: options.properties
    });
    return fetchJSON(window.Shopify.routes.root + 'cart/change.js', config);
  }
  function cartClear() {
    var config = getDefaultRequestConfig();
    config.method = 'POST';
    return fetchJSON(window.Shopify.routes.root + 'cart/clear.js', config);
  }
  function cartUpdate(body) {
    var config = getDefaultRequestConfig();
    config.method = 'POST';
    config.body = JSON.stringify(body);
    return fetchJSON(window.Shopify.routes.root + 'cart/update.js', config);
  }
  function cartRemove(items) {
    if (items.length === 0) return;
    var updates = {};
    items.forEach(function (i) {
      updates[i] = 0;
    });
    return cartUpdate({
      updates: updates
    });
  }
  function cartShippingRates() {
    return fetchJSON('/cart/shipping_rates.json', getDefaultRequestConfig());
  }
  function key(key) {
    if (typeof key !== 'string' || key.split(':').length !== 2) {
      throw new TypeError('Theme Cart: Provided key value is not a string with the format xxx:xxx');
    }
  }
  function quantity(quantity) {
    if (typeof quantity !== 'number' || isNaN(quantity)) {
      throw new TypeError('Theme Cart: An object which specifies a quantity or properties value is required');
    }
  }
  function id(id) {
    if (typeof id !== 'number' || isNaN(id)) {
      throw new TypeError('Theme Cart: Variant ID must be a number');
    }
  }
  function properties(properties) {
    if (_typeof(properties) !== 'object') {
      throw new TypeError('Theme Cart: Properties must be an object');
    }
  }
  function form(form) {
    if (!(form instanceof HTMLFormElement)) {
      throw new TypeError('Theme Cart: Form must be an instance of HTMLFormElement');
    }
  }
  function options(options) {
    if (_typeof(options) !== 'object') {
      throw new TypeError('Theme Cart: Options must be an object');
    }
    if (typeof options.quantity === 'undefined' && typeof options.properties === 'undefined') {
      throw new Error('Theme Cart: You muse define a value for quantity or properties');
    }
    if (typeof options.quantity !== 'undefined') {
      quantity(options.quantity);
    }
    if (typeof options.properties !== 'undefined') {
      properties(options.properties);
    }
  }

  /**
   * Cart Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly couple code to the Cart template.
   *
   * @namespace cart
   */

  /**
   * Returns the state object of the cart
   * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
   */
  function getState() {
    return cart().then(function (cart) {
      Events.trigger("cart:ready", cart);
    });
  }

  /**
   * Returns the object of the cart
   * @returns {Promise} Resolves with the object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
   */
  function getCart() {
    return cart().then(function (cart) {
      return cart;
    });
  }

  /**
   * Returns the index of the cart line item
   * @param {string} key The unique key of the line item
   * @returns {Promise} Resolves with the index number of the line item
   */
  function getItemIndex(key$$1) {
    key(key$$1);
    return cart().then(function (state) {
      var index = -1;
      state.items.forEach(function (item, i) {
        index = item.key === key$$1 ? i + 1 : index;
      });
      if (index === -1) {
        return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
      }
      return index;
    });
  }

  /**
   * Fetches the line item object
   * @param {string} key The unique key of the line item
   * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
   */
  function getItem(key$$1) {
    key(key$$1);
    return cart().then(function (state) {
      var lineItem = null;
      state.items.forEach(function (item) {
        lineItem = item.key === key$$1 ? item : lineItem;
      });
      if (lineItem === null) {
        return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
      }
      return lineItem;
    });
  }

  /**
   * Add a new line item to the cart
   * @param {number} id The variant's unique ID
   * @param {object} options Optional values to pass to /cart/add.js
   * @param {number} options.quantity The quantity of items to be added to the cart
   * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
   * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
   */
  function addItem(id$$1, options$$1) {
    options$$1 = options$$1 || {};
    id(id$$1);
    return cartAdd(id$$1, options$$1);
  }

  /**
   * Add a new line item to the cart from a product form
   * @param {object} form DOM element which is equal to the <form> node
   * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
   */
  function addItemFromForm(form$$1) {
    form(form$$1);
    var formData = new FormData(form$$1);
    id(parseInt(formData.get('id'), 10));
    return cartAddFromForm(formData);
  }

  /**
   * Changes the quantity and/or properties of an existing line item.
   * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
   * @param {object} options Optional values to pass to /cart/add.js
   * @param {number} options.quantity The quantity of items to be added to the cart
   * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
   * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
   */
  function updateItem(key$$1, options$$1) {
    key(key$$1);
    options(options$$1);
    return getItemIndex(key$$1).then(function (line) {
      return cartChange(line, options$$1);
    });
  }

  /**
   * Removes a line item from the cart
   * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
   * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
   */
  function removeItem(key$$1) {
    key(key$$1);
    return getItemIndex(key$$1).then(function (line) {
      return cartChange(line, {
        quantity: 0
      });
    });
  }

  /**
   * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
   * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
   */
  function clearItems() {
    return cartClear().then(function () {
      Events.trigger("cart:clear");
    });
  }

  /**
   * Gets all cart attributes
   * @returns {Promise} Resolves with the cart attributes object
   */
  function getAttributes() {
    return cart().then(function (state) {
      return state.attributes;
    });
  }

  /**
   * Sets all cart attributes
   * @returns {Promise} Resolves with the cart state object
   */
  function updateAttributes(attributes) {
    return cartUpdate({
      attributes: attributes
    });
  }

  /**
   * Clears all cart attributes
   * @returns {Promise} Resolves with the cart state object
   */
  function clearAttributes() {
    return getAttributes().then(function (attributes) {
      for (var key$$1 in attributes) {
        attributes[key$$1] = '';
      }
      return updateAttributes(attributes);
    });
  }

  /**
   * Gets cart note
   * @returns {Promise} Resolves with the cart note string
   */
  function getNote() {
    return cart().then(function (state) {
      return state.note;
    });
  }

  /**
   * Sets cart note
   * @returns {Promise} Resolves with the cart state object
   */
  function updateNote(note) {
    return cartUpdate({
      note: note
    });
  }

  /**
   * Clears cart note
   * @returns {Promise} Resolves with the cart state object
   */
  function clearNote() {
    return cartUpdate({
      note: ''
    });
  }

  /**
   * Get estimated shipping rates.
   * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
   */
  function getShippingRates() {
    return cartShippingRates();
  }
  function checkTrial(conf, Cart) {
    var _gObj$trial;
    var hasTrial = false;
    var remove = [];
    var config = getDefaultRequestConfig();
    var trialProduct = (_gObj$trial = gObj.trial) !== null && _gObj$trial !== void 0 ? _gObj$trial : false;
    var isEligible = trialProduct && (typeof gObj.customerTags === 'undefined' || gObj.customerTags.indexOf('member') === -1);
    var regularItems = false;
    var manuallyAdded = false;
    if (Cart.items.length > 0) {
      Cart.items.forEach(function (i) {
        if (i.price == 0 && i.title.toLowerCase().indexOf('trial') !== -1) {
          hasTrial = true;
          if (i.properties['_trial_added']) {
            isEligible = true;
            regularItems = true;
          }
          if (!isEligible) {
            remove.push(i.id);
          }
        } else if (i.title.toLowerCase().indexOf('membership') !== -1) {
          isEligible = false;
        } else {
          regularItems = true;
        }
      });
    }
    if (!regularItems || sessionStorage.getItem('trial_removed')) {
      isEligible = false;
    }
    if (trialProduct) {
      if (isEligible && !hasTrial) {
        console.log('Adding Trial');
        cartAdd(trialProduct.id, {
          'quantity': 1,
          'selling_plan': trialProduct.selling_plan,
          'properties': {
            '_is_membership_plan': true
          }
        }).then(function (item) {
          getCart().then(function (Cart) {
            Shopify.theme.ajaxCart.updateView(conf, Cart);
          });
        });
      } else if (!isEligible && hasTrial) {
        console.log('Removing Trial');
        remove.push(trialProduct.id);
      }
    }
    if (remove.length > 0) {
      cartRemove(remove).then(function (Cart) {
        Shopify.theme.ajaxCart.updateView(conf, Cart);
      });
    }
  }
  function checkGiftWrap(conf, Cart) {
    var isEligible = false;
    var hasWrap = false;
    var remove = [];
    var giftWrap = gObj.gift.wrap_product;
    var giftMessageCheckbox = document.querySelector('.gift-wrap-toggle');
    if (!giftMessageCheckbox) return;
    var giftMessageEnabled = giftMessageCheckbox.checked;
    if (Cart.items.length > 0) {
      Cart.items.forEach(function (i) {
        if (i.id == giftWrap) {
          hasWrap = true;
        } else if (document.querySelector('#mini-cart [data-item-id="' + i.id + '"][data-gift-wrap-eligible="true"]')) {
          isEligible = true;
        }
      });
    }
    document.getElementById('gift-wrap-price').style.display = isEligible ? 'inline' : 'none';
    if (!giftMessageEnabled) {
      isEligible = false;
    }
    if (!isEligible && hasWrap) {
      remove.push(giftWrap);
    }
    if (!hasWrap && isEligible && giftMessageEnabled) {
      console.log('🎁 Adding Gift Wrap');
      cartAdd(giftWrap, {
        'quantity': 1
      }).then(function (item) {
        getCart().then(function (Cart) {
          Shopify.theme.ajaxCart.updateView(conf, Cart);
        });
      });
    } else if (remove.length > 0) {
      console.log('🎁 Removing Gift Wrap');
      cartRemove(remove).then(function (Cart) {
        Shopify.theme.ajaxCart.updateView(conf, Cart);
      });
    }
  }
  function checkGWP(conf, Cart) {
    var eligibleSubtotal = false;
    var eligibleCustomer = false;
    var eligibleVariants = false;
    var gift = false;
    var tagGift = false;
    var giftPrice = 0;
    var hasGift = false;
    var hasTagGift = false;
    var hasRegular = false;
    var isEligible = false;
    var remove = [];
    var config = getDefaultRequestConfig();
    if (typeof gObj.gwp !== 'undefined') {
      eligibleSubtotal = gObj.gwp.eligibility.subtotal * 100; // Shopify cart is in cents
      eligibleCustomer = gObj.gwp.eligibility.customer;
      eligibleVariants = gObj.gwp.eligibility.products;
      gift = gObj.gwp.product;
    }
    if (typeof gObj.gwt !== 'undefined') {
      tagGift = gObj.gwt.product;
    }
    if (Cart.items.length > 0) {
      Cart.items.forEach(function (i) {
        if (i.id == gift || i.id == tagGift) {
          hasGift = true;
          if (i.id == tagGift) {
            hasTagGift = true;
          }
          if (typeof gObj.gwp !== 'undefined' && !gObj.gwp.eligibility.automatic_discount) {
            giftPrice = i.price;
          }
        }
      });
      var hasPaidItems = false;
      var hasEligibleVariant = false;
      Cart.items.forEach(function (i) {
        if (i.id != gift && i.id != tagGift) {
          if (i.price == 0 && i.title.toLowerCase().indexOf('trial') === -1) {
            remove.push(i.id);
          } else {
            hasPaidItems = true;
            if (eligibleVariants && eligibleVariants.length) {
              if (eligibleVariants.includes(i.id)) {
                hasEligibleVariant = true;
              } else {
                hasRegular = true;
              }
            }
          }
        }
      });

      // Each eligibility factor only applies when its setting is configured
      if (gift && hasPaidItems) {
        var meetsProducts = !eligibleVariants || !eligibleVariants.length || hasEligibleVariant;
        var meetsSubtotal = !eligibleSubtotal || Cart.total_price - giftPrice >= eligibleSubtotal;
        var isMember = !!(getCustomerId() && typeof gObj.customerTags !== 'undefined' && gObj.customerTags.includes('member'));
        var wantsNonMembers = eligibleCustomer && eligibleCustomer.indexOf('non') === 0;
        var meetsCustomer = !eligibleCustomer || (wantsNonMembers ? !isMember : isMember);
        isEligible = meetsProducts && meetsSubtotal && meetsCustomer;
      }
      if (!isEligible && tagGift && (!hasGift || Cart.items.length > 1)) {
        isEligible = true;
        gift = tagGift;
      }
    }
    if (isEligible) {
      var loc = getLocation();
      if (loc && loc != 'US') {
        isEligible = false;
      }
    }
    if (isEligible && gift && !hasGift) {
      console.log('Adding GWP: ' + gift);
      cartAdd(gift, {
        'quantity': 1
      }).then(function (item) {
        getCart().then(function (Cart) {
          Shopify.theme.ajaxCart.updateView(conf, Cart);
        });
      });
    } else if (!isEligible && hasGift) {
      if (hasTagGift) {
        gift = tagGift;
      }
      console.log('Removing GWP: ' + gift);
      remove.push(gift);
    }
    if (!hasRegular && isEligible) {
      var style = '<style id="gift-message-css">.gift-message { display: none; } .ajax-cart__summary-wrapper { border: 0 !important; }</style>';
      $('body').append(style);
    } else {
      $('#gift-message-css').remove();
    }
    if (remove.length > 0) {
      cartRemove(remove).then(function (Cart) {
        Shopify.theme.ajaxCart.updateView(conf, Cart);
      });
    }
  }
  exports.getState = getState;
  exports.getCart = getCart;
  exports.getItemIndex = getItemIndex;
  exports.getItem = getItem;
  exports.addItem = addItem;
  exports.addItemFromForm = addItemFromForm;
  exports.cartAddMultiple = cartAddMultiple;
  exports.updateItem = updateItem;
  exports.removeItem = removeItem;
  exports.clearItems = clearItems;
  exports.getAttributes = getAttributes;
  exports.updateAttributes = updateAttributes;
  exports.clearAttributes = clearAttributes;
  exports.getNote = getNote;
  exports.updateNote = updateNote;
  exports.clearNote = clearNote;
  exports.getShippingRates = getShippingRates;
  exports.checkGWP = checkGWP;
  exports.checkGiftWrap = checkGiftWrap;
  exports.checkTrial = checkTrial;
  return exports;
}({});
var oldCartContent = '';
Shopify.theme.ajaxCart = {
  init: function init() {
    var config = document.getElementById('cart-config');
    if (!config) return false;
    config = JSON.parse(config.innerHTML || '{}');
    var selectors = {
      cartTrigger: '.js-mini-cart-trigger',
      cartPageLoader: '.ajax-cart__page-wrapper .js-mini-cart-loader',
      addToCart: '.js-ajax-submit',
      addRecipeToCart: '.recipe-add-form',
      stickyCart: '.js-sticky-cart'
    };

    // Init carts
    this.initializeAjaxCart(config);

    // Set No Js Cart or Remove
    if (config.cart_action == 'no_js_cart') {
      if (document.querySelector('.js-ajax-cart-content')) {
        document.querySelector('.js-ajax-cart-content').remove();
      }
    } else {
      if (document.querySelector('.js-ajax-cart-content-nojs')) {
        document.querySelector('.js-ajax-cart-content-nojs').remove();
      }
    }

    // Init cart type
    if (config.cart_action == 'drawer') {
      WAU.Slideout.init("ajax-cart");
    } else if (config.cart_action == 'modal_cart') {
      WAU.Modal.init("ajax-cart");
    } else if (config.cart_action == 'mini_cart') {
      WAU.Modal.init("mini-ajax-cart");
    }

    // Override add to cart form
    document.querySelectorAll(selectors.addToCart).forEach(function (element, i) {
      element.addEventListener('click', function (e) {
        e.preventDefault();
        $addSection = $(this).closest('.product-add');

        // Subscription-only card buttons lead to the product page to start the
        // subscription flow (collection cards with the inline Recharge widget
        // keep their popup behavior)
        if ($(this).closest('.product-cta').length > 0 && $(this).parent().is('[data-selling-plan-id]') && !$addSection.hasClass('recharge-subscription-widget')) {
          window.location.href = $(this).closest('.product-info').find('.product-title a').attr('href');
          return false;
        }
        if ($addSection.length > 0 && $addSection.hasClass('recharge-subscription-widget')) {
          $card = $(this).closest('.product-index');
          var closeSelection = function closeSelection() {
            $addSection.removeClass('open');
            $addSection.find('.product-title').remove();
            $addSection.find('.product-image').remove();
            $('body').removeClass('modal--open');
            $('.js-modal-overlay').unbind('click');
          };
          $addSection.find('.close').unbind('click').click(function () {
            closeSelection();
          });
          $('.js-modal-overlay').unbind('click').click(function () {
            closeSelection();
          });
          if ($addSection.hasClass('open')) {
            closeSelection();
          } else {
            e.stopPropagation();
            $('body').addClass('modal--open');
            var _openSelection = function openSelection() {
              if ($addSection.find('.rc-widget').length === 1) {
                $addSection.addClass('open');
                if ($addSection.find('.product-add-wrapper').length === 0) {
                  $addSection.wrapInner('<div class="product-add-wrapper"></div>');
                }
                $addSection.find('.product-add-wrapper').prepend('<h3 class="product-title h4">' + $card.find('.product-title').text() + '</h3>');
                $addSection.prepend('<div class="product-image">' + $card.find('.prod-image').html() + '</div>').find('a').attr('href', 'javascript: void(0)');
              } else {
                setTimeout(_openSelection, 300);
              }
            };
            _openSelection();
            return false;
          }
        }
        if (this.classList.contains('js-ajax-bis')) {
          klaviyoBackInStockPopup($(this).parent().data('product-title'), $(this).parent().data('item-id'));
        } else {
          var addToCartForm = this.closest('form');
          var variantId = parseInt($(this).parent().attr('data-item-id'));
          var sellingPlanId = false;
          var properties = {};
          if (this.classList.contains('AddtoCart-PDP') && $('.rc-widget').is(':visible')) {
            if ($('.rc-radio__input').length === 0) {
              sellingPlanId = $('input[name="selling_plan"]').val();
            } else if ($('.rc-radio__input:checked').val().indexOf('sub') !== -1) {
              sellingPlanId = $('.rc-selling-plans-dropdown__select').val();
            }
          } else if (this.classList.contains('AddtoCart-PDP') && $('.recharge-gifting-widget').is(':visible')) {
            $('.recharge-gifting-widget form input,select,textarea,checkbox').each(function () {
              var name = $(this).attr('name');
              if (name.indexOf('properties[') !== -1) {
                name = name.replace('properties[__rc', '').replace(']', '');
                properties[name] = $(this).val();
              }
            });
            properties['_gift_redemption'] = randomString() + '-' + randomString() + '-' + randomString();
          } else if ($(this).closest('.product-add').find('.rc-widget').length > 0) {
            if ($(this).closest('.product-add').find('.rc-radio__input').length === 0) {
              sellingPlanId = $('input[name="selling_plan"]').val();
            } else if ($(this).closest('.product-add').find('.rc-radio__input:checked').val().indexOf('sub') !== -1) {
              sellingPlanId = $(this).closest('.product-add').find('.rc-selling-plans__dropdown').val();
            }
          } else if (addToCartForm && $(addToCartForm).find('input[name="selling_plan"]').length > 0) {
            // Recharge subscription widget v2 injects a hidden selling_plan input into the
            // product form and keeps it synced (empty string when one-time is selected)
            sellingPlanId = $(addToCartForm).find('input[name="selling_plan"]').val();
          } else {
            sellingPlanId = parseInt($(this).parent().attr('data-selling-plan-id'));
          }
          if ($(this).parent().attr('data-trial-added')) {
            properties['_trial_added'] = 1;
          }
          var kit = $(this).parent().attr('data-kit-instructions');
          var sku = $(this).parent().attr('data-sku');
          var giftRecipient = false;
          if ($(this).parent().data('gift-card') == 1 && $('.recipient-checkbox').prop('checked')) {
            var email = $('.recipient-email').val();
            var name = $('.recipient-name').val();
            var message = $('.recipient-message').val();
            var sendOn = $('.recipient-send-on').val();
            if (email.length <= 1 || email.indexOf('@') === -1) {
              alert('You must enter a recipient email or uncheck send as a gift');
              return false;
            }
            if (sendOn) {
              var now = new Date();
              var d = new Date(sendOn);
              if (d.setHours(0, 0, 0, 0) < now.setHours(0, 0, 0, 0)) {
                alert('Send on value must be in future');
                return false;
              }
            }
            giftRecipient = {
              '__shopify_send_gift_card_to_recipient': true,
              '__shopify_offset': new Date().getTimezoneOffset().toString(),
              'Recipient email': email.trim()
            };
            if (name) {
              giftRecipient['Recipient name'] = name.trim();
            }
            if (message) {
              giftRecipient['Message'] = message.trim();
            }
            if (sendOn) {
              giftRecipient['Send on'] = sendOn.trim();
            }
          }
          Shopify.theme.ajaxCart.addToCart(addToCartForm, element.parentNode, config, false, variantId, sellingPlanId, sku, kit, giftRecipient, properties);
        }
        return false;
      });
    });

    // Allow clicking anywhere on .product-cta to trigger add to cart
    document.querySelectorAll('.product-cta').forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        if (e.target.closest('a, button, input, .quantity-selector')) return;
        var btn = cta.querySelector('.js-ajax-submit');
        if (btn) btn.click();
      });
    });

    // Subscription card buttons rendered after init (e.g. predictive search)
    // are never bound above — catch them here and lead to the product page
    $(document).on('click', '.product-cta .add-to-cart[data-selling-plan-id] .js-ajax-submit', function (e) {
      e.preventDefault();
      if (!$(this).closest('.product-add').hasClass('recharge-subscription-widget')) {
        window.location.href = $(this).closest('.product-info').find('.product-title a').attr('href');
      }
    });

    // On cart trigger click
    var cartTriggers = document.querySelectorAll(selectors.cartTrigger);
    cartTriggers.forEach(function (item, i) {
      item.addEventListener('click', function (e) {
        e.preventDefault();

        // Open drawer
        Shopify.theme.cart.getCart().then(function (Cart) {
          Shopify.theme.ajaxCart.updateView(config, Cart);
          if (config.cart_action == 'drawer') {
            Shopify.theme.ajaxCart.showDrawer(config);
          } else if (config.cart_action == 'modal_cart') {
            Shopify.theme.ajaxCart.showModal(config);
          } else if (config.cart_action == 'mini_cart') {
            Shopify.theme.ajaxCart.showModal(config);
          } else {
            window.location.href = config.cart_url;
          }
        });
        return false;
      });
    });

    // Add recipes to cart
    var recipeAddForms = document.querySelectorAll(selectors.addRecipeToCart);
    recipeAddForms.forEach(function (recipeForm) {
      recipeForm.addEventListener('submit', function (e) {
        e.preventDefault();
        Shopify.theme.ajaxCart.addRecipeToCart(recipeForm, config);
      });
    });
  },
  cartStickyBar: function cartStickyBar() {
    var lastKnownScrollPosition = 0;
    var ticking = false;
    function initSticky(scrollPos) {
      var cartForm = document.querySelectorAll('.js-cart-form');
      if (!cartForm) return false;
      cartForm.forEach(function (item, i) {
        var topOfHiddenDiv = item.offsetTop;
        var position = scrollPos >= topOfHiddenDiv,
          footer = document.getElementById('footer'),
          stickyBar = document.querySelector('.js-sticky-cart');
        if (i === 1) return false;
        if (position && !stickyBar.classList.contains('show')) {
          stickyBar.classList.add('show');
          footer.classList.add('padding-sticky');
        } else if (!position && typeof stickyBar.classList !== 'undefined' && stickyBar.classList.contains('show')) {
          stickyBar.classList.remove('show');
          footer.classList.remove('padding-sticky');
        }
      });
    }
    document.addEventListener('scroll', function (e) {
      lastKnownScrollPosition = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function () {
          initSticky(lastKnownScrollPosition);
          ticking = false;
        });
        ticking = true;
      }
    });
  },
  cartEvents: function cartEvents(config) {
    var selectors = {
      cartDrawerRemove: '.js-cart-remove',
      cartDrawerQty: '[data-item-qty]',
      cartDrawerQtyDecrease: '[data-ajax-qty-decrease]',
      cartDrawerQtyIncrease: '[data-ajax-qty-increase]',
      cartNote: '.js-cart-note'
    };

    // Cart Events
    var cartDrawerQtyElems = document.querySelectorAll(selectors.cartDrawerQty);
    if (cartDrawerQtyElems.length === 0) {
      return false;
    }
    cartDrawerQtyElems.forEach(function (element, i) {
      var selector = '.add-to-cart.atc-' + element.dataset.itemId.split('-')[0];
      if (element.closest('.ajax-cart__item-quantity')) {
        $(selector).closest('.product-cta').addClass('in-cart');
        var $qSelector = $(selector + ' .quantity-selector');
        $qSelector.html(element.closest('.ajax-cart__item-quantity').innerHTML);
        var quantityLimit = $(selector).attr('data-quantity-limit');
        var _quantity = element.value;
        if (_quantity && quantityLimit && parseInt(_quantity) >= parseInt(quantityLimit)) {
          $qSelector.addClass('locked');
        } else {
          $qSelector.removeClass('locked');
        }
      } else if ($('.add-to-cart .updates_' + element.dataset.itemId).length) {
        $('.add-to-cart .updates_' + element.dataset.itemId).attr('value', element.value);
      }
      element.addEventListener('change', function (e) {
        e.preventDefault();
        var quantity = parseInt(this.value),
          itemKey = this.dataset.itemKey,
          itemMax = this.dataset.limit,
          lineElement = element.closest('.ajax-cart__cart-item');

        // Set new quantity
        element.value = quantity;

        // Adjust cart object
        setTimeout(function () {
          if (quantity === 0) {
            Shopify.theme.ajaxCart.removeFromCart(itemKey, config);
          } else {
            Shopify.theme.ajaxCart.checkLimit(itemMax, quantity, lineElement, config);
            Shopify.theme.cart.updateItem(itemKey, {
              quantity: quantity
            }).then(function (state) {
              Shopify.theme.ajaxCart.updateView(config, state);
            });
          }
        }, 250);
        return false;
      });
    });
    $('.product-cta.in-cart').each(function () {
      if (!$('.ajax-cart__cart-item[data-item-id=' + $(this).find('.add-to-cart').data('item-id') + ']').length) {
        $(this).removeClass('in-cart');
      }
    });
    document.querySelectorAll(selectors.cartDrawerRemove).forEach(function (element, i) {
      element.addEventListener('click', function (e) {
        e.preventDefault();
        var itemKey = this.dataset.itemKey;
        var kitSku = this.dataset.kitSku;
        Shopify.theme.ajaxCart.removeFromCart(itemKey, config, kitSku);
        return false;
      });
    });
    var qtyTimeout = false;
    var qtyLocked = false;
    $(selectors.cartDrawerQtyDecrease).off('click').click(function (e) {
      var _this = this;
      e.preventDefault();
      if (qtyTimeout) {
        clearTimeout(qtyTimeout);
      }
      if (!qtyLocked) {
        var $input = $(this).siblings('input');
        var _key = $input.attr('data-item-key');
        var qty = parseInt($input.val()) - 1;
        if (qty === 0) {
          Shopify.theme.ajaxCart.removeFromCart($(this).attr('data-item-key'), config);
        } else {
          $('input[data-item-key="' + _key + '"]').val(qty);
          qtyTimeout = setTimeout(function () {
            qtyLocked = true;
            Shopify.theme.ajaxCart.adjustQty($(_this).attr('data-ajax-qty-decrease'), config);
          }, 500);
        }
      }
    });
    $(selectors.cartDrawerQtyIncrease).off('click').click(function (e) {
      var _this2 = this;
      e.preventDefault();
      if (qtyTimeout) {
        clearTimeout(qtyTimeout);
      }
      if (!qtyLocked) {
        var $input = $(this).siblings('input');
        var _key2 = $input.attr('data-item-key');
        var qty = parseInt($input.val()) + 1;
        $('input[data-item-key="' + _key2 + '"]').val(qty);
        qtyTimeout = setTimeout(function () {
          qtyLocked = true;
          Shopify.theme.ajaxCart.adjustQty($(_this2).attr('data-ajax-qty-increase'), config);
        }, 500);
      }
    });
    document.querySelectorAll(selectors.cartNote).forEach(function (element, i) {
      checkEmojis();
      element.addEventListener('blur', function (event) {
        var note = element.value.trim();
        if (!note) {
          note = gObj.gift.standard_gift_note;
        }
        var attribute = gObj.gift.gift_note_attribute;
        if (attribute) {
          Shopify.theme.cart.getAttributes().then(function (attributes) {
            attributes[attribute] = note;
            Shopify.theme.cart.updateAttributes(attributes);
          });
        } else {
          Shopify.theme.cart.updateNote(note);
        }
        $('.gift-message-input').val(note);

        //.then(state => {
        //Shopify.theme.ajaxCart.updateView(config, state);
        //});
      });
    });

    // Reinit shipping calc
    if (config.show_calculator) {
      setTimeout(function () {
        Shopify.theme.shippingCalculator.init();
      }, 1000);
    }

    // Restart Payment buttons
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  },
  showDrawer: function showDrawer(config) {
    if (config.cart_action != 'drawer') return false;
    WAU.Slideout._openByName("ajax-cart");
  },
  hideDrawer: function hideDrawer(config) {
    if (config.cart_action != 'drawer') return false;
    WAU.Slideout._closeByName("ajax-cart");
  },
  showModal: function showModal(config) {
    if (config.cart_action == 'modal_cart') {
      WAU.Modal._openByName("ajax-cart");
    } else if (config.cart_action == 'mini_cart') {
      WAU.Modal._openByName("mini-ajax-cart");
    }
  },
  hideModal: function hideModal(config) {
    if (config.cart_action == 'modal_cart') {
      WAU.Modal._closeByName("ajax-cart");
    } else if (config.cart_action == 'mini_cart') {
      WAU.Modal._closeByName("mini-ajax-cart");
    }
  },
  removeFromCart: function removeFromCart(itemKey, config, kitSku) {
    Shopify.theme.cart.getItem(itemKey).then(function (item) {
      if (item.product_type == 'Membership') {
        if (typeof gObj.trial !== 'undefined' && gObj.trial.id == item.id && !item.properties['_trial_added']) {
          sessionStorage.setItem('trial_removed', true);
        }
        $('[data-membership-checkout]').hide();
        $('[data-membership-msg]').hide();
        $('[data-membership-msg-other]').hide();
        $('[data-membership-in-cart]').attr('data-membership-in-cart', '');
        $('[data-membership-atc]').show();
      }
    });
    Shopify.theme.cart.removeItem(itemKey).then(function (state) {
      if (typeof kitSku !== 'undefined' && kitSku) {
        kitItem = {};
        kitItem['Kit ' + kitSku] = null;
        Shopify.theme.cart.updateAttributes(kitItem);
      }
      Shopify.theme.cart.checkGWP(config, state);
      Shopify.theme.cart.checkGiftWrap(config, state);
      Shopify.theme.cart.checkTrial(config, state);
      Shopify.theme.ajaxCart.updateView(config, state);
    });
  },
  adjustQty: function adjustQty(itemId, config) {
    var selectors = {
      lineItem: '.item_' + itemId,
      updatesItem: '.updates_' + itemId
    };

    // Update Line Item
    document.querySelectorAll(selectors.lineItem).forEach(function (element, i) {
      elementInput = element.querySelector(selectors.updatesItem), key = elementInput.dataset.itemKey, max = elementInput.dataset.limit, quantity = parseInt(elementInput.value);

      // Check limit to prevent over adding
      if (Shopify.theme.ajaxCart.checkLimit(max, quantity, element, config)) return false;

      // Check new qty to prevent going lower than 1
      if (quantity === 0) return false;

      // Set new quantity
      elementInput.value = quantity;

      // Adjust cart object
      setTimeout(function () {
        Shopify.theme.cart.updateItem(key, {
          quantity: quantity
        }).then(function (state) {
          Shopify.theme.cart.checkGWP(config, state);
          Shopify.theme.cart.checkGiftWrap(config, state);
          Shopify.theme.cart.checkTrial(config, state);
          Shopify.theme.ajaxCart.updateView(config, state);
        });
      }, 250);
    });
  },
  checkLimit: function checkLimit(max, quantity, element, config) {
    // Check limit to prevent over adding
    if (max != '' && quantity > max) {
      var cartNote = document.createElement('div');
      cartNote.classList.add('mini-cart__cart-note');
      cartNote.innerHTML = '<p class="a-center"><b>' + config.cart_error + '</b>&nbsp;&nbsp;' + config.update_qty_error + '</p>';
      var adjacentElement = element.querySelector('.js-item-quantity');
      var parentElement = adjacentElement.parentNode;
      parentElement.appendChild(cartNote, adjacentElement);
      setTimeout(function () {
        theme.Helpers.fadeOut(cartNote);
        parentElement.removeChild(cartNote);
      }, 2000);
      return true;
    }
  },
  addRecipeToCart: function addRecipeToCart(form, config) {
    var fields = form.querySelectorAll('[name="formVariantId"]');
    if (fields.length <= 0) {
      return;
    }
    var items = [];
    fields.forEach(function (field) {
      var properties = {};
      var discountPrice = field.dataset.discountPrice;
      if (discountPrice) {
        properties['_discount_price'] = discountPrice;
      }
      items.push({
        id: parseInt(field.value),
        quantity: 1,
        properties: properties
      });
    });
    var button = form.querySelector('input[type="submit"],button[type="submit"]');
    if (button) {
      button.value = config.adding_to_cart;
      button.classList.add('disabled');
      button.getAttribute('disabled', 'disabled');
    }
    Shopify.theme.cart.cartAddMultiple(items).then(function () {
      button.classList.remove('disabled');
      button.removeAttribute('disabled', 'disabled');
      button.value = config.add_recipe_to_cart;
      Shopify.theme.cart.getCart().then(function (Cart) {
        if (config.cart_action == 'drawer' && config.cart_added_event == 'go_to_active_cart') {
          Shopify.theme.ajaxCart.showDrawer(config);
          setTimeout(function () {
            Shopify.theme.ajaxCart.hideDrawer(config);
          }, 3000);
        } else if (config.cart_action == 'modal_cart' && config.cart_added_event == 'go_to_active_cart') {
          Shopify.theme.ajaxCart.showModal(config);
        } else if (config.cart_action == 'mini_cart' && config.cart_added_event == 'go_to_active_cart') {
          Shopify.theme.ajaxCart.showModal(config);
        } else if (config.cart_action == 'page_only' && config.cart_added_event == 'go_to_active_cart') {
          window.location.href = config.cart_url;
        } else if (config.cart_added_event == 'product_page') {
          theme.Helpers.fadeIn(context.querySelector(selectors.cartAddedMsg));
          setTimeout(function () {
            theme.Helpers.fadeOut(context.querySelector(selectors.cartAddedMsg));
          }, 3000);
        } else {
          window.location.href = config.cart_url;
        }
        Shopify.theme.ajaxCart.updateView(config, Cart);
      });
    });
  },
  addToCart: function () {
    var _addToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(addToCartForm, formContext, config, isQuickview, variantId, sellingPlanId, sku, kit, giftRecipient, properties) {
      var selectors, context, options, variantPriceElement, discountPrice, membershipBtnElement;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            selectors = {
              addToCart: '.js-ajax-submit',
              cartAddedMsg: '.js-added-msg'
            };
            if (isQuickview) {
              context = document.querySelector('.js-quickview-content');
            } else {
              context = formContext;
            }
            if (context) {
              // Disable add to cart button temporarily]
              context.querySelector(selectors.addToCart).value = config.adding_to_cart;
              context.querySelector(selectors.addToCart).classList.add('disabled');
              context.querySelector(selectors.addToCart).getAttribute('disabled', 'disabled');
            }
            properties = typeof properties === 'undefined' ? {} : properties;
            if (!$.isEmptyObject(giftRecipient)) {
              properties = giftRecipient;
            }
            options = {
              quantity: 1,
              properties: properties
            };
            if (typeof sellingPlanId !== 'undefined' && sellingPlanId) {
              options['selling_plan'] = sellingPlanId;
            }
            variantPriceElement = document.querySelector("#variant-price-".concat(variantId));
            if (variantPriceElement) {
              discountPrice = variantPriceElement.dataset.discountPrice;
              if (discountPrice) {
                properties['_discount_price'] = discountPrice;
              }
            }
            membershipBtnElement = document.querySelector("div[data-item-id='".concat(variantId, "'] .membership-plans__button"));
            if (membershipBtnElement) {
              properties['_is_membership_plan'] = true;
            }
            Shopify.theme.cart.addItem(variantId, options).then(function (item) {
              if (typeof kit !== 'undefined' && kit) {
                kitItem = {};
                kitItem['Kit ' + sku] = kit;
                Shopify.theme.cart.updateAttributes(kitItem);
              }
              if (context) {
                // Re-enable add to cart button
                //context.querySelector(selectors.addToCart).value = config.added_to_cart;
                context.querySelector(selectors.addToCart).classList.remove('disabled');
                context.querySelector(selectors.addToCart).removeAttribute('disabled', 'disabled');
                setTimeout(function () {
                  var atc = context.querySelector(selectors.addToCart);
                  if (atc && atc.value !== 'undefined') {
                    atc.value = config.add_to_cart;
                  }
                }, 3000);
              }
              if (item.product_type == 'Membership') {
                var membershipType = item.title.toLowerCase().indexOf('annual') !== -1 ? 'annual' : 'monthly';
                var membershipSelected = $('.membership-plan__radio-input:checked') ? $('.membership-plan__radio-input:checked .membership-plan__header-text').text().toLowerCase().indexOf('annual') !== -1 ? 'annual' : 'monthly' : false;
                if (membershipSelected) {
                  $('[data-membership-atc]').hide();
                  $('[data-membership-msg]').show();
                  $('[data-membership-in-cart]').attr('data-membership-in-cart', membershipType);
                  $('[data-membership-checkout]').show();
                }
              }
              Shopify.theme.cart.getCart().then(function (Cart) {
                if (isQuickview && config.cart_added_event != 'product_page') {
                  Shopify.theme.quickview.hideModal();
                } else if (isQuickview && config.cart_added_event == 'product_page') {
                  theme.Helpers.fadeIn(context.querySelector(selectors.cartAddedMsg));
                  setTimeout(function () {
                    theme.Helpers.fadeOut(context.querySelector(selectors.cartAddedMsg));
                  }, 3000);
                }
                if (config.cart_action == 'drawer' && config.cart_added_event == 'go_to_active_cart') {
                  Shopify.theme.ajaxCart.showDrawer(config);
                  setTimeout(function () {
                    Shopify.theme.ajaxCart.hideDrawer(config);
                  }, 3000);
                } else if (config.cart_action == 'modal_cart' && config.cart_added_event == 'go_to_active_cart') {
                  Shopify.theme.ajaxCart.showModal(config);
                } else if (config.cart_action == 'mini_cart' && config.cart_added_event == 'go_to_active_cart') {
                  Shopify.theme.ajaxCart.showModal(config);
                } else if (config.cart_action == 'page_only' && config.cart_added_event == 'go_to_active_cart') {
                  window.location.href = config.cart_url;
                } else if (config.cart_added_event == 'product_page') {
                  theme.Helpers.fadeIn(context.querySelector(selectors.cartAddedMsg));
                  setTimeout(function () {
                    theme.Helpers.fadeOut(context.querySelector(selectors.cartAddedMsg));
                  }, 3000);
                } else {
                  window.location.href = config.cart_url;
                }
                Shopify.theme.cart.checkGWP(config, Cart);
                Shopify.theme.cart.checkTrial(config, Cart);
                setTimeout(function () {
                  Shopify.theme.cart.checkGiftWrap(config, Cart);
                }, 500);
                Shopify.theme.ajaxCart.updateView(config, Cart);
              });

              // Custom Klaviyo Event
              if (typeof klaviyoItem !== 'undefined') {
                klaviyo.push(['track', 'Added to Cart', klaviyoItem]);
              }
            })["catch"](function (error) {
              console.log(error);
              if (error.status == 422) {
                // Show error msg
                theme.Helpers.fadeIn(context.querySelector('.js-error-msg'));
                if (context) {
                  // Re-enable add to cart button
                  context.querySelector(selectors.addToCart).value = config.add_to_cart;
                  context.querySelector(selectors.addToCart).classList.remove('disabled');
                  context.querySelector(selectors.addToCart).removeAttribute('disabled', 'disabled');
                }
                setTimeout(function () {
                  theme.Helpers.fadeOut(context.querySelector('.js-error-msg'));
                }, 3000);
              } else {
                console.log(error);
              }
            });
            _context.next = 14;
            return Shopify.theme.cart.getCart().then(function (Cart) {
              Cart.items.forEach(function (item) {
                if (item.product_type === 'Membership' && item.quantity > 1) {
                  Shopify.theme.cart.updateItem(item.key, {
                    quantity: 1
                  }).then(function (state) {
                    Shopify.theme.ajaxCart.updateView(config, state);
                  });
                }
              });
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function addToCart(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x0) {
      return _addToCart.apply(this, arguments);
    }
    return addToCart;
  }(),
  getAjaxCart: function getAjaxCart(response) {
    var el = document.createElement('div');
    el.innerHTML = response;
    var responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
    var htmls = el.querySelectorAll('[data-html]');
    var html = {};
    if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
      html = htmls[0].innerHTML;
    } else {
      for (var i = 0; i < htmls.length; i++) {
        html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
      }
    }
    var options = responseOptions;
    return html;
  },
  initializeAjaxCart: function initializeAjaxCart(config) {
    var data, url;
    url = config.cart_url + '/?view=ajax';
    fetch(url, data).then(function (res) {
      return res.text();
    }).then(function (response) {
      var html = Shopify.theme.ajaxCart.getAjaxCart(response);

      // Replace cart content
      document.querySelectorAll('.js-ajax-cart-content').forEach(function (item, i) {
        item.innerHTML = html.content;
      });
      Shopify.theme.ajaxCart.cartEvents(config);
    }).then(function (response) {
      // Init shipping calc
      if (config.show_calculator) {
        setTimeout(function () {
          Shopify.theme.shippingCalculator.init();
        }, 1000);
      }
    })["catch"](function (error) {
      console.log(error);
    });
    Shopify.theme.cart.getCart().then(function (Cart) {
      Shopify.theme.cart.checkGWP(config, Cart);
      Shopify.theme.cart.checkTrial(config, Cart);
    });
  },
  updateView: function updateView(config, Cart) {
    var data, url;
    url = config.cart_url + '/?view=ajax';
    fetch(url, data).then(function (res) {
      return res.text();
    }).then(function (response) {
      var html = Shopify.theme.ajaxCart.getAjaxCart(response);
      var selectors = {
        cartContent: '.js-ajax-cart-content',
        cartEmpty: '.js-cart-empty',
        cartForm: '.js-cart-form',
        cartAccordion: '.js-cart-accordion',
        cartCount: '.js-cart-count'
      };

      /**
       * Updates the sticky cart
       * @param  {object} Cart   Cart object
       * @param  {config} config config object
       */
      var updateStickyCart = function updateStickyCart(cart, config) {
        var disable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var selectors = {
          stickyCart: '.js-sticky-cart',
          cartTotal: '.js-cart-total',
          checkoutButton: '.js-sticky-checkout-btn'
        };

        // Check for necessary arguments
        if (!cart) {
          console.log('Error. updateStickyCart requires a Cart object');
          return false;
        }
        if (!config) {
          console.log('Error. updateStickyCart requires a config object');
          return false;
        }

        // Update sticky cart price

        var stickyCartElems = document.querySelectorAll(selectors.stickyCart);
        if (stickyCartElems.length === 0) {
          return false;
        }
        stickyCartElems.forEach(function (stickyCart, i) {
          // Get the original price element
          var cartOriginalPriceEl = stickyCart.querySelector(selectors.cartTotal);

          // Format the price
          var formattedPrice = theme.Helpers.formatMoney(cart.total_price, config.money_format);

          // Log error if no original price element was found
          if (!cartOriginalPriceEl) {
            console.log('Error. No original price element found in sticky cart');
          }

          // Update the price
          cartOriginalPriceEl.innerHTML = formattedPrice;

          //
          // Disable checkout button
          //

          // Get the checkout button
          var checkoutButton = stickyCart.querySelector(selectors.checkoutButton);

          // If disable
          if (disable && checkoutButton && checkoutButton.disabled == false) {
            checkoutButton.disabled = true;
          } else {
            checkoutButton.disabled = false;
          }
        });
      };
      var isCartPage = function isCartPage() {
        return $('#shopping-cart').length > 0;
      };
      if (Cart.item_count === 0) {
        // Hide form
        document.querySelectorAll(selectors.cartForm).forEach(function (item, i) {
          item.classList.add('hide');
        });
        // Show empty msg
        document.querySelectorAll(selectors.cartEmpty).forEach(function (item, i) {
          item.classList.remove('hide');
        });
        // Update cart count
        document.querySelectorAll(selectors.cartCount).forEach(function (item, i) {
          item.innerHTML = '0';
        });
        $('.add-to-cart').closest('.product-cta').removeClass('in-cart');
        $('.cart-shipping-disclaimer').hide();
      } else {
        // Hide empty msg
        document.querySelectorAll(selectors.cartEmpty).forEach(function (item, i) {
          item.classList.add('hide');
        });
        // Update cart count
        document.querySelectorAll(selectors.cartCount).forEach(function (item, i) {
          item.innerHTML = Cart.item_count;
        });
        // Replace cart page and drawer content
        document.querySelectorAll(selectors.cartContent).forEach(function (item, i) {
          if (html.content != oldCartContent) {
            item.innerHTML = html.content;
          }
        });
        oldCartContent = html.content;
        // Reload accordions
        document.querySelectorAll(selectors.cartAccordion).forEach(function (item, i) {
          theme.Helpers.Accordion(item, '.tlink.has_sub_menu a', '.accordion-content.sub');
          theme.Helpers.Accordion(item, '.tlink2.has_sub_menu a', '.accordion-content2.sub');
        });

        // Reload events
        Shopify.theme.ajaxCart.cartEvents(config);
        qtyLocked = false;
        var inCartUpsellSelector = '#mini-cart .cart-upsell';
        var loadCarousel = function loadCarousel(isNosto) {
          var flktyData = $(inCartUpsellSelector + ' .js-carousel').data('flickity');
          if (flktyData) {
            new Flickity(inCartUpsellSelector + ' .js-carousel', flktyData);
            if (!isNosto) {
              $(inCartUpsellSelector + ' .js-ajax-submit').click(function (e) {
                e.preventDefault();
                var addToCartForm = $(this).closest('form');
                var variantId = $(this).closest('[data-variant-id]').data('variant-id');
                var sellingPlanId = $(this).parent().data('selling-plan-id');
                var cartConfig = document.getElementById('cart-config');
                if (!cartConfig) return false;
                cartConfig = JSON.parse(cartConfig.innerHTML || '{}');
                Shopify.theme.ajaxCart.addToCart(addToCartForm, document.querySelector(inCartUpsellSelector + ' form'), cartConfig, false, variantId, sellingPlanId, false, false);
                return false;
              });
            }
          }
        };
        if ($(inCartUpsellSelector + ' .flickity-enabled').length === 0) {
          if ($(inCartUpsellSelector + ' .nosto_element').length > 0) {
            var _renderNosto = function renderNosto() {
              if (typeof nostojs !== 'undefined' && nostojs && $(inCartUpsellSelector + ' .nosto_element').length > 0) {
                nostojs(function (api) {
                  api.resendCartTagging();
                  api.loadRecommendations().then(function (response) {
                    loadCarousel(true);
                    adjustCartScrollHeight();
                  });
                });
              } else {
                setTimeout(_renderNosto, 250);
              }
            };
            _renderNosto();
          } else {
            loadCarousel(false);
            adjustCartScrollHeight();
          }
        }
      }
      $('.gift-wrap-toggle').click(function () {
        var isChecked = $(this).prop('checked');
        var giftWrapVariantId = gObj.gift.wrap_product;
        if (isChecked) {
          console.log('🎁 Adding gift wrap');
          // add gift wrap product to cart
          if (giftWrapVariantId) {
            // if gift wrap already in cart, do not add again
            var giftWrapInCart = false;
            Cart.items.forEach(function (item) {
              if (item.variant_id == giftWrapVariantId) {
                giftWrapInCart = true;
              }
            });
            if (!giftWrapInCart) {
              Shopify.theme.cart.addItem(giftWrapVariantId, {
                quantity: 1
              }).then(function (item) {
                Shopify.theme.cart.getCart().then(function (Cart) {
                  Shopify.theme.ajaxCart.updateView(config, Cart);
                });
              });
            }
          }
        } else {
          console.log('🎁 Removing gift wrap');
          // remove gift wrap product from cart
          Shopify.theme.cart.getCart().then(function (Cart) {
            Cart.items.forEach(function (item) {
              if (item.variant_id == giftWrapVariantId) {
                Shopify.theme.cart.removeItem(item.key).then(function (state) {
                  Shopify.theme.ajaxCart.updateView(config, state);
                });
              }
            });
          });
        }
      });
      $('.gift-message-toggle').click(function () {
        var attribute = gObj.gift.gift_note_attribute;
        var isChecked = $(this).prop('checked');
        Shopify.theme.cart.getAttributes().then(function (attributes) {
          var cartNote = '';
          if (isChecked) {
            var showNote = function showNote() {
              $('.gift-message-input').removeClass('hide').val(cartNote);
              $('.ajax-cart__cart-form').addClass('gift-message-open');
            };
            if (attribute) {
              if (typeof attributes[attribute] !== 'undefined') {
                cartNote = attributes[attribute];
              }
              if (!cartNote) {
                cartNote = gObj.gift.standard_gift_note;
              }
            } else {
              Shopify.theme.cart.getNote().then(function (note) {
                if (!note) {
                  note = gObj.gift.standard_gift_note;
                  $('.gift-message-input').val(note);
                }
                Shopify.theme.cart.updateNote(note);
              });
              showNote();
              return true;
            }
            showNote();
          } else {
            $('.gift-message-input').addClass('hide').val('');
            $('.ajax-cart__cart-form').removeClass('gift-message-open');
          }
          if (attribute) {
            attributes[attribute] = cartNote;
            Shopify.theme.cart.updateAttributes(attributes);
          } else {
            Shopify.theme.cart.updateNote(cartNote);
          }
          adjustCartScrollHeight();
        });
      });

      //if (yotpoWidgetsContainer) {
      //  yotpoWidgetsContainer.initWidgets();
      //}

      // Set Cart Loaded
      setTimeout(function () {
        document.querySelector('body').classList.add('cart-loaded');

        // Remove dynamic buttons from drawer or model if on cart page
        if (config.cart_action == 'mini_cart') {
          if (document.querySelectorAll('#dynamic-checkout-cart').length > 2) {
            document.querySelectorAll('.js-mini-cart-wrapper #dynamic-checkout-cart').forEach(function (item, i) {
              item.remove();
            });
          }
        } else {
          if (document.querySelectorAll('#dynamic-checkout-cart').length >= 2) document.querySelectorAll('#dynamic-checkout-cart')[1].remove();
        }
      }, 500);
    })["catch"](function (error) {
      console.log(error);
    });
  }
};
Shopify.theme.shippingCalculator = {
  init: function init() {
    var config = document.getElementById('cart-config');
    if (!config) return false;
    var config = JSON.parse(config.innerHTML || '{}');
    var selectors = {
      container: '.js-shipping-calc-wrapper',
      submitButton: '.js-shipping-calc-submit',
      addressZip: '.js-shipping-calc-address-zip',
      addressCountry: '.js-shipping-calc-address-country',
      addressProvince: '.js-shipping-calc-address-province',
      addressProvinceLabel: '.js-shipping-calc-address-province-label',
      response: '.js-shipping-calc-response'
    };

    // let calculators = document.querySelectorAll(selectors.container);
    //
    // calculators.forEach((element, i) => {
    //   element.classList.add("shipping-calculator-" + i);
    // });

    var container;
    if (config.cart_action == 'mini_cart') {
      if (document.querySelectorAll(selectors.container)[0]) {
        document.querySelectorAll(selectors.container)[0].innerHTML = '';
      }
      container = document.querySelectorAll(selectors.container)[1];
    } else {
      if (document.querySelectorAll(selectors.container)[1]) {
        document.querySelectorAll(selectors.container)[1].innerHTML = '';
      }
      container = document.querySelectorAll(selectors.container)[0];
    }
    if (!container) return false;
    if (!document.querySelector('body').classList.contains('template-cart')) return false;

    // Initialize observer on shipping address.
    new Shopify.CountryProvinceSelector('address_country', 'address_province', {
      hideElement: 'address_province_container'
    });

    // Updating province label.
    var countriesSelect = container.querySelector(selectors.addressCountry);
    var addressProvinceLabelEl = container.querySelector(selectors.addressProvinceLabel);
    if (typeof Countries !== 'undefined') {
      Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl);
      countriesSelect.change(function () {
        Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl);
      });
    }

    // When any of the calculator buttons is clicked, get rates.
    var button = container.querySelector(selectors.submitButton);
    button.addEventListener('click', function (e) {
      e.preventDefault();

      // Disabling all buttons.
      Shopify.theme.shippingCalculator.disableButtons(config, container);

      // Hiding response.
      container.querySelector(selectors.response).style.display = 'none';

      // Reading shipping address for submission.
      var shippingAddress = {};
      shippingAddress.zip = container.querySelector(selectors.addressZip).value || '';
      shippingAddress.country = container.querySelector(selectors.addressCountry).value || '';
      shippingAddress.province = container.querySelector(selectors.addressProvince).value || '';
      Shopify.theme.shippingCalculator.getRates(config, shippingAddress, container);
    });
  },
  enableButtons: function enableButtons(config, container) {
    var selectors = {
      submitButton: '.js-shipping-calc-submit'
    };
    container.querySelector(selectors.submitButton).removeAttribute('disabled');
    container.querySelector(selectors.submitButton).classList.remove('disabled');
    container.querySelector(selectors.submitButton).value = config.calculator_submit;
  },
  disableButtons: function disableButtons(config, container) {
    var selectors = {
      submitButton: '.js-shipping-calc-submit'
    };
    container.querySelector(selectors.submitButton).setAttribute('disabled', 'disabled');
    container.querySelector(selectors.submitButton).classList.add('disabled');
    container.querySelector(selectors.submitButton).value = config.calculator_calculating;
  },
  getRates: function getRates(config, shipping_address, container) {
    var url = '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + shipping_address.zip + '&shipping_address%5Bcountry%5D=' + shipping_address.country + '&shipping_address%5Bprovince%5D=' + shipping_address.province;
    fetch(url, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (!response.shipping_rates) {
        Shopify.theme.shippingCalculator.onError(response, config, container);
      } else {
        var rates = response.shipping_rates;
        Shopify.theme.shippingCalculator.onRatesUpdate(rates, shipping_address, config, container);
      }
    })["catch"](function (error) {
      Shopify.theme.shippingCalculator.onError(error, config, container);
    });
  },
  onError: function onError(error, config, container) {
    // Re-enable calculate shipping buttons.
    Shopify.theme.shippingCalculator.enableButtons(config, container);
    var feedback = config.calculator_error + ' ' + Object.keys(error)[0] + ' ' + Object.values(error)[0];

    // Update calculator.
    Shopify.theme.shippingCalculator.render({
      rates: [],
      errorFeedback: feedback,
      success: false
    }, container, config);
    container.querySelector('.js-shipping-calc-rates').style.display = "none";
    container.querySelector('.js-shipping-calc-response').style.display = "block";
  },
  onRatesUpdate: function onRatesUpdate(rates, shipping_address, config, container) {
    // Re-enable calculate shipping buttons.
    Shopify.theme.shippingCalculator.enableButtons(config, container);

    // Formatting shipping address.
    var readable_address = '';
    if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
    if (shipping_address.province) readable_address += shipping_address.province + ', ';
    readable_address += shipping_address.country;
    if (!rates) return false;

    // Format rates for moneyFormat
    rates.forEach(function (rate, i) {
      rate.price = Shopify.theme.shippingCalculator.formatRate(rate.price, config);
    });

    // Show rates and feedback.
    Shopify.theme.shippingCalculator.render({
      rates: rates,
      address: readable_address,
      success: true
    }, container, config);
  },
  formatRate: function formatRate(ratePrice, config) {
    var formatDollarsToCents = function formatDollarsToCents(value) {
      value = (value + '').replace(/[^\d.-]/g, '');
      if (value && value.includes('.')) {
        value = value.substring(0, value.indexOf('.') + 3);
      }
      return value ? Math.round(parseFloat(value) * 100) : 0;
    };
    var cents = formatDollarsToCents(ratePrice);
    return theme.Helpers.formatMoney(cents, config.money_format);
  },
  render: function render(response, container, config) {
    var rateFeedback = document.querySelector('.js-shipping-calc-rates-feedback'),
      rateList = document.querySelector('.js-shipping-calc-rates');

    // Empty feedback
    rateFeedback.innerHTML = '';

    // Update feedback
    if (response.rates.length > 1) {
      rateFeedback.innerHTML = config.shipping_multi_rate_one + response.rates.length + config.shipping_multi_rate_two + response.address + config.shipping_multi_rate_three + response.rates[0].price;
    } else if (response.rates.length === 1) {
      rateFeedback.innerHTML = config.shipping_single_rate + response.address;
    } else {
      rateFeedback.innerHTML = config.shipping_no_destination;
    }

    // Empty rates
    rateList.innerHTML = '';

    // Update rates
    response.rates.forEach(function (rate, i) {
      var rateLI = document.createElement('li');
      rateLI.classList.add('shipping-calc__rate');
      rateLI.innerHTML = rate.name + ' at ' + rate.price;
      rateList.appendChild(rateLI);
    });
    container.querySelector('.js-shipping-calc-rates').style.display = "block";
    document.querySelector('.js-shipping-calc-response').style.display = "block";
  }
};
Shopify.theme.quickview = {
  init: function init() {
    var selectors = {
      quickviewButton: '.js-quickview-trigger'
    };

    // Init on click event for buttons
    document.querySelectorAll(selectors.quickviewButton).forEach(function (button, i) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        // Init modal
        WAU.Modal.init("quickview");

        // Get template
        var productUrl = this.dataset.productUrl,
          productUrl = Shopify.theme.quickview.cleanUrl(productUrl, 'variant');
        Shopify.theme.quickview.getTemplate(productUrl);
      });
    });
  },
  formatTemplate: function getAjaxCart(response) {
    var el = document.createElement('div');
    el.innerHTML = response;
    var htmls = el.querySelectorAll('[data-html]');
    var html = {};
    if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
      html = htmls[0].innerHTML;
    } else {
      for (var i = 0; i < htmls.length; i++) {
        html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
      }
    }
    return html;
  },
  showModal: function showModal() {
    WAU.Modal._openByName("quickview");
  },
  hideModal: function hideModal() {
    document.querySelector('.js-quickview-content').innerHTML = '';
    WAU.Modal._closeByName("quickview");
  },
  cleanUrl: function cleanUrl(url, key) {
    return url.split('?')[0] + '?view=quick';
  },
  getTemplate: function getTemplate(productUrl) {
    var data, url;
    url = productUrl;
    fetch(url, data).then(function (res) {
      return res.text();
    }).then(function (response) {
      var html = Shopify.theme.quickview.formatTemplate(response);

      // Replace modal content
      document.querySelector('.js-quickview-content').innerHTML = html.content;
    }).then(function (response) {
      var context = document.querySelector('.js-quickview-wrapper');

      // Trigger quickview event
      theme.Product(context);
    }).then(function (response) {
      var context = document.querySelector('.js-quickview-wrapper');

      // Load Payment Buttons
      if (context.dataset.paymentButton == 'true' && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    }).then(function (response) {
      var context = document.querySelector('.js-quickview-wrapper');

      // Trigger event for add to cart
      context.querySelector('.js-ajax-submit').addEventListener('click', function (e) {
        e.preventDefault();
        var addToCartForm = this.closest('form');
        var cartConfig = document.getElementById('cart-config');
        if (!cartConfig) return false;
        cartConfig = JSON.parse(cartConfig.innerHTML || '{}');
        var variantId = $(this).parent().data('item-id');
        var sellingPlanId = $(this).parent().data('selling-plan-id');
        Shopify.theme.ajaxCart.addToCart(addToCartForm, null, cartConfig, true, variantId, sellingPlanId);
        return false;
      });
    }).then(function (response) {
      // Show modal
      Shopify.theme.quickview.showModal();
    })["catch"](function (error) {
      console.log(error);
    });
  }
};
Shopify.theme.quickview.init();
Shopify.theme.ajaxCart.init();

// Reinit cart on section events
document.addEventListener('shopify:section:select', function (event) {
  Shopify.theme.quickview.init();
  Shopify.theme.ajaxCart.init();
});
var ViewedProducts = function () {
  var Constructor = function Constructor(params) {
    var publicAPIs = {};

    // default configs
    var config = {
      howManyToShow: 3,
      howManyToStoreInMemory: 30,
      wrapperId: "recently-viewed-products",
      onComplete: null
    };

    // array containing recently viewed products
    var productHandleQueue = [];

    // wrapper element that displays the products
    var wrapper = null;

    // variable to keep track of how many products have been shown
    var shown = 0;

    // Handle cookie related operations
    var cookie = {
      configuration: {
        expires: 90,
        path: "/",
        domain: window.location.hostname
      },
      name: "shopify_recently_viewed",
      write: function write(recentlyViewed) {
        Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
      },
      read: function read() {
        var recentlyViewed = [];
        var cookieValue = Cookies.get(this.name);
        if (cookieValue !== undefined && cookieValue !== '') {
          recentlyViewed = cookieValue.split(" ");
        }
        return recentlyViewed;
      },
      destroy: function destroy() {
        Cookies.remove(this.name, null, this.configuration);
      },
      remove: function remove(productHandle) {
        var recentlyViewed = this.read();
        var position = recentlyViewed.indexOf(productHandle);
        if (position !== -1) {
          recentlyViewed.splice(position, 1);
          this.write(recentlyViewed);
        }
      }
    };

    // Reveal wrapper element and show recently viewed products and run call back if provided one.
    var finalize = function finalize() {
      // Check if any products were shown.
      if (shown > 0) {
        // Remove hidden class if it exists
        if (wrapper.classList.contains('recently-viewed-products--hidden')) {
          wrapper.classList.remove('recently-viewed-products--hidden');
        }

        // If we have a callback.
        if (config.onComplete) {
          try {
            config.onComplete();
          } catch (error) {}
        }
      } else {
        console.log('No recently viewed products to show');
        return false;
      }
    };

    // Format the product listing template by converting it into a DOM node, determining it's CSS grid classes and then wrapping it with those classes
    var formatTemplate = function formatTemplate(product) {
      // Check if the product data was passed
      if (!product) {
        console.log('Error. Must provide a valid product in order to format it');
        return false;
      }

      //
      // Convert the product into a node.
      //

      // Parse the product HTML into a DOM node.
      var parser = new DOMParser();
      var doc = parser.parseFromString(product, 'text/html');

      // Get the template element.
      var template = doc.querySelector('[data-html="listing"]');

      // Check if we have a valid template element.
      if (!template) {
        console.log('Error. Could not find template elment.');
        return false;
      }

      //
      // Wrap the product in a div with grid classes.
      //

      // Create div element
      var productWrap = document.createElement('div');

      // Apply classes
      productWrap.classList.add('product', 'product-index', 'recently-viewed-products__product', 'js-product-listing');

      // Append product in wrapper element
      productWrap.appendChild(template.content);

      // Return the final product template
      return productWrap;
    };

    // Use fetch api to get product data and add it to the list
    var _moveAlong = function moveAlong() {
      if (productHandleQueue.length && shown < config.howManyToShow) {
        // Build fetch url
        var furl = "/products/".concat(productHandleQueue[0], "?view=listing");

        // Fetch the product data
        fetch(furl).then(function (response) {
          // Convert data to text
          return response.text();
        }).then(function (response) {
          // Get the formated product node with the data
          var product = formatTemplate(response);

          // Append the product to the wrapper element
          wrapper.appendChild(product);

          // Remove first element from the array
          productHandleQueue.shift();

          // Increment shown
          shown++;

          // Recursively call function
          _moveAlong();
        })["catch"](function (error) {
          // Log error
          console.log(error.message);
          // Remove first product from the array from the cookie
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          _moveAlong();
        });
      } else {
        finalize();
      }
    };
    publicAPIs.showRecentlyViewed = function (params) {
      var params = params || {};

      // Update defaults.
      config = Object.assign(config, params);

      // Reset
      shown = 0;
      productHandleQueue = [];
      wrapper = null;
      template = null;

      // Read cookie.
      productHandleQueue = cookie.read();

      // Get the wrapper element
      wrapper = document.getElementById(config.wrapperId);

      // If we have any to show.
      if (config.howManyToShow && wrapper) {
        // Getting each product with an Ajax call and rendering it on the page.
        _moveAlong();
      }
    };
    publicAPIs.getConfig = function () {
      return config;
    };
    publicAPIs.clearList = function () {
      cookie.destroy();
    };
    publicAPIs.getCount = function () {
      var productHandleQueue = cookie.read();
      return productHandleQueue.length;
    };
    publicAPIs.showRecentlyViewed(params);
    return publicAPIs;
  };
  return Constructor;
}();
Shopify.RecordViewedProducts = function () {
  // default configs
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 30,
    wrapperId: "recently-viewed-products",
    onComplete: null
  };

  // array containing recently viewed products
  var productHandleQueue = [];

  // wrapper element that displays the products
  var wrapper = null;

  // variable to keep track of how many products have been shown
  var shown = 0;

  // Handle cookie related operations
  var cookie = {
    configuration: {
      expires: 90,
      path: "/",
      domain: window.location.hostname
    },
    name: "shopify_recently_viewed",
    write: function write(recentlyViewed) {
      Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
    },
    read: function read() {
      var recentlyViewed = [];
      var cookieValue = Cookies.get(this.name);
      if (cookieValue !== undefined && cookieValue !== '') {
        recentlyViewed = cookieValue.split(" ");
      }
      return recentlyViewed;
    },
    destroy: function destroy() {
      Cookies.remove(this.name, null, this.configuration);
    },
    remove: function remove(productHandle) {
      var recentlyViewed = this.read();
      var position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };
  return {
    getConfig: function getConfig() {
      return config;
    },
    clearList: function clearList() {
      cookie.destroy();
    },
    getCount: function getCount() {
      var productHandleQueue = cookie.read();
      return productHandleQueue.length;
    },
    recordRecentlyViewed: function recordRecentlyViewed(params) {
      var params = params || {};

      // Update defaults.
      config = Object.assign(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf("/products/") !== -1) {
        // What is the product handle on this page.
        var urlPathname = new URL(window.location).pathname;
        var urlArray = decodeURIComponent(urlPathname).split('/');
        var productHandle = urlArray[urlArray.indexOf('products') + 1];
        if (!productHandle) {
          console.log('Error, no product handle found.');
          return false;
        }

        // In what position is that product in memory.
        var position = recentlyViewed.indexOf(productHandle);

        // If not in memory. (product handle was not found in the recentlyv)
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);

          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    }
  };
}();

/*============================================================================
  Other
==============================================================================*/
var mobile = window.matchMedia('(max-width: 740px)');
var tablet = window.matchMedia('(max-width: 979px) and (min-width: 741px)');
var desktop = window.matchMedia('(min-width: 980px)');
document.addEventListener("DOMContentLoaded", function () {
  (function initModals() {
    if (document.querySelector('[data-wau-modal-content="create-customer"]')) {
      WAU.Modal.init("create-customer");
    }
    if (document.querySelector('[data-wau-modal-content="send-invite"]')) {
      WAU.Modal.init("send-invite");
    }
    if (document.querySelector('[data-wau-modal-content="recover-password"]')) {
      WAU.Modal.init("recover-password");
    }
    if (document.querySelector('[data-wau-modal-content="new-address"]')) {
      WAU.Modal.init("new-address");
    }
    var modals = document.querySelectorAll('[data-wau-modal-content]');
    if (!modals) return false;
    modals.forEach(function (item, i) {
      var contentType = item.dataset.wauModalContent;
      if (contentType.includes("edit-address")) {
        WAU.Modal.init(item.dataset.wauModalContent);
      }
    });
  })();
});

/*============================================================================
  Announcement Bar Section
==============================================================================*/

var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};
theme.AnnouncementBar = function () {
  function AnnouncementBar(container) {
    /* lang and currency disclosure */
    this.container = container;
    this.cache = {};
    this.cacheSelectors();
    if (this.cache.localeDisclosure) {
      this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure);
    }
    if (this.cache.currencyDisclosure) {
      this.currencyDisclosure = new theme.Disclosure(this.cache.currencyDisclosure);
    }
  }
  ; // end AnnouncementBar function

  AnnouncementBar.prototype = _.assignIn({}, AnnouncementBar.prototype, {
    cacheSelectors: function cacheSelectors() {
      this.cache = {
        localeDisclosure: this.container.querySelector(selectors.disclosureLocale),
        currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency)
      };
    },
    onUnload: function onUnload() {
      if (this.cache.localeDisclosure) {
        this.localeDisclosure.destroy();
      }
      if (this.cache.currencyDisclosure) {
        this.currencyDisclosure.destroy();
      }
    }
  });
  return AnnouncementBar;
}();

/*============================================================================
  Header
==============================================================================*/

theme.Header = function () {
  function Header(container) {
    if ($('body').attr('class').indexOf('template-page-pre-checkout-upsell') !== -1) {
      return;
    }
    var mobileHeader = document.querySelector(".js-mobile-header"),
      blockTopWrapper = document.querySelector(".js-block-header"),
      clearElement = document.querySelector(".js-clear-element"),
      menuItemsWithNestedDropdowns = document.querySelectorAll(".js-menuitem-with-nested-dropdown"),
      doubleTapToGoItems = document.querySelectorAll(".js-doubletap-to-go"),
      topBar = document.querySelector(".js-top-bar"),
      isMobile = window.innerWidth <= 1220,
      isDesktop = window.innerWidth > 1220;
    prepareSticky();
    window.addEventListener('scroll', function (event) {
      prepareSticky();
    });
    window.addEventListener('resize', function (event) {
      prepareSticky();
    });
    window.addEventListener('shopify:section:select', function (event) {
      prepareSticky();
    });
    function prepareSticky() {
      var isMobileStyle = document.querySelector('.header__wrapper').classList.contains("mobile-style-true"),
        elementClass,
        elementHeight,
        amountToScroll;
      switch (isMobile || isMobileStyle) {
        case true:
          amountToScroll = topBar.clientHeight;
          elementClass = ".js-mobile-header";
          elementHeight = mobileHeader.clientHeight;
          break;
        case false:
          if (!blockTopWrapper) {
            amountToScroll = topBar.clientHeight;
          } else {
            amountToScroll = topBar.clientHeight + blockTopWrapper.clientHeight;
          }
          elementClass = ".js-theme-header";
          elementHeight = document.querySelector(".js-theme-header").clientHeight;
          break;
      }
      amountToScroll -= 10;
      return theme.Helpers.makeSticky(amountToScroll, elementClass, elementHeight);
    }

    // Aria support
    theme.a11yHelpers.setUpAriaExpansion();
    theme.a11yHelpers.setUpAccessibleNavigationMenus();

    // Making sure that nested dropdowns are properly placed in the correct place if they're offscreen.
    menuItemsWithNestedDropdowns.forEach(function (menuItem) {
      menuItem.addEventListener('mouseenter', function (event) {
        var nestedDropdown = menuItem.querySelector(".js-dropdown-nested");
        if (nestedDropdown) {
          if (theme.DOMHelpers.isElementPastEdge(nestedDropdown)) {
            nestedDropdown.classList.add("dropdown--edge");
          }
        }
      });
    });

    // Double Tap To Go on Tablets
    function closeMenu(activeClass) {
      document.querySelectorAll("[data-active-class=\"".concat(activeClass, "\"]")).forEach(function (activeMenu) {
        activeMenu.classList.remove(activeClass);
      });
    }
    doubleTapToGoItems.forEach(function (doubleTapItem) {
      var preventClick = false,
        prevEventTarget = undefined;
      var activeClass = doubleTapItem.getAttribute("data-active-class");
      Events.on("device:touchstart", function () {
        preventClick = true;
      });
      doubleTapItem.addEventListener("click", function (event) {
        if (preventClick) {
          event.preventDefault();
        }
      });
      doubleTapItem.addEventListener("touchstart", function (event) {
        event.target.setAttribute("aria-expanded", "false");
        closeMenu(activeClass);
        if (prevEventTarget === event.target) {
          preventClick = false;
        } else {
          event.target.classList.toggle(activeClass);
          event.target.setAttribute("aria-expanded", "true");
        }
        prevEventTarget = event.target;
      });
    });
  }
  Header.prototype = _.assignIn({}, Header.prototype, {
    onSelect: function onSelect() {
      WAU.Slideout.init("mobile-navigation");
      if (document.querySelector('[data-wau-modal-content="search-modal"]')) {
        WAU.Modal.init("search-modal");
      }
    }
  });
  return Header;
}();

/*============================================================================
  Image Carousel with Text Section
==============================================================================*/
theme.Carousel = function () {
  function Carousel(container) {
    var slideshows = document.querySelectorAll('.js-slideshow');
    slideshows.forEach(function (Slideshow) {
      if (isMobile || !Slideshow.classList.contains('mobile-carousel')) {
        var flktyData = Slideshow.getAttribute('data-flickity');
        var flktyOptions = JSON.parse(flktyData);
        new Flickity(Slideshow, flktyOptions);
      }
    });
  }
  return Carousel;
}();
theme.Carousel.prototype = _.assignIn({}, theme.Carousel.prototype, {
  onLoad: function onLoad(event) {
    var Slideshow = event.target.closest('.js-slideshow');
    var flktyData = Slideshow.getAttribute('data-flickity');
    var flktyOptions = JSON.parse(flktyData);
    new Flickity('.js-slideshow', flktyOptions);
  },
  onBlockSelect: function onBlockSelect(event) {
    var Slideshow = event.target.closest('.js-slideshow');
    var flkty = Flickity.data(Slideshow);
    var Slide = event.target.getAttribute("data-slider-index");
    flkty.select(Slide);
  }
});

/*============================================================================
  Collection List Section
==============================================================================*/
theme.CollectionList = function () {
  function CollectionList(container) {}
  CollectionList.prototype = _.assignIn({}, CollectionList.prototype, {});
  return CollectionList;
}();

/*============================================================================
  Collection Section
==============================================================================*/
theme.Collection = function () {
  function Collection(container) {
    if (container.querySelector("[data-collection-sidebar]")) {
      WAU.Slideout.init("collection-sidebar");
    }
    theme.CollectionPage.init(container, container.dataset.sectionId);
  }
  Collection.prototype = _.assignIn({}, Collection.prototype, {
    onBlockSelect: function onBlockSelect(event) {
      WAU.Slideout._openByName("collection-sidebar");
      var activeSlideout = document.querySelector('.slideout--active');
      var activeSlideoutName = activeSlideout.getAttribute('data-wau-slideout');
      WAU.Accordion.hideAll(activeSlideoutName);
      setTimeout(function () {
        var accordionContext = event.target.nextElementSibling;
        theme.CollectionPage.openAccordions(accordionContext);
      }, 500);
      document.addEventListener('shopify:section:unload', function (event) {
        WAU.Slideout._closeByName("collection-sidebar");
      });
    }
  });
  return Collection;
}();
theme.CollectionPage = {
  init: function init(container, sectionId) {
    if (container.querySelector("[data-collection-filter-results]")) {
      theme.CollectionPage.currentFilters();
    }
    if (container.querySelector("[data-collection-grid-layout]")) {
      theme.CollectionPage.gridLayout();
    }
    if (container.querySelector("[data-collection-accordion-links]")) {
      theme.CollectionPage.slideoutLinks();
    }
    if (container.querySelector("[data-collection-sidebar]") || container.querySelector("[data-collection-sort-by]")) {
      theme.CollectionPage.sidebarFilters();
    }
    if (container.querySelector("[data-collection-filters-price-range]")) {
      theme.CollectionPage.priceRange();
      theme.CollectionPage.priceSlider();
    }
    theme.CollectionPage.filterOptionToggles();
    this.filterData = [];
  },
  filterOptionToggles: function filterOptionToggles() {
    document.querySelector('.collection-template').addEventListener('click', function (event) {
      var btn = event.target.closest('.filter-option .button-as-link');
      if (btn) {
        var currentFilter = btn.closest('.filter-option');
        var topbar = currentFilter.closest('.collection-topbar');
        if (topbar) {
          topbar.querySelectorAll('.filter-option.active').forEach(function (el) {
            if (el !== currentFilter) el.classList.remove('active');
          });
        }
        currentFilter.classList.toggle('active');
      } else if (!event.target.closest('.filter-option')) {
        document.querySelectorAll('.collection-topbar .filter-option.active').forEach(function (el) {
          el.classList.remove('active');
        });
      }
    });
  },
  priceRange: function priceRange() {
    // Add filter to urlParm after text input changes
    var filters = document.querySelectorAll('.js-filter-range-input');
    if (filters.length > 0) {
      filters.forEach(function (item, i) {
        item.addEventListener('change', function (event) {
          setTimeout(function () {
            var searchParams = new URLSearchParams();
            document.querySelectorAll('.js-collection-side-filter input[type="checkbox"]:checked').forEach(function (cb) {
              searchParams.append(cb.name, cb.value);
            });
            document.querySelectorAll('.js-filter-range-input[type="number"]').forEach(function (input) {
              if (input.value) {
                searchParams.append(input.name, input.value);
              }
            });
            theme.CollectionPage.renderPage(searchParams.toString(), null, true);
          }, 1000);
        });
      });
    }
  },
  priceSlider: function priceSlider() {
    var parents = document.querySelectorAll(".js-price-range");
    if (!parents) return false;
    parents.forEach(function (parent, i) {
      var rangeS = parent.querySelectorAll("input[type=range]"),
        numberS = parent.querySelectorAll("input[type=number]");
      rangeS.forEach(function (el) {
        el.oninput = function () {
          var slide1 = parseFloat(rangeS[0].value),
            slide2 = parseFloat(rangeS[1].value);
          var slide1Dec = (Math.round(slide1 * 100) / 100).toFixed(2),
            slide2Dec = (Math.round(slide2 * 100) / 100).toFixed(2);
          if (parseFloat(slide1Dec) > parseFloat(slide2Dec)) {
            var _ref = [slide2Dec, slide1Dec];
            slide1Dec = _ref[0];
            slide2Dec = _ref[1];
          }
          numberS[0].value = slide1Dec;
          numberS[1].value = slide2Dec;
        };
      });
      rangeS[0].onchange = function () {
        numberS[0].dispatchEvent(new Event('change', {
          bubbles: true
        }));
      };
      rangeS[1].onchange = function () {
        numberS[1].dispatchEvent(new Event('change', {
          bubbles: true
        }));
      };
      numberS.forEach(function (el) {
        el.oninput = function () {
          var number1 = parseFloat(numberS[0].value),
            number2 = parseFloat(numberS[1].value);
          var number1Dec = (Math.round(number1 * 100) / 100).toFixed(2),
            number2Dec = (Math.round(number2 * 100) / 100).toFixed(2);
          if (number1Dec > number2Dec) {
            var tmp = number1Dec;
            numberS[0].value = number2Dec;
            numberS[1].value = tmp;
          }
          rangeS[0].value = number1Dec;
          rangeS[1].value = number2Dec;
        };
      });
    });
  },
  currentFilters: function currentFilters() {
    var filters = document.querySelectorAll('.js-current-filter');
    filters.forEach(function (item, i) {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        theme.CollectionPage.onActiveFilterClick(event);
      });
    });
  },
  sidebarFilters: function sidebarFilters(context) {
    document.querySelector('.collection-template').addEventListener('click', function (event) {
      var item = event.target.closest('.js-collection-side-filter');
      if (!item) return;
      event.preventDefault();
      if (item.querySelector('input[type="checkbox"]').checked) {
        item.classList.remove('current');
        item.querySelector('input[type="checkbox"]').checked = false;
      } else {
        item.classList.add('current');
        item.querySelector('input[type="checkbox"]').checked = true;
      }
      var searchParams = new URLSearchParams();
      document.querySelectorAll('.js-collection-side-filter input[type="checkbox"]:checked').forEach(function (cb) {
        searchParams.append(cb.name, cb.value);
      });
      document.querySelectorAll('.js-filter-range-input[type="number"]').forEach(function (input) {
        if (input.value) {
          searchParams.append(input.name, input.value);
        }
      });
      theme.CollectionPage.renderPage(searchParams.toString(), null, false);
    });
  },
  gridLayout: function gridLayout() {
    var gridIcons = document.querySelectorAll('.js-collection-layout');
    if (!gridIcons) return false;
    gridIcons.forEach(function (item, i) {
      item.addEventListener('click', function () {
        gridIcons.forEach(function (gridIcon) {
          gridIcon.classList.remove('active');
        });
        item.classList.add('active');
        var gridType = item.dataset.gridType;
        document.querySelector('.product-loop').setAttribute('data-grid-type', gridType);
      });
    });
  },
  slideoutLinks: function slideoutLinks() {
    var links = document.querySelectorAll('.js-collection-slideout-link');
    links.forEach(function (item, i) {
      item.addEventListener('click', function (event) {
        theme.CollectionPage.openAccordions(item);
      });
    });
  },
  openAccordions: function openAccordions(trigger) {
    var accordionContext = trigger.getAttribute('data-accordion-context');
    var slideout = document.getElementById('CollectionSidebarFiltersForm');
    if (isMobile) {
      var selectAccordions = slideout.querySelectorAll('.js-accordion-header[data-accordion-context="' + accordionContext + '"]');
      selectAccordions.forEach(function (item, i) {
        var target = item.querySelector('[data-toggle="accordion"]');
        WAU.Accordion.show(target, true);
      });
    } else {
      var accordionTarget = trigger.getAttribute('data-accordion-target');
      var accordionType = trigger.getAttribute('data-accordion-type');
      var target = slideout.querySelector('.js-accordion-header[data-accordion-target="' + accordionTarget + '"]');
      if (accordionType) {
        var options = target.nextElementSibling.querySelectorAll('.js-collection-side-filter');
        if (options.length) {
          options.forEach(function (item, i) {
            var optionType = item.getAttribute('data-type');
            if (optionType == accordionType) {
              item.parentNode.classList.remove('hidden');
            } else {
              item.parentNode.classList.add('hidden');
            }
          });
        }
      }
      WAU.Accordion.show(target, true);
    }
  },
  renderFilters: function renderFilters(accordionContext, sidebarOpen) {
    if (document.querySelector("[data-collection-filter-results]")) {
      theme.CollectionPage.currentFilters();
    }
    if (document.querySelector("[data-collection-sidebar]") || document.querySelector("[data-collection-sort-by]")) {
      // WAU.Slideout._reloadSlideoutContents("collection-sidebar");
      WAU.Slideout.init("collection-sidebar");
      if (sidebarOpen) {
        WAU.Slideout._openByName("collection-sidebar");
        if (accordionContext != null) theme.CollectionPage.openAccordions(accordionContext);
      }
    }
    if (document.querySelector("[data-collection-filters-price-range]")) {
      theme.CollectionPage.priceRange();
      theme.CollectionPage.priceSlider();
    }
    if (document.querySelector("[data-collection-grid-layout]")) {
      theme.CollectionPage.gridLayout();
    }
    if (document.querySelector("[data-collection-accordion-links]")) {
      theme.CollectionPage.slideoutLinks();
    }
    Shopify.theme.quickview.init();
  },
  renderSectionFromFetch: function renderSectionFromFetch(url, section, accordionContext, sidebarOpen) {
    var _this3 = this;
    fetch(url).then(function (response) {
      return response.text();
    }).then(function (responseText) {
      var html = responseText;
      _this3.filterData = [].concat(_toConsumableArray(_this3.filterData), [{
        html: html,
        url: url
      }]);
      theme.CollectionPage.renderProductGrid(html);
      theme.CollectionPage.renderFilters(accordionContext, sidebarOpen);
    });
  },
  renderSectionFromCache: function renderSectionFromCache(filterDataUrl, section, accordionContext, sidebarOpen) {
    var html = this.filterData.find(filterDataUrl).html;
    theme.CollectionPage.renderProductGrid(html);
    theme.CollectionPage.renderFilters(accordionContext, sidebarOpen);
  },
  renderPage: function renderPage(searchParams, accordionContext, sidebarOpen) {
    var _this4 = this;
    var updateURLHash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var sections = theme.CollectionPage.getSections();
    sections.forEach(function (section) {
      var url = "".concat(window.location.pathname, "?section_id=").concat(section.section, "&").concat(searchParams);
      var filterDataUrl = function filterDataUrl(element) {
        return element.url === url;
      };
      _this4.filterData.some(filterDataUrl) ? theme.CollectionPage.renderSectionFromCache(filterDataUrl, section, accordionContext, sidebarOpen) : theme.CollectionPage.renderSectionFromFetch(url, section, accordionContext, sidebarOpen);
    });
    setTimeout(function () {
      Shopify.theme.ajaxCart.init(), initializeFavorites();
    }, 1000);
    if (updateURLHash) theme.CollectionPage.updateURLHash(searchParams);
  },
  renderProductGrid: function renderProductGrid(html) {
    html = new DOMParser().parseFromString(html, 'text/html');
    var innerHTML = html.getElementById('CollectionProductGrid').innerHTML;
    var pagination = html.getElementById('pagination').innerHTML;
    document.getElementById('CollectionProductGrid').innerHTML = innerHTML;
    document.getElementById('pagination').innerHTML = pagination;
  },
  onActiveFilterClick: function onActiveFilterClick(event) {
    event.preventDefault();
    theme.CollectionPage.renderPage(new URL(event.currentTarget.href).searchParams.toString(), false);
  },
  updateURLHash: function updateURLHash(searchParams) {
    history.pushState({
      searchParams: searchParams
    }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));
  },
  getSections: function getSections() {
    return [{
      id: 'main-collection-product-grid',
      section: document.getElementById('main-collection-product-grid').dataset.id
    }];
  }
};

/*============================================================================
  Search Section
==============================================================================*/
theme.Search = function () {
  function Search(container) {
    if (container.querySelector("[data-collection-sidebar]")) {
      WAU.Slideout.init("collection-sidebar");
    }
    theme.SearchPage.init(container, container.dataset.sectionId);
  }
  Search.prototype = _.assignIn({}, Search.prototype, {});
  return Search;
}();
theme.SearchPage = {
  init: function init(container, sectionId) {
    if (container.querySelector("[data-collection-filter-results]")) {
      theme.SearchPage.currentFilters();
    }
    if (container.querySelector("[data-collection-grid-layout]")) {
      theme.SearchPage.gridLayout();
    }
    if (container.querySelector("[data-collection-accordion-links]")) {
      theme.SearchPage.slideoutLinks();
    }
    if (container.querySelector("[data-collection-sidebar]") || container.querySelector("[data-collection-sort-by]")) {
      theme.SearchPage.sidebarFilters();
    }
    if (container.querySelector("[data-collection-filters-price-range]")) {
      theme.SearchPage.priceRange();
      theme.SearchPage.priceSlider();
    }
    this.filterData = [];
  },
  priceRange: function priceRange() {
    // Add filter to urlParm after text input changes
    var filters = document.querySelectorAll('.js-filter-range-input');
    if (filters.length > 0) {
      filters.forEach(function (item, i) {
        item.addEventListener('change', function (event) {
          setTimeout(function () {
            var formData = new FormData(item.closest('form'));
            var searchParams = new URLSearchParams(formData); //.toString();
            //const accordionContext = item.closest('.c-accordion__panel');
            //var searchString = window.location.search.toString(),
            //searchString = searchString.replace('?', '');
            //const finalSearchParams = searchString + '&' + searchParams;

            theme.SearchPage.searchFilter(searchParams);

            //theme.SearchPage.renderPage(finalSearchParams, accordionContext, true);
          }, 1000);
        });
      });
    }
  },
  priceSlider: function priceSlider() {
    var parents = document.querySelectorAll(".js-price-range");
    if (!parents) return false;
    parents.forEach(function (parent, i) {
      var rangeS = parent.querySelectorAll("input[type=range]"),
        numberS = parent.querySelectorAll("input[type=number]");
      rangeS.forEach(function (el) {
        el.oninput = function () {
          var slide1 = parseFloat(rangeS[0].value),
            slide2 = parseFloat(rangeS[1].value);
          var slide1Dec = (Math.round(slide1 * 100) / 100).toFixed(2),
            slide2Dec = (Math.round(slide2 * 100) / 100).toFixed(2);
          if (parseFloat(slide1Dec) > parseFloat(slide2Dec)) {
            var _ref2 = [slide2Dec, slide1Dec];
            slide1Dec = _ref2[0];
            slide2Dec = _ref2[1];
          }
          numberS[0].value = slide1Dec;
          numberS[1].value = slide2Dec;
        };
      });
      rangeS[0].onchange = function () {
        numberS[0].dispatchEvent(new Event('change', {
          bubbles: true
        }));
      };
      rangeS[1].onchange = function () {
        numberS[1].dispatchEvent(new Event('change', {
          bubbles: true
        }));
      };
      numberS.forEach(function (el) {
        el.oninput = function () {
          var number1 = parseFloat(numberS[0].value),
            number2 = parseFloat(numberS[1].value);
          var number1Dec = (Math.round(number1 * 100) / 100).toFixed(2),
            number2Dec = (Math.round(number2 * 100) / 100).toFixed(2);
          if (number1Dec > number2Dec) {
            var tmp = number1Dec;
            numberS[0].value = number2Dec;
            numberS[1].value = tmp;
          }
          rangeS[0].value = number1Dec;
          rangeS[1].value = number2Dec;
        };
      });
    });
  },
  currentFilters: function currentFilters() {
    var filters = document.querySelectorAll('.js-current-filter');
    filters.forEach(function (item, i) {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        theme.SearchPage.onActiveFilterClick(event);
      });
    });
  },
  sidebarFilters: function sidebarFilters(context) {
    var filters = document.querySelectorAll('.js-collection-side-filter');
    filters.forEach(function (item, i) {
      if (!item.classList.contains('init')) {
        item.classList.add('init');
        item.addEventListener('click', function (event) {
          event.preventDefault();
          if (item.querySelector('input[type="checkbox"]').checked) {
            item.classList.remove('current');
            item.querySelector('input[type="checkbox"]').checked = false;
          } else {
            item.classList.add('current');
            item.querySelector('input[type="checkbox"]').checked = true;
          }
          var formData = new FormData(item.closest('form'));
          var searchParams = new URLSearchParams(formData); //.toString();
          //const accordionContext = item.closest('.c-accordion__panel');
          //var searchString = window.location.search.toString(),
          //searchString = searchString.replace('?', '');
          //const finalSearchParams = searchString + '&' + searchParams;

          theme.SearchPage.searchFilter(searchParams);

          //theme.SearchPage.renderPage(finalSearchParams, accordionContext, true);
        });
      }
    });
  },
  searchFilter: function searchFilter(searchParams) {
    var filterValues = [];
    var _iterator = _createForOfIteratorHelper(searchParams.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          _key3 = _step$value[0],
          value = _step$value[1];
        if (value) {
          var _k = _key3.replace(/filter\.[a-z]\./, '').replace('.', '_');
          if (typeof filterValues[_k] !== 'undefined' && filterValues[_k].indexOf(value) === -1) {
            filterValues[_k] += '|' + value;
          } else {
            filterValues[_k] = value;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    filterString = '';
    if (!$.isEmptyObject(filterValues)) {
      for (var k in filterValues) {
        filterString += (filterString.length ? '&' : '') + k + '=' + filterValues[k];
      }
    }
    if (typeof productSearch !== 'undefined') {
      productSearch.filter = filterString;
      jsonSearch(productSearch);
    }
    if (typeof recipeSearch !== 'undefined') {
      recipeSearch.filter = filterString;
      jsonSearch(recipeSearch);
    }
    if (typeof articleSearch !== 'undefined') {
      articleSearch.filter = filterString;
      jsonSearch(articleSearch);
    }
    if (typeof pageSearch !== 'undefined') {
      pageSearch.filter = filterString;
      jsonSearch(pageSearch);
    }
    WAU.Slideout._closeByName("collection-sidebar");
  },
  gridLayout: function gridLayout() {
    var gridIcons = document.querySelectorAll('.js-collection-layout');
    if (!gridIcons) return false;
    gridIcons.forEach(function (item, i) {
      item.addEventListener('click', function () {
        gridIcons.forEach(function (gridIcon) {
          gridIcon.classList.remove('active');
        });
        item.classList.add('active');
        var gridType = item.dataset.gridType;
        document.querySelector('.search__grid').setAttribute('data-grid-type', gridType);
      });
    });
  },
  slideoutLinks: function slideoutLinks() {
    var links = document.querySelectorAll('.js-collection-slideout-link');
    links.forEach(function (item, i) {
      item.addEventListener('click', function (event) {
        theme.SearchPage.openAccordions(item);
      });
    });
  },
  openAccordions: function openAccordions(trigger) {
    var accordionContext = trigger.getAttribute('data-accordion-context');
    var slideout = document.getElementById('CollectionSidebarFiltersForm');
    if (isMobile) {
      var selectAccordions = slideout.querySelectorAll('.js-accordion-header[data-accordion-context="' + accordionContext + '"]');
      selectAccordions.forEach(function (item, i) {
        var target = item.querySelector('[data-toggle="accordion"]');
        WAU.Accordion.show(target, true);
      });
    } else {
      var accordionTarget = trigger.getAttribute('data-accordion-target');
      var accordionType = trigger.getAttribute('data-accordion-type');
      var target = slideout.querySelector('.js-accordion-header[data-accordion-target="' + accordionTarget + '"]');
      if (accordionType) {
        var options = target.nextElementSibling.querySelectorAll('.js-collection-side-filter');
        if (options.length) {
          options.forEach(function (item, i) {
            var optionType = item.getAttribute('data-type');
            if (optionType == accordionType) {
              item.parentNode.classList.remove('hidden');
            } else {
              item.parentNode.classList.add('hidden');
            }
          });
        }
      }
      WAU.Accordion.show(target, true);
    }
  },
  renderFilters: function renderFilters(accordionContext, sidebarOpen) {
    if (document.querySelector("[data-collection-filter-results]")) {
      theme.SearchPage.currentFilters();
    }
    if (document.querySelector("[data-collection-sidebar]") || document.querySelector("[data-collection-sort-by]")) {
      // WAU.Slideout._reloadSlideoutContents("collection-sidebar");
      WAU.Slideout.init("collection-sidebar");
      theme.SearchPage.sidebarFilters();
      if (sidebarOpen) {
        WAU.Slideout._openByName("collection-sidebar");
        if (accordionContext != null) theme.SearchPage.openAccordions(accordionContext);
      }
    }
    if (document.querySelector("[data-collection-filters-price-range]")) {
      theme.SearchPage.priceRange();
      theme.SearchPage.priceSlider();
    }
    if (document.querySelector("[data-collection-grid-layout]")) {
      theme.SearchPage.gridLayout();
    }
    if (document.querySelector("[data-collection-accordion-links]")) {
      theme.SearchPage.slideoutLinks();
    }
    Shopify.theme.quickview.init();
  },
  renderSectionFromFetch: function renderSectionFromFetch(url, section, accordionContext, sidebarOpen) {
    var _this5 = this;
    fetch(url).then(function (response) {
      return response.text();
    }).then(function (responseText) {
      var html = responseText;
      _this5.filterData = [].concat(_toConsumableArray(_this5.filterData), [{
        html: html,
        url: url
      }]);
      theme.SearchPage.renderSearchGrid(html);
      theme.SearchPage.renderFilters(accordionContext, sidebarOpen);
    });
  },
  renderSectionFromCache: function renderSectionFromCache(filterDataUrl, section, accordionContext, sidebarOpen) {
    var html = this.filterData.find(filterDataUrl).html;
    theme.SearchPage.renderSearchGrid(html);
    theme.SearchPage.renderFilters(accordionContext, sidebarOpen);
  },
  renderPage: function renderPage(searchParams, accordionContext, sidebarOpen) {
    var _this6 = this;
    var updateURLHash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var sections = theme.SearchPage.getSections();
    sections.forEach(function (section) {
      var url = "".concat(window.location.pathname, "?section_id=").concat(section.section, "&").concat(searchParams);
      var filterDataUrl = function filterDataUrl(element) {
        return element.url === url;
      };
      _this6.filterData.some(filterDataUrl) ? theme.SearchPage.renderSectionFromCache(filterDataUrl, section, accordionContext, sidebarOpen) : theme.SearchPage.renderSectionFromFetch(url, section, accordionContext, sidebarOpen);
    });
    if (updateURLHash) theme.SearchPage.updateURLHash(searchParams);
  },
  renderSearchGrid: function renderSearchGrid(html) {
    var innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('searchResultsWrapper').innerHTML;
    document.getElementById('searchResultsWrapper').innerHTML = innerHTML;
  },
  onActiveFilterClick: function onActiveFilterClick(event) {
    event.preventDefault();
    var searchParams = new URL(event.currentTarget.href).searchParams.toString();
    var searchString = new URL(window.location).searchParams.get('q');
    var finalSearchParams = searchParams ? searchParams : 'q=' + searchString;
    theme.SearchPage.renderPage(finalSearchParams);
  },
  updateURLHash: function updateURLHash(searchParams) {
    history.pushState({
      searchParams: searchParams
    }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));
  },
  getSections: function getSections() {
    return [{
      id: 'main-search-results',
      section: document.getElementById('main-search-results').dataset.id
    }];
  }
};

/*============================================================================
  Product Modules
==============================================================================*/
var mobile = window.matchMedia('(max-width: 740px)');
var tablet = window.matchMedia('(max-width: 979px) and (min-width: 741px)');
var desktop = window.matchMedia('(min-width: 980px)');
theme.ProductForm = function (context, sectionId, events, Product) {
  var prodForm = context.querySelector("#product-form-".concat(sectionId));
  var config = JSON.parse(prodForm.dataset.productForm || '{}');
  var selector, varSelectors, options, variant;
  context.querySelectorAll('.formVariantId').forEach(function (item, i) {
    item.setAttribute('name', 'id');
  });
  (function quantity() {
    var elements = context.querySelectorAll("[name=quantity]");
    if (!elements) {
      return false;
    }
    elements.forEach(function (element, i) {
      events.on("quantitycontrol:click", change);
      events.on("variantchange", reset);
      function change(value) {
        var quantity = parseInt(element.value) + value;
        if (quantity < 1) {
          return false;
        }
        element.value = quantity;
      }
      function reset() {
        element.value = 1;
      }
    });
  })();
  (function quantity_controls() {
    Control(".quantity-control-up", 1);
    Control(".quantity-control-down", -1);
    function Control(selector, value) {
      var element = context.querySelector(selector);
      if (!element) {
        return false;
      }
      element.addEventListener("click", function (event) {
        event.preventDefault();
        events.trigger("quantitycontrol:click", value);
      });
    }
  })();
  if (Product.variants.length == 1) {
    if (context.querySelector('[data-store-availability-container]')) {
      events.trigger("storeavailability:variant", Product.variants[0].id, Product.title, context);
    }
    return false;
  }

  // variant only js below
  if (Product.has_only_default_variant) return false;
  varSelectors = context.querySelectorAll('.js-variant-selector');
  varSelectors.forEach(function (item, i) {
    item.addEventListener("change", function (event) {
      event.preventDefault();
      if (config.swatches == 'swatches') {
        var swatches = Array.from(varSelectors);
        options = swatches.map(function (swatch) {
          return Array.from(swatch.querySelectorAll('input')).find(function (radio) {
            return radio.checked;
          }).value;
        });
      } else {
        options = Array.from(context.querySelectorAll('select.js-variant-selector'), function (select) {
          return select.value;
        });
      }
      variant = Product.variants.find(function (variant) {
        return !variant.options.map(function (option, index) {
          return options[index] === option;
        }).includes(false);
      });
      variantEvents(context, variant, config);
    });
  });
  (function sale_icon() {
    var acceptedFormats = {
      "icon": "icon",
      "percentage": "percentage",
      "amount": "amount"
    };
    var selectors = {
      salePriceBadge: ".price__badge.price__badge--sale"
    };
    var saleIconEl = context.querySelector(selectors.salePriceBadge);
    var dataFormat = context.dataset.saleFormat;
    var savingsString = config.savings;
    if (typeof money !== 'function') {
      console.log('sale_icon:: Error. Money helper function is not available.');
      return false;
    }
    if (dataFormat == acceptedFormats.icon) {
      console.log('sale_icon:: Error. Format does not match an accepted format.');
      return false;
    }
    if (!config) {
      console.log('sale_icon:: Error. Do not have access to the config object for translations.');
      return false;
    }
    if (!saleIconEl) {
      console.log('sale_icon:: Error. No Sale icon element to work with.');
      return false;
    }
    function salePercentage(variant) {
      var difference = variant.compare_at_price - variant.price;
      var differencePercentage = Math.floor(difference / variant.compare_at_price * 100);
      return differencePercentage + '%';
    }
    ;
    function saleAmount(variant) {
      var difference = variant.compare_at_price - variant.price;
      return money(difference);
    }
    ;
    function showDiscount(variant, format, string) {
      var regex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /{{ savings }}/i;
      if (!variant) {
        console.log('Error. No variant passed into function.');
        return false;
      }
      if (!format) {
        console.log('Error. No format was passed into function.');
        return false;
      }
      if (!string) {
        console.log('Error. No string passed into function.');
        return false;
      }
      switch (format) {
        case acceptedFormats.percentage:
          return string.replace(regex, salePercentage(variant));
          break;
        case acceptedFormats.amount:
          return string.replace(regex, saleAmount(variant));
          break;
      }
      ;
    }
    ;
    function updateSaleIcon(variant) {
      if (variant.compare_at_price > variant.price) {
        saleIconEl.innerHTML = showDiscount(variant, dataFormat, savingsString);
      }
    }
    events.on("variantchange", updateSaleIcon);
  })();
  (function variantInventoryQuantity() {
    var classes = {
      variantStockLevels: 'js-variant-stock-levels',
      variantStockLevelsMessage: 'js-variant-stock-levels__message',
      hide: 'visually-hidden'
    };
    var selectors = {
      variantStockLevels: '.' + classes.variantStockLevels,
      variantStockLevelsMessage: '.' + classes.variantStockLevelsMessage,
      variantStockLevelsTheshold: 'data-variant-stock-level-threshold'
    };
    var DEFAULT_LIMIT = 11;
    var variantStockLevelEl = context.querySelector(selectors.variantStockLevels);
    var variantStockLevelMessageEl = context.querySelector(selectors.variantStockLevelsMessage);
    if (!variantStockLevelEl) {
      console.log('Error. Could not find product inventory element.');
      return false;
    }
    var stockLevelThreshold = variantStockLevelEl.getAttribute(selectors.variantStockLevelsTheshold) !== undefined ? parseInt(variantStockLevelEl.dataset.stockLevelThreshold, 10) : DEFAULT_LIMIT;
    var checkFadeSupport = function checkFadeSupport() {
      return typeof theme.Helpers.fadeIn === 'function' && typeof theme.Helpers.fadeOut === 'function';
    };
    var showElement = function showElement(element) {
      if (!element) return;
      element.classList.remove(classes.hide);
      if (checkFadeSupport) {
        theme.Helpers.fadeIn(element);
      }
    };
    var hideElement = function hideElement(element) {
      if (!element) return;
      if (checkFadeSupport) {
        theme.Helpers.fadeOut(element);
      }
      // element.classList.add(classes.hide);
    };
    var getMessage = function getMessage(config, quantity) {
      var regex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : /{{ count }}/;
      if (quantity == 1) {
        if (config.only_left.one.includes(regex.source)) {
          return config.only_left.one.replace(regex, quantity);
        } else {
          return config.only_left.one;
        }
      } else {
        if (config.only_left.one.includes(regex.source)) {
          return config.only_left.other.replace(regex, quantity);
        } else {
          return config.only_left.other;
        }
      }
    };
    events.on("variantchange", function (variant) {
      if (variant.inventory_management && variant.inventory_quantity < stockLevelThreshold && variant.inventory_quantity > 0) {
        variantStockLevelMessageEl.innerHTML = getMessage(config, variant.inventory_quantity);
        showElement(variantStockLevelEl);
      } else {
        hideElement(variantStockLevelEl);
      }
    });
    events.on("variantunavailable", function (variant) {
      hideElement(variantStockLevelEl);
    });
  })();
  (function swatches() {
    var elements = context.querySelectorAll("[type=radio]");
    if (!elements) return false;
    var states = {
      sold_out: function sold_out(element) {
        element.parentElement.classList.add("soldout");
      },
      available: function available(element) {
        element.parentElement.classList.remove("soldout");
      }
    };
    events.on("variantunavailable", set_unavailable);
    elements.forEach(Swatch);
    var swatchLabel = context.querySelectorAll(".swatches__form--label");
    swatchLabel.forEach(selectInput);
    function set_unavailable() {
      var selected = {};
      var selected_elements = document.querySelectorAll("[type=radio]:checked");
      selected_elements.forEach(function (element) {
        var option = "option" + element.getAttribute("data-position");
        var value = element.value;
        selected[option] = value;
      });
      elements.forEach(function (element) {
        var available = false;
        var current_option = "option" + element.getAttribute("data-position");
        var current_value = element.value;
        var other_options = ["option1", "option2", "option3"].filter(function (option) {
          return selected[option] && option != current_option;
        });
        Product.variants.forEach(function (variant) {
          if (!variant.available) {
            return;
          }
          if (variant[current_option] != current_value) {
            return;
          }
          if (variant[other_options[0]] == selected[other_options[0]] && variant[other_options[1]] == selected[other_options[1]]) {
            available = true;
            return;
          }
        });
        if (available) {
          states.available(element);
        } else {
          states.sold_out(element);
        }
      });
    }
    function Swatch(element) {
      var option_position = element.getAttribute("data-position");
      var current_option = "option" + option_position;
      var other_options = ["option1", "option2", "option3"].filter(function (option) {
        return option != current_option;
      });
      element.addEventListener("change", function (event) {
        var selectedLabel = context.querySelector('#selected-option-' + option_position);

        //selectedLabel.innerHTML = element.value;

        events.trigger("swatch:change:" + option_position, element.value);
        var optionSet = $(this).closest('.swatch').data('option-index');
        $('.swatch[data-option-index="' + optionSet + '"] .swatch-element').each(function () {
          if ($(this).find('label').text().trim() == element.value.trim()) {
            $(this).addClass('selected');
          } else {
            $(this).removeClass('selected');
          }
        });
      });
      events.on("variantchange:option" + option_position + ":" + element.value, select);
      events.on("variantchange", set_availability);
      function select() {
        element.checked = true;
      }
      function set_availability(current_variant) {
        var available = false;
        Product.variants.forEach(function (variant) {
          if (!variant.available) {
            return;
          }
          if (variant[current_option] != element.value) {
            return;
          }
          if (variant[other_options[0]] != current_variant[other_options[0]]) {
            return;
          }
          if (variant[other_options[1]] != current_variant[other_options[1]]) {
            return;
          }
          available = true;
        });
        if (available) {
          states.available(element);
        } else {
          states.sold_out(element);
        }
      }
    }
    function selectInput(element) {
      element.addEventListener("keyup", function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          var input = event.target.parentNode.querySelector(".swatches__form--input");
          input.click();
        }
      });
    }
  })();
  (function price() {
    var element = context.querySelector(".price__regular .price-item--regular");
    if (!element) return false;
    events.on("variantchange", function (variant) {
      var price = money(variant.price);
      element.innerHTML = price;
      events.on("variantunavailable", function (variant) {
        price = config.unavailable;
        element.innerHTML = price;
      });
    });
  })();
  (function price_classes() {
    var element = context.querySelector("[data-price]");
    if (!element) return false;
    events.on("variantchange", function (variant) {
      if (variant.available && variant.compare_at_price > variant.price) {
        element.classList.add('price--on-sale');
        element.classList.remove('price--sold-out');
      } else if (!variant.available && variant.compare_at_price > variant.price) {
        element.classList.add('price--sold-out');
        element.classList.add('price--on-sale');
      } else if (!variant.available) {
        element.classList.add('price--sold-out');
        element.classList.remove('price--on-sale');
      } else {
        element.classList.remove('price--on-sale');
        element.classList.remove('price--sold-out');
      }
      if (variant.unit_price_measurement) {
        element.classList.add('price--unit-available');
      } else {
        element.classList.remove('price--unit-available');
      }
    });
  })();
  (function unit_price() {
    var element = context.querySelector("[data-unit-price]");
    var wrapper = context.querySelector(".price__unit");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant) {
      var unitPrice = "";
      if (variant.unit_price) {
        unitPrice = theme.Helpers.formatMoney(variant.unit_price, config.money_format);
        +' ' + config.unit_price_separator + ' ' + getBaseUnit(variant);
        wrapper.style.display = "flex";
      } else {
        wrapper.style.display = "none";
      }
      element.innerHTML = unitPrice;
    });
  })();
  (function compare_price() {
    var saleEl = context.querySelector(".price__sale .price-item--sale");
    var regEl = context.querySelector(".price__sale .price-item--regular");
    if (!saleEl) {
      return false;
    }
    events.on("variantchange", function (variant) {
      var salePrice = "",
        regPrice = "";
      if (variant.compare_at_price > variant.price) {
        regPrice = money(variant.compare_at_price);
        salePrice = money(variant.price);
      }
      saleEl.innerHTML = salePrice;
      regEl.innerHTML = regPrice;
    });
  })();
  (function add_to_cart() {
    var element = context.querySelector(".js-ajax-submit");
    if (!element) return false;
    events.on("variantchange", function (variant) {
      var text = config.button;
      var disabled = false;
      if (!variant.available) {
        text = config.sold_out;
        disabled = true;
      }
      element.value = text;
      element.disabled = disabled;
    });
    events.on("variantunavailable", function () {
      element.value = config.unavailable;
      element.disabled = true;
    });
  })();
  (function shop_pay() {
    var element = context.querySelector('.product-form-installment');
    if (!element) return false;
    var input = element.querySelector('input[name="id"]');
    var selectId = element.querySelector('select[name="id"]');
    events.on("variantchange", function (variant) {
      selectId.value = parseInt(variant.id);
      input.value = variant.id;
      selectId.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
  })();
  (function smart_payment_buttons() {
    var element = context.querySelector(".shopify-payment-button");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant) {
      if (!variant.available) {
        element.style.display = 'none';
      } else {
        element.style.display = 'block';
      }
    });
  })();
  (function sticky_bar() {
    var stickyBar = document.getElementById('sticky-cart');
    if (!stickyBar) return false;
    events.on("variantchange", function (variant) {
      var isMain = context.getAttribute("data-main-product");
      if (isMain === null) return false;
      (function price() {
        var element = context.querySelector("#sticky-cart .price__regular .price-item--regular");
        var price = money(variant.price);
        element.innerHTML = price;
        events.on("variantunavailable", function (variant) {
          price = config.unavailable;
          element.innerHTML = price;
        });
      })();
      (function price_classes() {
        var element = context.querySelector("#sticky-cart [data-price]");
        if (variant.available && variant.compare_at_price > variant.price) {
          element.classList.add('price--on-sale');
          element.classList.remove('price--sold-out');
        } else if (!variant.available && variant.compare_at_price > variant.price) {
          element.classList.add('price--sold-out');
          element.classList.add('price--on-sale');
        } else if (!variant.available) {
          element.classList.add('price--sold-out');
          element.classList.remove('price--on-sale');
        } else {
          element.classList.remove('price--on-sale');
          element.classList.remove('price--sold-out');
        }
        if (variant.unit_price_measurement) {
          element.classList.add('price--unit-available');
        } else {
          element.classList.remove('price--unit-available');
        }
      })();
      (function unit_price() {
        var element = context.querySelector("#sticky-cart [data-unit-price]");
        var wrapper = context.querySelector("#sticky-cart .price__unit");
        if (!element) {
          return false;
        }
        var unitPrice = "";
        if (variant.unit_price) {
          unitPrice = theme.Helpers.formatMoney(variant.unit_price, config.money_format);
          +' ' + config.unit_price_separator + ' ' + getBaseUnit(variant);
          wrapper.style.display = "flex";
        } else {
          wrapper.style.display = "none";
        }
        element.innerHTML = unitPrice;
      })();
      (function compare_price() {
        var saleEl = context.querySelector("#sticky-cart .price__sale .price-item--sale");
        var regEl = context.querySelector("#sticky-cart .price__sale .price-item--regular");
        if (!saleEl) {
          return false;
        }
        var salePrice = "",
          regPrice = "";
        if (variant.compare_at_price > variant.price) {
          regPrice = money(variant.compare_at_price);
          salePrice = money(variant.price);
        }
        saleEl.innerHTML = salePrice;
        regEl.innerHTML = regPrice;
      })();

      // Update Option 1
      var option1 = stickyBar.querySelector('#current-option-1 .option-selected');
      if (option1) {
        stickyBar.querySelector('#current-option-1 .option-selected').innerHTML = variant.option1;
      }
      var option2 = stickyBar.querySelector('#current-option-2 .option-selected');
      if (option2) {
        stickyBar.querySelector('#current-option-2 .option-selected').innerHTML = variant.option2;
      }
      var option3 = stickyBar.querySelector('#current-option-3 .option-selected');
      if (option3) {
        stickyBar.querySelector('#current-option-3 .option-selected').innerHTML = variant.option3;
      }

      // Update button
      var button = stickyBar.querySelector(".sticky-add");
      var text = config.button;
      var disabled = false;
      if (!variant.available) {
        text = config.sold_out;
        disabled = true;
      }
      button.value = text;
      button.disabled = disabled;
      events.on("variantunavailable", function () {
        button.value = config.unavailable;
        button.disabled = true;
      });
    });
  })();
  (function variant_weight() {
    var element = context.querySelector(".js-variant-weight");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant) {
      var variant_weight = "".concat(variant.weight_in_unit, " ").concat(variant.weight_unit);
      element.innerHTML = variant_weight;
      if (variant_weight === "") {
        context.querySelector(".js-variant-weight-container").classList.add('hide');
      } else {
        context.querySelector(".js-variant-weight-container").classList.remove('hide');
      }
    });
    events.on("variantunavailable", function (variant) {
      var variant_weight = config.unavailable;
      element.innerHTML = variant_weight;
    });
  })();
  (function variant_inventory() {
    var element = context.querySelector(".js-variant-inventory");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant) {
      var variant_inventory = variant.inventory_quantity;
      element.innerHTML = variant_inventory;
      if (variant_inventory === "") {
        context.querySelector(".js-variant-inventory-container").classList.add('hide');
      } else {
        context.querySelector(".js-variant-inventory-container").classList.remove('hide');
      }
    });
    events.on("variantunavailable", function (variant) {
      var variant_inventory = config.unavailable;
      element.innerHTML = variant_inventory;
    });
  })();
  (function variant_selected() {
    var element = context.querySelector(".js-variant-selected");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant) {
      var variant_title = variant.title;
      element.innerHTML = variant_title;
      if (variant_title === "") {
        context.querySelector(".js-variant-selected-container").classList.add('hide');
      } else {
        context.querySelector(".js-variant-selected-container").classList.remove('hide');
      }
    });
    events.on("variantunavailable", function (variant) {
      var variant_title = config.unavailable;
      element.innerHTML = variant_title;
    });
  })();
  (function variant_sku() {
    var element = context.querySelector(".js-product-sku");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant) {
      var variant_sku = variant.sku;
      element.innerHTML = variant_sku;
      if (variant_sku === "") {
        context.querySelector(".js-product-sku-container").classList.add('hide');
      } else {
        context.querySelector(".js-product-sku-container").classList.remove('hide');
      }
    });
    events.on("variantunavailable", function (variant) {
      var variant_sku = config.unavailable;
      element.innerHTML = variant_sku;
    });
  })();
  function money(cents) {
    return theme.Helpers.formatMoney(cents, config.money_format);
  }
  function getBaseUnit(variant) {
    return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
  }
  function variantEvents(context, variant, config) {
    if (!variant) {
      events.trigger("variantunavailable", config);
      Events.trigger("storeavailability:unavailable");
      return;
    }
    if (Product.variants.length == 1) {
      if (!variant.available) {
        var element = context.querySelector(".product-price");
        element.innerHTML = config.sold_out;
      }
      return;
    }
    events.trigger("variantchange", variant, config);
    events.trigger("variantchange:option1:" + variant.option1);
    events.trigger("variantchange:option2:" + variant.option2);
    events.trigger("variantchange:option3:" + variant.option3);
    if (context.querySelector('[data-store-availability-container]')) {
      events.trigger("storeavailability:variant", variant.id, Product.title, context);
    }
    if (variant.featured_media) {
      //Events.trigger("variantchange:image", variant.featured_media.id, context);
    }
    if (config.enable_history) historyState(variant, context);
    updateVariantInput(variant, context);
  }
  function historyState(variant, context) {
    if (!variant) return;
    if ($('.variant-contents').length > 0) {
      window.location.href = "".concat(context.dataset.url, "?variant=").concat(variant.id);
    } else {
      window.history.replaceState({}, '', "".concat(context.dataset.url, "?variant=").concat(variant.id));
    }
  }
  function updateVariantInput(variant, context) {
    context.querySelectorAll('.formVariantId').forEach(function (item, i) {
      item.setAttribute('name', 'id');
      item.value = variant.id;
      item.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
    $('.add-to-cart').attr('data-item-id', variant.id);
    showPDPVariantImages(variant.id);
  }
};
theme.ProductGallery = function () {
  function init(context, sectionId, events, Product) {
    var config = JSON.parse(context.querySelector('.js-product-gallery').dataset.galleryConfig || '{}'),
      main = context.querySelector('.js-carousel-main'),
      carouselNav = context.querySelector('.js-thumb-carousel-nav');
    if (!main) return false;
    this.mainSlider(main, carouselNav, config, context);
    if (config.thumbPosition == 'bottom' && config.thumbSlider == true) this.thumbSlider(carouselNav, main, context);
    if (config.clickToEnlarge) theme.ProductGallery.enlargePhoto(context);
  }
  function mainSlider(main, carouselNav, config, context) {
    var initialEl = main.querySelector("[data-image-id='" + context.dataset.initialVariant + "']"),
      initialIndex;
    if (initialEl) {
      initialIndex = initialEl.dataset.slideIndex;
    } else {
      initialIndex = 0;
    }
    if (config.navStyle == 'dots') {
      var dots = true,
        arrows = false;
    } else {
      var dots = false,
        arrows = true;
    }
    var flkty = new Flickity(main, {
      // options
      fade: false,
      wrapAround: false,
      cellAlign: 'left',
      draggable: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: false,
      selectedAttraction: 0.01,
      adaptiveHeight: true,
      imagesLoaded: true,
      initialIndex: initialIndex,
      on: {
        ready: function ready() {
          var id = this.selectedElement.dataset.imageId;

          /* Fade in */
          context.querySelector('.js-product-gallery').style.visibility = "visible";
        },
        change: function change() {
          /* Set focus control on change */
          theme.ProductGallery.removeFocus(context);
          theme.ProductGallery.addFocus(this.selectedElement, context);

          /* Set media */
          theme.ProductGallery.setActiveThumbnail(this.selectedElement.dataset.imageId, this.selectedElement, context);
          theme.ProductGallery.switchMedia(this.selectedElement.dataset.imageId, context);

          /* Allow model drag */
          if (this.selectedElement.classList.contains('model-slide')) {
            if (this.isDraggable) {
              /* Turn off drag for model usage */
              this.options.draggable = !this.options.draggable;
              this.updateDraggable();
            }
          }
        }
      }
    });
    theme.ProductGallery.galleryEvents(flkty, context);
    if (carouselNav) theme.ProductGallery.thumbnails(flkty, carouselNav, config, context);
  }
  function thumbSlider(wrapper, main, context) {
    var flktyThumbs = new Flickity(wrapper, {
      // options
      wrapAround: false,
      groupCells: true,
      cellAlign: 'center',
      draggable: true,
      contain: true,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: false,
      selectedAttraction: 0.01,
      dragThreshold: 5,
      accessibility: false
    });
  }
  function thumbnails(flkty, carouselNav, config, context) {
    if (!carouselNav) return false;
    var thumbs = carouselNav.querySelectorAll('.js-thumb-item');
    if (!thumbs) return false;

    /* on thumbnail click and key enter */
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        var index = this.dataset.slideIndex,
          el = carouselNav.querySelectorAll('.js-thumb-item')[index],
          mediaId = this.dataset.imageId;
        if ($('body').hasClass('product') && $(this).hasClass('product-single__thumbnails-item') && $('.product-bottom').css('position') == 'sticky') {
          scrollToDiv('#slider .image-slide[data-slide-index=' + index + ']', 120);
        } else {
          /* Update classes & aria */
          theme.ProductGallery.setActiveThumbnail(mediaId, el, context);
          theme.ProductGallery.switchMedia(mediaId, context);

          /* move thumb slider to position */
          theme.ProductGallery.setThumbPos(this, carouselNav);

          /* change slide */
          flkty.select(index);
        }
      });
      thumb.addEventListener('keypress', function (event) {
        event.preventDefault();
        if (event.which == 13) {
          //Enter key pressed

          var index = this.dataset.slideIndex,
            el = carouselNav.querySelectorAll('.js-thumb-item')[index],
            mediaId = this.dataset.imageId;

          /* Update classes & aria */
          theme.ProductGallery.setActiveThumbnail(mediaId, el, context);
          theme.ProductGallery.switchMedia(mediaId, context);

          /* move thumb slider to position */
          theme.ProductGallery.setThumbPos(this, carouselNav);

          /* change slide */
          flkty.select(index);
        }
      });
    });

    /* Add prev/next navigation buttons to thumbnail container */
    var thumbnailContainer = context.querySelector('#thumbnails');
    if (thumbnailContainer) {
      /* Update disabled state based on current slide */
      var updateNavButtons = function updateNavButtons() {
        prevBtn.disabled = flkty.selectedIndex === 0;
        nextBtn.disabled = flkty.selectedIndex === flkty.slides.length - 1;
      };
      var prevBtn = document.createElement('button');
      prevBtn.className = 'thumb-nav-btn thumb-nav-prev';
      prevBtn.setAttribute('type', 'button');
      prevBtn.setAttribute('aria-label', 'Previous');
      prevBtn.innerHTML = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"></path></svg>';
      var nextBtn = document.createElement('button');
      nextBtn.className = 'thumb-nav-btn thumb-nav-next';
      nextBtn.setAttribute('type', 'button');
      nextBtn.setAttribute('aria-label', 'Next');
      nextBtn.innerHTML = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" transform="translate(100, 100) rotate(180)"></path></svg>';
      thumbnailContainer.appendChild(prevBtn);
      thumbnailContainer.appendChild(nextBtn);
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        flkty.previous();
      });
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        flkty.next();
      });
      updateNavButtons();
      flkty.on('change', updateNavButtons);

      /* Sync thumb Flickity position when main slider changes */
      flkty.on('change', function (index) {
        var thumbFlkty = Flickity.data(carouselNav);
        if (thumbFlkty) {
          thumbFlkty.select(index);
        }
      });
    }

    /* adjust thumbnail sizes
    if (config.thumbPosition != 'bottom') {
      theme.ProductGallery.setThumbSizes(carouselNav, config, context);
    }
    */
  }

  /*
    function setThumbSizes(carouselNav, config, context) {
      let wrapper = context.querySelector('.js-thumb-vertical-wrapper'),
        wrapperWidth = wrapper.offsetWidth,
        thumbsShown = config.thumbsShown || 4;
  
      carouselNav.querySelectorAll('.js-thumb-item').forEach((item, i) => {
        item.style.maxWidth = wrapperWidth + 'px';
      });
  
      carouselNav.querySelectorAll('.js-thumb-item-img').forEach((item, i) => {
        item.style.width = wrapperWidth + 20 + 'px';
        item.style.height = wrapperWidth + 20 + 'px';
      });
  
      let thumbHeight = carouselNav.querySelectorAll('.js-thumb-item-img')[0].offsetWidth,
          wrapperHeight = (parseInt(thumbHeight) * parseInt(thumbsShown)) + 40;
  
      wrapper.querySelector('.js-thumb-carousel-nav').style.maxHeight = wrapperHeight + 'px';
    }
  */

  function setThumbPos(selected, carouselNav) {
    carouselNav.scrollTo({
      top: selected.offsetTop - 20,
      left: 0,
      behavior: 'smooth'
    });
  }
  function galleryEvents(flkty, context) {
    /* On Variant Change and Initial Load */
    Events.on('variantchange:image', function (id, context) {
      if (id === null) return false;

      /* Select new image in flickity */
      var main, el, index, curFlkty;
      main = context.querySelector('.js-carousel-main');
      el = main.querySelector("[data-image-id='" + id + "']");
      index = el.dataset.slideIndex;
      theme.ProductGallery.setActiveThumbnail(id, el, context);
      theme.ProductGallery.switchMedia(id, context);
      curFlkty = Flickity.data(main);
      curFlkty.select(index);
    });
  }
  function removeFocus(context) {
    var main;
    if (context) {
      main = context;
    } else {
      main = context.querySelector('.js-carousel-main');
    }

    /* Set all elements to no tab */
    context.querySelectorAll('.js-carousel-main *').forEach(function (item, i) {
      item.setAttribute('tabIndex', '-1');
      item.blur();
    });
    var buttonContents = context.querySelectorAll('.flickity-button *');
    buttonContents.forEach(function (item, i) {
      item.setAttribute('tabIndex', '-1');
      item.classList.add('js-hide-focus');
    });
    if (main.classList.contains('.flickity-enabled')) {
      main.setAttribute('tabIndex', '-1');
      main.classList.add('js-hide-focus');
    }
  }
  function addFocus(current, context) {
    /* Set current element to tab */
    if (current.classList.contains('image-slide')) {
      current.querySelector('img').setAttribute("tabIndex", "0");
    } else if (current.classList.contains('video-slide')) {
      current.querySelectorAll('.plyr__controls *').forEach(function (item, i) {
        item.setAttribute("tabIndex", "0");
      });
    } else if (current.classList.contains('external_video-slide')) {
      current.querySelector('iframe').setAttribute("tabIndex", "0");
    } else if (current.classList.contains('model-slide')) {
      current.querySelectorAll('.shopify-model-viewer-ui__controls-area *').forEach(function (item, i) {
        item.setAttribute("tabIndex", "0");
      });
    }
  }
  function enlargePhoto(context) {
    var buttons = context.querySelectorAll('a.zoom_btn');
    if (!buttons) return false;
    buttons.forEach(function (button, i) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var btn = event.target,
          index = btn.getAttribute('data-ps-slide-index'),
          index = parseInt(index, 10);
        openPhotoSwipe(index);
      });
    });
    var openPhotoSwipe = function openPhotoSwipe(index) {
      var pswpElement = document.querySelectorAll('.pswp')[0];
      var images = context.querySelectorAll('.js-carousel-main .image-slide');
      if (images.length < 2) {
        var arrows = false;
      } else {
        var arrows = true;
      }
      var items = [];
      images.forEach(function (image, i) {
        var imageTag = image.querySelector('.product__image');
        var item = {
          src: imageTag.getAttribute('data-zoom-src'),
          w: imageTag.getAttribute('data-width'),
          h: imageTag.getAttribute('data-height')
        };
        items.push(item);
      });
      var options = {
        index: index,
        arrowEl: arrows,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        fullscreenEl: false,
        preloaderEl: false,
        shareEl: false,
        tapToClose: false,
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnail = context.querySelector('.product__image');
          var rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };
      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
      gallery.listen('afterChange', function () {
        var flkty = Flickity.data('.slides.carousel-main');
        var newIndex = gallery.getCurrentIndex();
        var sliderImage = document.querySelector("[data-ps-slide-index=\"".concat(newIndex, "\"]"));
        var newNewIndex = parseInt(sliderImage.dataset.index, 10);
        flkty.select(newNewIndex);
      });
    };
  }
  function switchMedia(mediaId, context) {
    var main = context.querySelector('.js-carousel-main'),
      currentMedia = main.querySelector('[data-product-single-media-wrapper]:not(.inactive)'),
      newMedia = main.querySelector('[data-product-single-media-wrapper]' + "[data-thumbnail-id='product-template-" + mediaId + "']"),
      otherMedia = main.querySelectorAll('[data-product-single-media-wrapper]' + ":not([data-thumbnail-id='product-template-" + mediaId + "'])");
    currentMedia.dispatchEvent(new CustomEvent('mediaHidden', {
      bubbles: true,
      cancelable: true
    }));
    newMedia.classList.add('active-slide');
    newMedia.classList.remove('inactive');
    newMedia.dispatchEvent(new CustomEvent('mediaVisible', {
      bubbles: true,
      cancelable: true
    }));
    otherMedia.forEach(function (el) {
      el.classList.add('inactive');
      el.classList.remove('active-slide');
    }.bind(this));
  }
  function setActiveThumbnail(mediaId, el, context) {
    var main = context.querySelector('.js-carousel-main'),
      carouselNav = context.querySelector('.js-thumb-carousel-nav');
    if (typeof mediaId === 'undefined') {
      mediaId = main.querySelector('[data-product-single-media-wrapper]:not(.hide)').dataset.mediaId;
    }
    if (carouselNav) {
      /* remove selected class from all */
      carouselNav.querySelectorAll('.js-thumb-item').forEach(function (item, i) {
        item.classList.remove('is-nav-selected');
        item.classList.remove('active-slide');
        item.removeAttribute('aria-current');
      });
    }

    /* add selected class */
    var thumbActive = context.querySelector(".js-thumb-item[data-image-id='" + mediaId + "']");
    if (thumbActive) {
      thumbActive.classList.add('is-nav-selected');
      thumbActive.classList.add('active-slide');
      thumbActive.setAttribute('aria-current', true);
    }
  }
  return {
    init: init,
    mainSlider: mainSlider,
    thumbSlider: thumbSlider,
    thumbnails: thumbnails,
    setThumbPos: setThumbPos,
    //    setThumbSizes: setThumbSizes,
    galleryEvents: galleryEvents,
    removeFocus: removeFocus,
    addFocus: addFocus,
    enlargePhoto: enlargePhoto,
    switchMedia: switchMedia,
    setActiveThumbnail: setActiveThumbnail
  };
}();
theme.ProductFullGallery = function () {
  function init(context, sectionId, events, Product) {
    var config = JSON.parse(context.querySelector('.js-product-gallery').dataset.galleryConfig || '{}'),
      main = context.querySelector('.js-carousel-main');
    if (!main) return false;
    this.mainSlider(main, config, context);
    if (config.clickToEnlarge) theme.ProductFullGallery.enlargePhoto(context);
  }
  function mainSlider(main, config, context) {
    var initialEl = main.querySelector("[data-image-id='" + context.dataset.initialVariant + "']"),
      initialIndex;
    if (initialEl) {
      initialIndex = initialEl.dataset.slideIndex;
    } else {
      initialIndex = 0;
    }
    var flkty = new Flickity(main, {
      // options
      fade: false,
      wrapAround: true,
      cellAlign: 'center',
      draggable: false,
      contain: true,
      imagesLoaded: true,
      accessibility: true,
      lazyLoad: 2,
      pageDots: true,
      prevNextButtons: true,
      autoPlay: false,
      selectedAttraction: 0.01,
      dragThreshold: 15,
      adaptiveHeight: false,
      initialIndex: initialIndex,
      on: {
        ready: function ready() {
          var id = this.selectedElement.dataset.imageId;

          /* Fade in */
          context.querySelector('.js-product-gallery').style.visibility = "visible";
        },
        change: function change() {
          /* Set focus control on change */
          theme.ProductFullGallery.removeFocus(context);
          theme.ProductFullGallery.addFocus(this.selectedElement, context);

          /* Set media */
          theme.ProductFullGallery.switchMedia(this.selectedElement.dataset.imageId, context);

          /* Allow model drag */
          if (this.selectedElement.classList.contains('model-slide')) {
            if (this.isDraggable) {
              /* Turn off drag for model usage */
              this.options.draggable = !this.options.draggable;
              this.updateDraggable();
            }
          }
        }
      }
    });
    theme.ProductFullGallery.galleryEvents(flkty, context);
  }
  function galleryEvents(flkty, context) {
    /* On Variant Change and Initial Load */
    Events.on('variantchange:image', function (id, context) {
      if (id === null) return false;

      /* Select new image in flickity */
      var main = context.querySelector('.js-carousel-main'),
        el = main.querySelector("[data-image-id='" + id + "']"),
        index = el.dataset.slideIndex;
      theme.ProductFullGallery.switchMedia(id, context);
      flkty.select(index);
    });
  }
  function removeFocus(context) {
    var main;
    if (context) {
      main = context;
    } else {
      main = context.querySelector('.js-carousel-main');
    }

    /* Set all elements to no tab */
    context.querySelectorAll('.js-carousel-main *').forEach(function (item, i) {
      item.setAttribute('tabIndex', '-1');
      item.blur();
    });
    var buttonContents = context.querySelectorAll('.flickity-button *');
    buttonContents.forEach(function (item, i) {
      item.setAttribute('tabIndex', '-1');
      item.classList.add('js-hide-focus');
    });
    if (main.classList.contains('.flickity-enabled')) {
      main.setAttribute('tabIndex', '-1');
      main.classList.add('js-hide-focus');
    }
  }
  function addFocus(current, context) {
    /* Set buttons to tab */
    context.querySelectorAll('.flickity-button').forEach(function (item, i) {
      item.setAttribute("tabIndex", "0");
    });
    /* Set current element to tab */
    if (current.classList.contains('image-slide')) {
      current.querySelector('img').setAttribute("tabIndex", "0");
    } else if (current.classList.contains('video-slide')) {
      current.querySelectorAll('.plyr__controls *').forEach(function (item, i) {
        item.setAttribute("tabIndex", "0");
      });
    } else if (current.classList.contains('external_video-slide')) {
      current.querySelector('iframe').setAttribute("tabIndex", "0");
    } else if (current.classList.contains('model-slide')) {
      current.querySelectorAll('.shopify-model-viewer-ui__controls-area *').forEach(function (item, i) {
        item.setAttribute("tabIndex", "0");
      });
    }
  }
  function enlargePhoto(context) {
    var buttons = context.querySelectorAll('a.zoom_btn');
    if (!buttons) return false;
    buttons.forEach(function (button, i) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var btn = event.target,
          index = btn.getAttribute('data-ps-slide-index'),
          index = parseInt(index, 10);
        openPhotoSwipe(index);
      });
    });
    var openPhotoSwipe = function openPhotoSwipe(index) {
      var pswpElement = document.querySelectorAll('.pswp')[0];
      var images = context.querySelectorAll('.js-carousel-main .image-slide');
      if (images.length < 2) {
        var arrows = false;
      } else {
        var arrows = true;
      }
      var items = [];
      images.forEach(function (image, i) {
        var imageTag = image.querySelector('.product__image');
        var item = {
          src: imageTag.getAttribute('data-zoom-src'),
          w: imageTag.getAttribute('data-width'),
          h: imageTag.getAttribute('data-height')
        };
        items.push(item);
      });
      var options = {
        index: index,
        arrowEl: arrows,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        fullscreenEl: false,
        preloaderEl: false,
        shareEl: false,
        tapToClose: false,
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnail = context.querySelector('.product__image');
          var rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };
      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
      gallery.listen('afterChange', function () {
        var flkty = Flickity.data('.slides.carousel-main');
        var newIndex = gallery.getCurrentIndex();
        var sliderImage = document.querySelector("[data-ps-slide-index=\"".concat(newIndex, "\"]"));
        var newNewIndex = parseInt(sliderImage.dataset.index, 10);
        flkty.select(newNewIndex);
      });
    };
  }
  function switchMedia(mediaId, context) {
    var main = context.querySelector('.js-carousel-main'),
      currentMedia = main.querySelector('[data-product-single-media-wrapper]:not(.inactive)'),
      newMedia = main.querySelector('[data-product-single-media-wrapper]' + "[data-thumbnail-id='product-template-" + mediaId + "']"),
      otherMedia = main.querySelectorAll('[data-product-single-media-wrapper]' + ":not([data-thumbnail-id='product-template-" + mediaId + "'])");
    currentMedia.dispatchEvent(new CustomEvent('mediaHidden', {
      bubbles: true,
      cancelable: true
    }));
    newMedia.classList.add('active-slide');
    newMedia.classList.remove('inactive');
    newMedia.dispatchEvent(new CustomEvent('mediaVisible', {
      bubbles: true,
      cancelable: true
    }));
    otherMedia.forEach(function (el) {
      el.classList.add('inactive');
      el.classList.remove('active-slide');
    }.bind(this));
  }
  return {
    init: init,
    mainSlider: mainSlider,
    galleryEvents: galleryEvents,
    removeFocus: removeFocus,
    addFocus: addFocus,
    enlargePhoto: enlargePhoto,
    switchMedia: switchMedia
  };
}();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}
theme.ProductVideo = function (context, sectionId) {
  var videos = {};
  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };
  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };
  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };
  function init(videoContainer, sectionId) {
    if (!videoContainer) {
      return;
    }
    var videoElement = videoContainer.querySelector('iframe, video');
    if (!videoElement) {
      return;
    }
    var mediaId = videoContainer.getAttribute('data-media-id');
    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function ready() {
        createPlayer(this);
      }
    };
    var video = videos[mediaId];
    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([{
          name: 'video-ui',
          version: '1.0',
          onLoad: setupPlyrVideos
        }]);
        theme.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        theme.LibraryLoader.load('youtubeSdk', setupYouTubeVideos);
        break;
    }
  }
  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }
    loadVideos(hosts.html5);
  }
  function setupYouTubeVideos() {
    if (!window.YT.Player) return;
    loadVideos(hosts.youtube);
  }
  function createPlayer(video) {
    if (video.player) {
      return;
    }
    var productMediaWrapper = video.container.closest(selectors.productMediaWrapper);
    var enableLooping = productMediaWrapper.getAttribute('data-' + attributes.enableVideoLooping) === 'true';
    switch (video.host) {
      case hosts.html5:
        // eslint-disable-next-line no-undef
        video.player = new Shopify.Plyr(video.element, {
          loop: {
            active: enableLooping
          },
          muted: true,
          hideControlsOnPause: true,
          tooltips: {
            controls: false,
            seek: true
          }
        });
        video.player.on('ready', function (event) {
          video.container.querySelector('.plyr--full-ui').setAttribute('tabindex', '-1');
          video.container.querySelectorAll('.plyr--full-ui *').forEach(function (item, i) {
            item.setAttribute('tabindex', '-1');
          });
        });
        video.player.on('play', function (event) {
          video.container.querySelectorAll('.plyr__controls *').forEach(function (item, i) {
            item.setAttribute("tabIndex", "0");
          });
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.getAttribute('data-' + attributes.videoId);
        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function onStateChange(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            },
            onReady: function onReady(event) {
              video.player.mute();
            }
          }
        });
        break;
    }
    var pauseVideo = function pauseVideo() {
      if (!video.player) return;
      if (video.host === hosts.html5) {
        video.player.pause();
      }
      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    };
    productMediaWrapper.addEventListener('mediaHidden', pauseVideo);
    productMediaWrapper.addEventListener('xrLaunch', pauseVideo);
    productMediaWrapper.addEventListener('mediaHidden xrLaunch', function () {
      if (!video.player) return;
      if (video.host === hosts.html5) {
        video.player.pause();
      }
      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    });
    productMediaWrapper.addEventListener('mediaVisible', function () {
      if (theme.Helpers.isTouch()) return;
      if (!video.player) return;
      if (video.host === hosts.html5) {
        if (desktop.matches) {
          video.player.play();
        }
      }
      if (video.host === hosts.youtube && video.player.playVideo) {
        if (desktop.matches) {
          video.player.playVideo();
        }
      }
    });
  }
  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }
    if (video.tagName === 'IFRAME') {
      if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video.src)) {
        return hosts.youtube;
      }
    }
    return null;
  }
  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }
  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.nativeVideo) continue;
        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }
  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }
  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
}();
theme.ProductModel = function () {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};
  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };
  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };
    modelViewerContainers.forEach(function (modelViewerContainer, index) {
      var mediaId = modelViewerContainer.getAttribute('data-media-id');
      var modelViewerElement = modelViewerContainer.querySelector('model-viewer');
      var modelId = modelViewerElement.getAttribute('data-model-id');
      if (index === 0) {
        var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
        var xrButton = mediaGroup.querySelector(selectors.xrButton);
        xrButtons[sectionId] = {
          element: xrButton,
          defaultId: modelId
        };
      }
      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        container: modelViewerContainer,
        element: modelViewerElement
      };
    });
    window.Shopify.loadFeatures([{
      name: 'shopify-xr',
      version: '1.0',
      onLoad: setupShopifyXr
    }, {
      name: 'model-viewer-ui',
      version: '1.0',
      onLoad: setupModelViewerUi
    }]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }
  function setupShopifyXr(errors) {
    if (errors) return;
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function () {
        setupShopifyXr();
      });
      return;
    }
    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];
        if (modelSection.loaded) continue;
        var modelJson = document.querySelector('#ModelJson-' + sectionId);
        if (!modelJson) return false;
        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }
  function setupModelViewerUi(errors) {
    if (errors) return;
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
        }
        setupModelViewerListeners(model);
      }
    }
  }
  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    model.container.addEventListener('mediaVisible', function () {
      xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
      if (mobile.matches) return;
      model.modelViewerUi.play();
    });
    model.container.addEventListener('mediaHidden', function () {
      xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
      model.modelViewerUi.pause();
    });
    model.container.addEventListener('xrLaunch', function () {
      model.modelViewerUi.pause();
    });
  }
  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }
  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
}();
theme.ProductDetails = function (context, events, Product) {
  (function sku() {
    var element = context.querySelector(".variant_sku");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant, config) {
      var variant_sku = variant.sku;
      element.innerHTML = variant_sku;
    });
    events.on("variantunavailable", function (variant, config) {
      var variant_sku = config.unavailable;
      element.innerHTML = variant_sku;
    });
  })();
  (function current_variant() {
    var element = context.querySelector(".variant_selected");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant) {
      var variant_selected = variant.title;
      element.innerHTML = variant_selected;
    });
    events.on("variantunavailable", function (variant, config) {
      var variant_selected = config.unavailable;
      element.innerHTML = variant_selected;
    });
  })();
  (function inventory() {
    var element = context.querySelector(".variant_inventory");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant, config) {
      var inventory_quantity = variant.inventory_quantity;
      if (inventory_quantity > 0) {
        element.innerHTML = inventory_quantity;
      } else {
        element.innerHTML = config.unavailable;
      }
    });
    events.on("variantunavailable", function (variant, config) {
      var inventory_quantity = config.unavailable;
      element.innerHTML = inventory_quantity;
    });
  })();
  (function weight() {
    var element = context.querySelector(".variant_weight");
    if (!element) {
      return false;
    }
    events.on("variantchange", function (variant, config) {
      var variant_weight = variant.weight_in_unit;
      var variant_weight_unit = variant.weight_unit;
      if (variant_weight > 0) {
        element.innerHTML = variant_weight + '&nbsp;' + variant_weight_unit;
      } else {
        element.innerHTML = config.unavailable;
      }
    });
    events.on("variantunavailable", function (variant, config) {
      var variant_weight = config.unavailable;
      element.innerHTML = variant_weight;
    });
  })();
};
theme.ProductAccordion = function () {
  (function accordion() {
    document.addEventListener('shopify:block:select', function (event) {
      // Dont' run on the mobile navigation
      if (event.target.classList.contains(WAU.Accordion.getConfigClass('mobileNavAccordion'))) {
        return;
      }
      WAU.Accordion.show(event.target, true);
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      // Dont' run on the mobile navigation
      if (event.target.classList.contains(WAU.Accordion.getConfigClass('mobileNavAccordion'))) {
        return;
      }

      // Don't hide if it has the "open by default" setting enabled
      if (!event.target.classList.contains(WAU.Accordion.getConfigClass('open'))) {
        WAU.Accordion.hide(event.target, true);
      }
    });
  })();
};
theme.ProductStickyBar = function () {
  var stickyBar = document.getElementById('sticky-cart');
  if (!stickyBar) return false;
  var lastKnownScrollPosition = 0;
  var ticking = false;
  function initSticky(scrollPos) {
    var cartForm = document.querySelectorAll('.js-product-bottom');
    if (!cartForm) return false;
    cartForm.forEach(function (item, i) {
      var topOfHiddenDiv = item.offsetTop;
      var position = scrollPos >= topOfHiddenDiv,
        footer = document.getElementById('footer'),
        stickyBar = document.querySelector('.js-sticky-cart');
      if (i === 1) return false;
      if (position && !stickyBar.classList.contains('show')) {
        stickyBar.classList.add('show');
        footer.classList.add('padding-sticky');
      } else if (!position && typeof stickyBar.classList !== 'undefined' && stickyBar.classList.contains('show')) {
        stickyBar.classList.remove('show');
        footer.classList.remove('padding-sticky');
      }
    });
  }
  document.addEventListener('scroll', function (e) {
    lastKnownScrollPosition = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        initSticky(lastKnownScrollPosition);
        ticking = false;
      });
      ticking = true;
    }
  });
};

/*======================================================
  Accordion
========================================================*/

theme.Accordion = function () {
  (function accordion() {
    document.addEventListener('shopify:block:select', function (event) {
      // Dont' run on the mobile navigation
      if (event.target.classList.contains(WAU.Accordion.getConfigClass('mobileNavAccordion'))) {
        return;
      }
      WAU.Accordion.show(event.target, true);
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      // Dont' run on the mobile navigation
      if (event.target.classList.contains(WAU.Accordion.getConfigClass('mobileNavAccordion'))) {
        return;
      }

      // Don't hide if it has the "open by default" setting enabled
      if (!event.target.classList.contains(WAU.Accordion.getConfigClass('open'))) {
        WAU.Accordion.hide(event.target, true);
      }
    });
  })();
};

/*======================================================
  Recently Viewed
========================================================*/

theme.RecentlyViewed = function () {
  /**
   * Initializes the recently viewed section. Only works on once per page.
   * @param {Node} container section container element
   */
  function RecentlyViewed(container) {
    var _this7 = this;
    // Check for container
    if (!container) {
      console.log('Error. Recently viewed section must be provided a container in order to work.');
      return false;
    }

    //
    // Get data- attribute information.
    //

    // Get how many products to show variable.
    var DEFAULT_LIMIT = 6;

    // Get the data-limit value or set to default limit (6).
    var limit = container.dataset.limit ? container.dataset.limit : DEFAULT_LIMIT;
    var grid = container.dataset.grid;

    // Get the data-carousel value or set to false (boolean)
    var carousel = container.dataset.carousel ? container.dataset.carousel : false;

    // If data-carousel attribute is set to a string "true", then convert to the "true" boolean value otherwise return "false" boolean
    var carouselEnabled = carousel === 'true';
    var wrapperId = container.dataset.wrapperId;

    //
    // Helper functions
    //

    /**
     * Callback function to reveal the entire section
     * @param  {String} wrapperId wrapper element
     * @todo use container instead of wrapper?
     */
    var revealOuterWrapper = function revealOuterWrapper() {
      var wrapperId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'recently-viewed';
      // Bail if not wrapper Id
      if (!wrapperId) {
        console.log('Error. must provide a wrapperId as an argument.');
        return false;
      }

      // Get the wrapper element
      var wrapper = document.getElementById(wrapperId);

      // Bail if no wrapper element was found
      if (!wrapper) {
        console.log('Error. No wrapper element was found.');
        return false;
      }

      // If the fadeIn helper method is not available then simply
      // change to display block. Otherwise use the fadeIn helper
      // method to display the section.
      if (_typeof(theme.Helpers.fadeIn) === undefined) {
        wrapper.style.display = 'block';
      } else if (typeof theme.Helpers.fadeIn === 'function') {
        theme.Helpers.fadeIn(wrapper);
      }
    };

    /**
     * Initialize the Flickity carousel.
     * @todo pass in container instead of using querySelector
     */
    var initCarousel = function initCarousel(wrapperId) {
      if (!wrapperId) {
        console.log('Error. Must provide a wrapper element to initialze the carousel on.');
        return false;
      }

      // Get the carousel element
      var carousel = document.getElementById(wrapperId);

      // Bail if it does not exists.
      if (!carousel) {
        console.log('Error. No carousel element for recently viewed products found!');
        return false;
      }

      // Get config object from data- attribute
      var flktyData = carousel.dataset.flickityConfig;

      // Convert to a JSON object
      var flktyOptions = JSON.parse(flktyData);

      // If there are more products to show than what the products per row or "grid" option then there is enough to wrapAround, show prevNext buttons.
      if (Shopify.RecordViewedProducts.getCount() > grid) {
        flktyOptions.wrapAround = true;
        flktyOptions.prevNextButtons = true;
        flktyOptions.draggable = true;
      }
      ;

      // Initiate Flickity
      new Flickity(carousel, flktyOptions);
    };

    /**
     * Functions to run when showRecentlyViewed is done
     * @param  {boolean} carousel  determine sif using in a carousel or not
     * @param  {node} container container element
     * @param  {string} wrapperId ID of the wrapper inside the container that displays the products
     * @return {[type]}           [description]
     * @todo add checks
     */
    var afterComplete = function afterComplete(carousel, container, wrapperId) {
      revealOuterWrapper(container.id);

      // If carousel is enabled
      if (carousel === true) {
        // Initialize the carousel
        initCarousel(wrapperId, _this7.container);
      }

      // Re-initialize Quickview
      Shopify.theme.quickview.init();

      // Initialize the color swatches
      // WAU.ProductColorSwatches.init(container, 200);
    };
    var viewedProduct = new ViewedProducts({
      howManyToShow: limit,
      wrapperId: wrapperId,
      onComplete: afterComplete.bind(this, carouselEnabled, container, wrapperId)
    });
  }
  ;
  return RecentlyViewed;
}();
theme.ProductRecommendations = function () {
  function ProductRecommendations() {
    var loadProductRecommendationsIntoSection = function loadProductRecommendationsIntoSection() {
      // Look for an element with class 'product-recommendations'
      var container = document.querySelector(".js-product-rec-wrapper");
      if (!container) return false;
      var baseUrl = container.dataset.baseUrl;
      if (container === null) {
        return;
      }
      // Read product id from data attribute
      var productId = container.dataset.productId;
      var sectionId = container.dataset.sectionId;
      var limit = container.dataset.limit;

      // Build request URL
      var recommendationsSectionUrl = baseUrl + '?section_id=' + sectionId + '&limit=' + limit + '&product_id=' + productId;
      fetch(recommendationsSectionUrl).then(function (response) {
        return response.text();
      }).then(function (productHtml) {
        if (productHtml.trim() === '') return;
        container.innerHTML = productHtml;
        container.innerHTML = container.firstElementChild.innerHTML;
      });
    };
    document.addEventListener("shopify:section:select", function (event) {
      if (event.detail.sectionId.includes("product-recommendations")) {
        loadProductRecommendationsIntoSection();
      }
    });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
  }
  return ProductRecommendations;
}();
theme.Product = function () {
  function Product(context) {
    var events = new EventEmitter3();
    events.trigger = events.emit; // alias

    var productJson = context.querySelector('.product-json');
    if (!productJson) {
      return false;
    }
    var Product = productJson.innerHTML,
      Product = JSON.parse(Product || '{}');
    var sectionId = context.dataset.sectionId;
    theme.ProductAccordion(Product);

    // Record if on a product page
    if (document.body.classList.contains('template-product')) {
      Shopify.RecordViewedProducts.recordRecentlyViewed();
    }
    if (context.querySelector("[data-product-details]")) {
      theme.ProductDetails(context, events, Product);
    }
    if (context.querySelector("[data-gallery-thumbnails]")) {
      theme.ProductGallery.init(context, sectionId, events, Product);
    }
    if (context.querySelector('[data-store-availability-container]')) {
      theme.StoreAvailability(context, Product, events);
    }
    if (context.querySelector("[data-gallery-fullwidth]")) {
      theme.ProductFullGallery.init(context, sectionId, events, Product);
    }
    if (context.querySelector("[data-product-form]")) {
      theme.ProductForm(context, sectionId, events, Product);
    }
    if (context.querySelector("[data-product-sticky-bar]")) {
      theme.ProductStickyBar(context, events, Product);
    }

    /* Product media */
    context.querySelectorAll("[data-product-media-type-video]").forEach(function (context, sectionId) {
      theme.ProductVideo.init(context, sectionId);
    });
    var modelViewerElements = context.querySelectorAll('[data-product-media-type-model]');
    if (modelViewerElements.length > 0) {
      theme.ProductModel.init(modelViewerElements, sectionId);
    }
    var self = this;
    document.addEventListener('shopify_xr_launch', function () {
      var currentMedia = document.querySelector('[data-product-single-media-wrapper]:not(.inactive)', self);
      currentMedia.dispatchEvent(new CustomEvent('xrLaunch', {
        bubbles: true,
        cancelable: true
      }));
    });
  }
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-section-type="product__section"]')) return Product;
  });
  return Product;
}();
theme.StoreAvailability = function (context, Product, events) {
  // Initial on load
  var id = context.querySelector('[data-store-availability-container]').dataset.variantId;
  var title = context.querySelector('[data-store-availability-container]').dataset.productTitle;
  updateContent(id, title, context);

  // Update on variant change
  events.on("storeavailability:variant", function (id, title, context) {
    updateContent(id, title, context);
  });
  function updateContent(id, title, context) {
    var container = context.querySelector('[data-store-availability-container]');
    var variantSectionUrl = '/variants/' + id + '/?section_id=pickup-availability';
    container.innerHTML = '';
    fetch(variantSectionUrl).then(function (response) {
      return response.text();
    }).then(function (storeAvailabilityHTML) {
      if (storeAvailabilityHTML.trim() === '') {
        return;
      }
      container.innerHTML = storeAvailabilityHTML;
      container.innerHTML = container.firstElementChild.innerHTML;
      container.style.opacity = 1;
      container.style.visibility = "visible";

      // Show or hide container if variant unavailable
      container.querySelector('.store-availability-container').classList.remove('fadeOut');
      container.querySelector('.store-availability-container').style.display = "block";
      Events.on("storeavailability:unavailable", function () {
        container.querySelector('.store-availability-container').classList.add('fadeOut');
        container.querySelector('.store-availability-container').style.display = "none";
      });

      // If no active pickup locations hide container and stop function
      if (document.querySelector('[data-pick-up-available="false"]')) {
        container.style.display = "none";
        return false;
      } else {
        container.style.display = "block";
      }

      // Move modal code to slideout
      var source = document.getElementById("StoreAvailabilityModal");

      // create the slideout el, assign it a name, and then add
      var slideoutContainer = document.querySelector(".js-slideout-toggle-wrapper");
      var slideoutAside = document.getElementById('slideout-store-availability');
      if (slideoutAside) {
        slideoutAside.innerHTML = "";
        slideoutAside.appendChild(source);
      } else {
        var newSlideout = WAU.Slideout._createSlideoutEl("right", "store-availability", slideoutContainer);
        newSlideout.appendChild(source);
      }
      WAU.Slideout.init("store-availability");

      // Update product title
      var storeAvailabilityModalProductTitle = document.querySelector('[data-store-availability-modal-product-title]');
      storeAvailabilityModalProductTitle.textContent = title;
    });
  }
};

/*============================================================================
  Slideshow Section
==============================================================================*/
theme.Slideshow = function () {
  function Slideshow(container) {
    var slideshows = document.querySelectorAll('.js-slideshow');
    slideshows.forEach(function (Slideshow) {
      var flktyData = Slideshow.getAttribute('data-flickity');
      var flktyOptions = JSON.parse(flktyData);
      new Flickity(Slideshow, flktyOptions);
    });
  }
  return Slideshow;
}();
theme.Slideshow.prototype = _.assignIn({}, theme.Slideshow.prototype, {
  onLoad: function onLoad(event) {
    var Slideshow = event.target.closest('.js-slideshow');
    var flktyData = Slideshow.getAttribute('data-flickity');
    var flktyOptions = JSON.parse(flktyData);
    new Flickity('.js-slideshow', flktyOptions);
  },
  onBlockSelect: function onBlockSelect(event) {
    var Slideshow = event.target.closest('.js-slideshow');
    var flkty = Flickity.data(Slideshow);
    var Slide = event.target.getAttribute("data-slider-index");
    flkty.select(Slide);
    flkty.pausePlayer();
  },
  onBlockDeselect: function onBlockDeselect() {
    var Slideshow = event.target.closest('.js-slideshow');
    var flkty = Flickity.data(Slideshow);
    flkty.unpausePlayer();
  }
});

/*============================================================================
  Map Section
==============================================================================*/
theme.Maps = function () {
  var google_api_loaded = false;
  var allMaps = [];
  var events = new EventEmitter3();
  events.trigger = events.emit; // alias

  window.gm_authFailure = function () {
    google_api_loaded = false;
    if (Shopify.designMode) {
      events.trigger("gmauthfailure:themeeditor");
    } else {
      events.trigger("gmauthfailure");
    }
  };
  var getScript = function getScript(url) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onerror = reject;
      script.onload = script.onreadystatechange = function () {
        var loadState = this.readyState;
        if (loadState && loadState !== 'loaded' && loadState !== 'complete') return;
        script.onload = script.onreadystatechange = null;
        resolve();
      };
      document.head.appendChild(script);
    });
  };
  function Map(container) {
    var config = container.querySelector("[data-map-config]").innerHTML,
      config = JSON.parse(config);
    if (!config.api_key) {
      return false;
    }
    (function section_container() {
      var element = container;
      events.on("gmauthfailure:themeeditor", error);
      events.on("map:error", error);
      function error() {
        element.classList.add("map-section-load-error");
      }
    })();
    (function background_image() {
      var element = container.querySelector("[data-bg-image]");
      events.on("gmauthfailure", show);
      function show() {
        element.classList.add("show-image");
      }
    })();
    (function overlay() {
      var element = container.querySelector("[data-map-overlay]");
      events.on("gmauthfailure:themeeditor", error);
      events.on("map:error", error);
      function error(message) {
        message = message || config.auth_error;
        element.innerHTML = '<div class="map-section-error errors text-center">' + message + '</div>';
      }
    })();
    function map() {
      var element = container.querySelector("[data-map]");
      events.on("ready", geolocate);
      function geolocate() {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: config.address
        }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            render(results);
          } else {
            error(status);
          }
        });
      }
      function render(results) {
        element.innerHTML = "";
        var map = new google.maps.Map(element, {
          zoom: config.zoom,
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          styles: config.styles,
          disableDefaultUI: true
        });
        var center = map.getCenter();
        new google.maps.Marker({
          map: map,
          position: center
        });
        google.maps.event.addDomListener(window, "resize", function () {
          theme.Helpers.debounce(function () {
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
          }, 250);
        });
        document.addEventListener('shopify:section:unload', function () {
          google.maps.event.clearListeners(map, "resize");
        });
      }
      function error(status) {
        var message = config.address_error;
        switch (status) {
          case 'ZERO_RESULTS':
            message = config.address_no_results;
            break;
          case 'OVER_QUERY_LIMIT':
            message = config.address_query_limit;
            break;
          case 'REQUEST_DENIED':
            message = config.auth_error;
            break;
        }
        if (Shopify.designMode) {
          events.trigger("map:error", message);
        }
      }
    }
    ;
    map(container);
    if (google_api_loaded === true) {
      events.trigger("ready");
    } else {
      if (google_api_loaded !== 'loading') {
        google_api_loaded = 'loading';
        if (typeof window.google === 'undefined') {
          getScript("https://maps.googleapis.com/maps/api/js?key=" + config.api_key).then(function () {
            google_api_loaded = true;
            events.trigger("ready");
          })["catch"](function () {
            events.trigger("map:error", 'Could not load map with API key. Check billing with Google.');
            console.error('Could not load script with api given');
          });
        }
      }
    }
  }
  Map.prototype = _.assignIn({}, Map.prototype, {});
  return Map;
}();

/*============================================================================
  Featured Collection Section
==============================================================================*/
theme.FeaturedCollection = function () {
  function FeaturedCollection(container) {
    var Carousels = document.querySelectorAll('.featured__collection-carousel');
    if (!Carousels) {
      return false;
    }
    Carousels.forEach(function (Carousel) {
      var flktyData = Carousel.getAttribute('data-flickity');
      if (isMobile || !Carousel.classList.contains('mobile-carousel')) {
        var flktyOptions = JSON.parse(flktyData);
        new Flickity(Carousel, flktyOptions);
      }
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var Carousel = event.target.closest('.featured__collection-carousel');
      if (!Carousel) {
        return false;
      }
      var flkty = Flickity.data(Carousel);
      flkty.destroy();
    });
    document.addEventListener('shopify:section:load', function (event) {
      var Carousel = event.target.closest('.js-carousel');
      if (!Carousel || !isMobile && Carousel.classList.contains('mobile-carousel')) {
        return false;
      }
      var flktyData = Carousel.getAttribute('data-flickity');
      var flktyOptions = JSON.parse(flktyData);
      new Flickity('.js-carousel', flktyOptions);
    });
  }
  FeaturedCollection.prototype = _.assignIn({}, FeaturedCollection.prototype, {});
  return FeaturedCollection;
}();

/*============================================================================
  Mobile Nav
==============================================================================*/
theme.mobileNav = function () {
  WAU.Slideout.init("mobile-navigation");

  /*function mobileNav(container) {
        WAU.Slideout.init("mobile-navigation");
  }
  mobileNav.prototype = _.assignIn({}, mobileNav.prototype, {
   onSelect: function() {
           WAU.Slideout._openByName("mobile-navigation");
   },
   onDeselect: function() {
           WAU.Slideout._closeByName("mobile-navigation");
   },
   onBlockSelect: function() {
           WAU.Slideout._openByName("mobile-navigation");
   }
  });
  return mobileNav;*/
}();

/*============================================================================
  Homepage Collection slider
==============================================================================*/
theme.CollectionSlider = function () {
  var slideshowPlugin = function () {
    "use strict";

    var publicAPIs = {};
    // Store the index slide for each slider
    var slideIndex = [];
    // Id for each slider
    var slideId = [];

    // Helper function to get the index of the slideId array
    var getSliderIdIndex = function getSliderIdIndex(sliderId) {
      return slideId.indexOf(sliderId);
    };

    // Wrapper function to determine which slide to show
    var _selectSlide = function _selectSlide(n, no) {
      showDivs(n, no);
    };

    // Change slide
    var showDivs = function showDivs(n, no) {
      // Increment variable used for for loop
      var i;
      var parentSlide = document.getElementById(slideId[no]);
      var slides = parentSlide.querySelectorAll(".slide");

      // If slide index is greater than slideshow slides then go to first slide
      if (n > slides.length) {
        slideIndex[no] = 1;
      }

      // If slide index is less than 1 then go to last slide
      if (n < 1) {
        slideIndex[no] = slides.length;
      }
      slides.forEach(function (slide) {
        slide.style.display = "none";
      });

      // Show this slide
      // slides[slideIndex[no] - 1].style.display = "block";
      slides[slideIndex[no] - 1].style.display = "flex";
    };

    // Select a specific slide
    publicAPIs.selectSlide = function (n, sliderId) {
      var no = getSliderIdIndex(sliderId);
      _selectSlide(slideIndex[no] = n, no);
    };

    // Select the next slide
    publicAPIs.nextSlide = function (sliderId) {
      var n = 1;
      var no = getSliderIdIndex(sliderId);
      _selectSlide(slideIndex[no] += n, no);
    };

    // Select the previous slide
    publicAPIs.prevSlide = function (sliderId) {
      var n = -1;
      var no = getSliderIdIndex(sliderId);
      _selectSlide(slideIndex[no] += n, no);
    };

    // Initialize plugin
    publicAPIs.init = function () {
      // Get all slideshows
      var slideshows = document.querySelectorAll(".featured-collections-slider");

      // Bail if not slideshows
      if (!slideshows) {
        console.log("Error, no slideshows");
        return;
      }

      // Initialize each slideshow
      slideshows.forEach(function (slideshow, i) {
        slideIndex.push(1);
        slideId.push(slideshow.id);
        showDivs(1, i);
      });

      // Add event handlers for buttons
      document.addEventListener("click", function (event) {
        var target = event.target;

        // If child SVG element is selected then get parent button element
        if (target.classList.contains('left-arrow') || target.classList.contains('right-arrow')) {
          target = target.parentElement;
        }

        // Check which slider action to do
        if (target.hasAttribute("data-arrow-prev")) {
          publicAPIs.prevSlide(target.dataset.parent);
        } else if (target.hasAttribute("data-arrow-next")) {
          publicAPIs.nextSlide(target.dataset.parent);
        } else if (target.hasAttribute("data-slide-to")) {
          publicAPIs.selectSlide(Number(target.dataset.slideTo), target.dataset.parent);
        } else {
          // console.log("not an arrow button");
          return;
        }
      });
    };
    return publicAPIs;
  }();
  slideshowPlugin.init();

  // Theme editor interaction
  document.addEventListener('shopify:block:select', function (event) {
    var id = event.detail.blockId;
    var sliderId = event.target.parentElement.id;
    var slideIndex = event.target.dataset.slideIndex;
    slideshowPlugin.selectSlide(Number(slideIndex), sliderId);
  });
};

/*============================================================================
  Footer Section
==============================================================================*/
var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};
theme.Footer = function () {
  function Footer(container) {
    this.container = container;
    this.cache = {};
    this.cacheSelectors();
    if (this.cache.localeDisclosure) {
      this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure);
    }
    if (this.cache.currencyDisclosure) {
      this.currencyDisclosure = new theme.Disclosure(this.cache.currencyDisclosure);
    }
  }
  Footer.prototype = _.assignIn({}, Footer.prototype, {
    cacheSelectors: function cacheSelectors() {
      this.cache = {
        localeDisclosure: this.container.querySelector(selectors.disclosureLocale),
        currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency)
      };
    },
    onUnload: function onUnload() {
      if (this.cache.localeDisclosure) {
        this.localeDisclosure.destroy();
      }
      if (this.cache.currencyDisclosure) {
        this.currencyDisclosure.destroy();
      }
    }
  });
  return Footer;
}();

/*======================================================
  Password Page Section
========================================================*/
theme.Password = function () {
  function Password(container) {
    window.addEventListener('DOMContentLoaded', function (event) {
      var passwordError = document.querySelector('.errors');
      if (passwordError) {
        WAU.Slideout._openByName("password");
      } else {
        return false;
      }
    });
    WAU.Slideout.init("password");
    window.addEventListener('shopify:section:select', function (event) {
      WAU.Slideout.init("password");
    });
  }
  Password.prototype = _.assignIn({}, Password.prototype, {});
  return Password;
}();

/*======================================================
  Mailing Popup
========================================================*/
theme.MailingPopup = function () {
  var Popup = function () {
    var defaults = {
      selectors: {
        popupContainer: ".newsletter__popup-container",
        popupOverlay: ".newsletter__popup-overlay",
        popupCloseButton: ".newsletter__popup-container-close"
      },
      classes: {
        visible: "is-visible"
      },
      viewportWidth: 740,
      // Viewport must be greater than this number to open
      overlay: true,
      // Enabled overlay
      defaultFrequency: 5,
      // Days
      defaultPopupDelay: 5000,
      // Milliseconds
      cookieSetName: "popupShown",
      // What cookie sets
      debug: false,
      escape: true,
      // Listen to escape button to close the pop up
      successMessage: false,
      // Show popup on success ?customer_posted=true
      fadeAnimation: false,
      // Use fade functions from theme helpers
      formId: '#mailing-popup-form' // Used to differentiate popup form from other forms
    };
    var lastFocus, popupTestMode, popupFrequency;
    var publicAPIs = {};

    /*
     * @description check URL query string. Determines if customer post success is true or not
     */
    var checkURLQueryString = function checkURLQueryString() {
      if (settings.debug) {
        console.log("checkURLQueryString() ran");
      }
      if (settings.successMessage) {
        var url = new URL(location);
        if (url.hash == settings.formId && url.searchParams.get('customer_posted') == 'true') {
          return true;
        }
      }
      return false;
    };

    /*
     * @description return the viewport width
     */
    var getViewportWidth = function getViewportWidth() {
      return window.innerWidth || document.documentElement.clientWidth;
    };

    /*
     * @description handle overlay click event to exit overlay
     */
    var handleOverlayEvent = function handleOverlayEvent(event) {
      if (typeof settings !== 'undefined' && event.target === document.querySelector("".concat(settings.selectors.popupOverlay, ".").concat(settings.classes.visible))) {
        publicAPIs.close();
      }
    };

    /*
     * @description handle escape keyboard event
     */
    var handleEscapeKeyboardEvent = function handleEscapeKeyboardEvent(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        publicAPIs.close();
      }
    };

    /*
     * @description check if theme.Helper fade functions are available
     */
    var checkFadeSupport = function checkFadeSupport() {
      return typeof theme.Helpers.fadeIn === 'function' && typeof theme.Helpers.fadeOut === 'function';
    };

    /*
     * @description checks to see if fadeAnimations option is enabled and supported
     */
    var useFadeAnimation = function useFadeAnimation() {
      return settings.fadeAnimation && checkFadeSupport();
    };

    /*
     * @description handle close button event
     */
    var handleCloseButtonEvent = function handleCloseButtonEvent(event) {
      publicAPIs.close(event);
    };

    /*
     * @description check if working in the theme editor
     */
    var themeEditorCheck = function themeEditorCheck() {
      return Shopify.designMode;
    };

    /*
     * @description open the pop up
     */
    publicAPIs.open = function () {
      if (getViewportWidth() < settings.viewportWidth) {
        return;
      }
      if (settings.overlay && document.querySelector(settings.selectors.popupOverlay)) document.querySelector(settings.selectors.popupOverlay).classList.add(settings.classes.visible);
      if (document.querySelector(settings.selectors.popupContainer)) {
        if (useFadeAnimation()) {
          theme.Helpers.fadeIn(document.querySelector(settings.selectors.popupContainer));
        } else {
          document.querySelector(settings.selectors.popupContainer).style.display = "block";
        }
      }

      // Don't set cookie when inside the theme editor
      if (themeEditorCheck() !== true) {
        Cookies.set(settings.cookieSetName, 'yes', {
          expires: popupFrequency
        });
      }
      if (typeof theme.a11yHelpers.focusOnElement === 'function') {
        theme.a11yHelpers.focusOnElement(document.querySelector(settings.selectors.popupContainer));
      }
    };

    /*
     * @description close the pop up
     */
    publicAPIs.close = function (event) {
      if (document.querySelector(settings.selectors.popupContainer)) {
        if (useFadeAnimation()) {
          theme.Helpers.fadeOut(document.querySelector(settings.selectors.popupContainer));
        } else {
          document.querySelector(settings.selectors.popupContainer).style.display = "none";
        }
      }
      if (settings.overlay && document.querySelector(settings.selectors.popupOverlay)) document.querySelector(settings.selectors.popupOverlay).classList.remove(settings.classes.visible);

      // If there was an event passed in, prevent it from redirecting
      if (event) event.preventDefault();

      // If there is a lastFocus element then focus on it
      if (lastFocus) lastFocus.focus();
    };

    /*
     * @description initialize the pop up
     */
    publicAPIs.init = function (options) {
      var psettings = Object.assign({}, defaults, options);
      popupFrequency = document.querySelector(psettings.selectors.popupContainer).getAttribute('data-popup-frequency') ? Number(document.querySelector(psettings.selectors.popupContainer).getAttribute('data-popup-frequency')) : psettings.defaultFrequency;
      var popupDelayAttribute = document.querySelector(psettings.selectors.popupContainer).getAttribute('data-popup-delay');
      var popupDelay = Number(popupDelayAttribute) * 1000;
      var popupCloseEl = document.querySelector(psettings.selectors.popupCloseButton);
      if (!popupCloseEl) {
        if (psettings.debug) console.log('err. no popup close button');
      }
      var popupEnabledAttribute = document.querySelector(psettings.selectors.popupContainer).getAttribute('data-popup-enabled');
      var popupEnabled = popupEnabledAttribute == 'true' ? true : false;

      // Register events
      popupCloseEl.addEventListener('click', handleCloseButtonEvent);
      if (psettings.escape) {
        document.addEventListener('keyup', handleEscapeKeyboardEvent);
      }
      if (psettings.overlay) {
        document.addEventListener('click', handleOverlayEvent);
      }

      // Bail if working inside the theme editor
      if (themeEditorCheck() || !popupEnabled) return;
      if (checkURLQueryString()) {
        popupDelay = 10;
      }
      setTimeout(function () {
        // if (themeEditorCheck() == true || checkURLQueryString() ) {
        if (checkURLQueryString()) {
          lastFocus = document.activeElement;
          publicAPIs.open();
        } else {
          var popUpShownCookie = Cookies.get(psettings.cookieSetName);
          if (!popUpShownCookie) {
            lastFocus = document.activeElement;
            publicAPIs.open();
          }
        }
      }, popupDelay);
    };
    return publicAPIs;
  }();
  function MailingPopup(container) {
    // Initialize pop up
    Popup.init({
      selectors: {
        popupContainer: ".js-popup",
        popupOverlay: ".js-popup-overlay",
        popupCloseButton: ".js-popup-close"
      },
      overlay: true,
      successMessage: true
    });
  }
  ;

  // Interact with the theme editor
  MailingPopup.prototype = _.assignIn({}, MailingPopup.prototype, {
    onSelect: function onSelect() {
      Popup.open();
    },
    onDeselect: function onDeselect() {
      Popup.close();
    }
  });
  return MailingPopup;
}();

/*============================================================================
  Global Events
==============================================================================*/
var mobile = window.matchMedia('(max-width: 740px)');
var tablet = window.matchMedia('(max-width: 979px) and (min-width: 741px)');
var desktop = window.matchMedia('(min-width: 980px)');
window.addEventListener('DOMContentLoaded', function (event) {
  /* Initialize Accordions */
  WAU.Accordion.init();
  if (document.querySelector('[data-wau-modal-content="search-modal"]')) {
    WAU.Modal.init("search-modal");
  }
  (function helperRteFormat() {
    theme.DOMHelpers.wrapIframe({
      iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
      iframeWrapperClass: 'video-wrapper'
    });
    theme.DOMHelpers.wrapTable({
      tables: document.querySelectorAll('.rte table'),
      tableWrapperClass: 'table-wrapper'
    });
  })();
  (function eventTriggers() {
    if (mobile.matches) {
      Events.trigger("mediaquery:mobile");
    }
    if (tablet.matches) {
      Events.trigger("mediaquery:tablet");
    }
    if (desktop.matches) {
      Events.trigger("mediaquery:desktop");
    }
    window.addEventListener("resize", function () {
      if (mobile.matches) {
        Events.trigger("mediaquery:mobile");
      }
      if (tablet.matches) {
        Events.trigger("mediaquery:tablet");
      }
      if (desktop.matches) {
        Events.trigger("mediaquery:desktop");
      }
    });
    window.addEventListener('touchstart', function onFirstTouch() {
      Events.trigger("device:touchstart");
      window.removeEventListener('touchstart', onFirstTouch, false);
    });
    document.addEventListener('shopify:section:select', function (event) {
      Events.trigger("editor:section:select", event);
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      Events.trigger("editor:section:deselect", event);
    });
    document.addEventListener('shopify:section:load', function (event) {
      Events.trigger("editor:section:load", event);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      Events.trigger("editor:section:unload", event);
    });
    document.addEventListener('shopify:block:select', function (event) {
      Events.trigger("editor:block:select", event);
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      Events.trigger("editor:block:deselect", event);
    });
    document.addEventListener('lazyloaded', function (e) {
      Events.trigger("lazyLoad:complete");
    });
  })();
  (function adjustDisclosureListsPastEdge() {
    if (theme.DOMHelpers.isElementPastEdge === undefined || theme.DOMHelpers.adjustElementXPosition === undefined) {
      console.log('Error. Missing helper functions');
      return;
    }
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.classList.contains('disclosure__toggle')) {
        return;
      }
      var parentEl = target.closest('.disclosure');
      var disclosureList = parentEl.querySelector('.disclosure-list');
      if (theme.DOMHelpers.isElementPastEdge(disclosureList)) {
        theme.DOMHelpers.adjustElementXPosition(disclosureList, 10);
        return;
      }
    });
  })();
  (function initPredictiveSearch() {
    var selectors = {
      input: 'input[type="search"]',
      results: '#predictive-search'
    };
    var PredictiveSearch = /*#__PURE__*/function (_HTMLElement) {
      function PredictiveSearch() {
        var _this8;
        _classCallCheck(this, PredictiveSearch);
        _this8 = _callSuper(this, PredictiveSearch);

        // Make sure that theme helper methods and the browser supports.
        _this8.featureDetections();

        // Get data attributes from element
        _this8.routesPredictiveSearchURL = _this8.dataset.routes;
        _this8.showOnlyProducts = _this8.dataset.showOnlyProducts;
        _this8.resultsPerResource = _this8.dataset.resultsPerResource;
        _this8.inputSelector = _this8.dataset.inputSelector;
        _this8.resultsSelector = _this8.dataset.resultsSelector;

        // Get DOM elements
        _this8.input = _this8.querySelector(_this8.inputSelector) ? _this8.querySelector(_this8.inputSelector) : _this8.querySelector(selectors.input);
        _this8.predictiveSearchResults = _this8.querySelector(_this8.resultsSelector) ? _this8.querySelector(_this8.resultsSelector) : _this8.querySelector(selectors.results);

        // Add event listeners
        _this8.input.addEventListener('input', theme.Helpers.debounce(function (event) {
          _this8.onChange(event);
        }, 300).bind(_this8));
        _this8.addEventListener('focusout', _this8.onFocusOut.bind(_this8));
        return _this8;
      }
      _inherits(PredictiveSearch, _HTMLElement);
      return _createClass(PredictiveSearch, [{
        key: "featureDetections",
        value: function featureDetections() {
          if (!this.isFunction(theme.Helpers.debounce)) {
            console.log('Error. Missing debouce theme helper method for predictive search.');
            return false;
          }
          if (!window.fetch) {
            console.log('Error. Web browser does not support fetch required for predictive search');
            return false;
          }
        }
      }, {
        key: "getTypeOf",
        value: function getTypeOf(value) {
          return Object.prototype.toString.call(value);
        }
      }, {
        key: "isFunction",
        value: function isFunction(value) {
          return this.getTypeOf(value) === '[object Function]';
        }
      }, {
        key: "onChange",
        value: function onChange() {
          var searchTerm = this.input.value.trim();
          if (!searchTerm.length) {
            //this.close();
            return;
          }
          this.getSearchResults(searchTerm);
        }
      }, {
        key: "getSearchResults",
        value: function getSearchResults(searchTerm) {
          var _this9 = this;
          //let resourceTypes = (this.showOnlyProducts === 'true') ? 'product' : 'product,collection,article,page';
          var resourceTypes = this.showOnlyProducts === 'true' ? 'product' : 'product,article,page';
          var resourceLimit = 10; //this.resultsPerResource;
          var SECTION_ID = 'predictive-search';

          //console.log(`${this.routesPredictiveSearchURL}?q=${searchTerm}&resources[type]=${resourceTypes}&resources[limit]=${resourceLimit}&resources[limit_scope]=each&section_id=${SECTION_ID}&resources[options][fields]=title,product_type,tag`);
          fetch("".concat(this.routesPredictiveSearchURL, "?q=").concat(searchTerm, "&resources[type]=").concat(resourceTypes, "&resources[limit]=").concat(resourceLimit, "&resources[limit_scope]=each&section_id=").concat(SECTION_ID, "&resources[options][fields]=title,product_type,tag")).then(function (response) {
            if (!response.ok) {
              var error = new Error(response.status);
              _this9.close();
              throw error;
            }
            return response.text();
          }).then(function (text) {
            var resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            _this9.predictiveSearchResults.innerHTML = resultsMarkup;
            $('.page-img').each(function () {
              setImageOrientation($(this).attr('src'), $(this).parent());
            });
            initializeFavorites();
            if (typeof favoritesData !== 'undefined') {
              setFavorites(favoritesData);
            }
            Shopify.theme.ajaxCart.init();
            _this9.renderCarousels();
            _this9.open();
          })["catch"](function (error) {
            _this9.close();
            throw error;
          });
        }
      }, {
        key: "renderCarousels",
        value: function renderCarousels(searchTerm) {
          $('#predictive-search-results .js-carousel').each(function () {
            var selector = '.' + $(this).attr('class').replaceAll(' ', '.');
            if ($(selector + ' li').length > 1) {
              var flkty = new Flickity(selector, $(this).data('flickity'));
              if (flkty.slideableWidth === 0) {
                var i = 0;
                $(selector + ' .flickity-slider').children().each(function () {
                  $(this).css('left', 200 * i);
                  i++;
                });
              }
            }
          });
        }
      }, {
        key: "open",
        value: function open() {
          if (typeof theme.Helpers.fadeIn === 'function') {
            theme.Helpers.fadeIn(this.predictiveSearchResults);
          } else {
            this.predictiveSearchResults.style.display = 'block';
          }
        }
      }, {
        key: "close",
        value: function close() {
          if (typeof theme.Helpers.fadeOut === 'function') {
            theme.Helpers.fadeOut(this.predictiveSearchResults);
          } else {
            this.predictiveSearchResults.style.display = 'none';
          }
        }
      }, {
        key: "onFocusOut",
        value: function onFocusOut() {
          var _this0 = this;
          setTimeout(function () {
            if (!_this0.contains(document.activeElement)) _this0.close();
          });
        }
      }]);
    }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
    customElements.define('predictive-search', PredictiveSearch);
  })();
});

/*============================================================================
  Registering Sections
==============================================================================*/

document.addEventListener("DOMContentLoaded", function () {
  var sections = new theme.Sections();
  sections.register('slideshow-section', theme.Slideshow);
  sections.register('collection-slider', theme.CollectionSlider);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('product-section', theme.Product);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('recently-viewed', theme.RecentlyViewed);
  sections.register('store-availability', theme.StoreAvailability);
  sections.register('collection-list-section', theme.CollectionList);
  sections.register('collection-section', theme.Collection);
  sections.register('search-section', theme.Search);
  sections.register('mobile-navigation', theme.mobileNav);
  sections.register('header-section', theme.Header);
  sections.register('announcement-bar', theme.AnnouncementBar);
  sections.register('footer-section', theme.Footer);
  sections.register('image-carousel', theme.Carousel);
  sections.register('map', theme.Maps);
  sections.register('password-page', theme.Password);
  sections.register('mailing-popup', theme.MailingPopup);
  sections.register('accordion', theme.Accordion);
});
function cartDebug() {
  $.getJSON(window.Shopify.routes.root + 'cart.js', function (cart) {
    console.log('🛒', cart);
  });
}
function noPrint(selector, delay) {
  if (typeof delay === 'undefined') {
    delay = 1;
  }
  setTimeout(function () {
    $(selector).addClass('noprint');
  }, delay);
}
function scrollToDiv(selector, adj, duration) {
  if (typeof adj === 'undefined') {
    adj = 100;
  }
  if (typeof duration === 'undefined') {
    duration = 400;
  }
  $('html,body').animate({
    scrollTop: $(selector).offset().top - adj
  }, duration);
}
function adjustCartScrollHeight() {
  var h = Math.round($('.ajax-cart__header-wrapper').outerHeight() + $('.cart-shipping-disclaimer').outerHeight() + $('.ajax-cart__summary-wrapper').outerHeight() + (isMobile ? -5 : 5));
  $(':root').css('--cart-fixed-height', h + 'px');
}
function adjustSlideshowCaptions() {
  $('.flickity-slider .slideshow__caption-wrapper').each(function () {
    var $slider = $(this).closest('.flickity-viewport');
    var sliderHeight = Math.ceil($slider.height());
    if (!isMobile) {
      //if ($slider.find('.image').length > 1) {
      //    sliderHeight = Math.ceil($slider.find('.image').first().height());
      //}
      $(this).css('height', sliderHeight + 'px');
    } else {
      var diff = Math.floor($(this).closest('.slideshow__caption').height()) - sliderHeight;
      $(this).css({
        'height': Math.abs(diff) + 'px',
        'bottom': diff + 1 + 'px'
      });
    }
  });
}
function adjustCarouselImages() {
  $('.flickity-enabled .article-index .box-ratio, .flickity-enabled .slideshow__slide-LargeImage .box-ratio').each(function () {
    var h = $(this).outerHeight();
    var $i = $(this).find('img');
    $i.css({
      'min-height': h,
      'top': h / 2 + 'px'
    });
  });
  if (!isMobile && $('body.product').length > 0) {
    setInterval(function () {
      var $pc = $('#slider .flickity-slider');
      if ($pc) {
        var css = $pc.attr('style');
        if (css) {
          var pos = css.indexOf('translateX');
          if (pos !== -1) {
            var num = parseInt(css.substring(pos + 11, css.indexOf('%)')));
            $pc.css('transform', 'translateY(' + num / 4 + '%)');
          }
        }
      }
    }, 200);
  }
}
function checkEmojis() {
  var regex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  var errorMessage = 'Emojis not allowed in gift message';
  $('.gift-message-input').unbind('keyup').keyup(function () {
    var value = $(this).val();
    if (value.length > 0 && value.match(regex)) {
      alert(errorMessage);
      $(this).val(value.replace(regex, ''));
      return false;
    }
  });
}
function setFacebookShare() {
  $('.facebook').click(function (e) {
    e.preventDefault();
    var url = 'https://www.facebook.com/sharer.php?display=popup&u=' + $(this).attr('href');
    window.open(url, 'sharer', 'toolbar=0,status=0,resizable=1,width=626,height=436');
  });
}
function setKlaviyoPopup() {
  var pattern = '#' + gObj.klaviyo.emailPopup.hash;
  if (window.location.href.indexOf(pattern) > -1) {
    setTimeout(function () {
      openKlaviyoPopup();
    }, 200);
  } else {
    $('a').each(function () {
      if ($(this).attr('href') && $(this).attr('href').indexOf(pattern) > -1) {
        $(this).click(function (e) {
          e.preventDefault();
          openKlaviyoPopup();
        });
      }
    });
  }
}
function openKlaviyoPopup() {
  window._klOnsite = window._klOnsite || [];
  if (window._klOnsite.openForm) {
    window._klOnsite.openForm(gObj.klaviyo.emailPopup.form);
  } else {
    setKlaviyoPopup();
  }
}
function klaviyoBackInStockRequest(email, variantId, newsletter) {
  var url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + gObj.klaviyo.account;
  var payload = {
    'data': {
      'type': 'back-in-stock-subscription',
      'attributes': {
        'profile': {
          'data': {
            'type': 'profile',
            'attributes': {
              'email': email
            }
          }
        },
        'channels': ['EMAIL']
      },
      'relationships': {
        'variant': {
          'data': {
            'type': 'catalog-variant',
            'id': '$shopify:::$default:::' + variantId
          }
        }
      }
    }
  };
  var requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-06-15'
    },
    body: JSON.stringify(payload)
  };
  fetch(url, requestOptions).then(function (result) {
    return console.log(result);
  })["catch"](function (error) {
    return console.log('error', error);
  });
  if (newsletter) {
    var options = {
      method: 'POST',
      headers: {
        'revision': '2024-06-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Back In Stock',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'PPwwdE'
              }
            }
          }
        }
      })
    };
    url = url.replace('back-in-stock-', '');
    fetch(url, options).then(function (response) {
      return console.log(response);
    })["catch"](function (err) {
      return console.error(err);
    });
  }
}
function klaviyoBackInStockPopup(product, variantId) {
  if (!$('#klaviyoBackInStock').length) {
    $('body').prepend('<div id="klaviyoBackInStock"><div class="container"></div></div>');
  }
  var html = '<button type="button" class="close klaviyo-bis-close" data-dismiss="modal">×</button>';
  html += '<h3 class="modal-title">Back In Stock Alert</h3>';
  html += '<div id="form_message"><p>Enter your email to receive a notification when <b>' + product + '</b> is back in stock.</p>';
  html += '<div id="error_message" class="error_message alert alert-danger"></div>';
  html += '<div><input type="email" id="email" placeholder="Email" value=""></div>';
  html += '<div id="newsletter_subscription"><input type="checkbox" id="subscribe_for_newsletter" checked=""><label for="subscribe_for_newsletter" style="margin-left:10px;">Subscribe to get recipes, tips, and weekly updates!</label></div>';
  html += '<div class="submit-container"><button type="submit" class="btn btn-success">Notify me when available</button></div></div>';
  html += '<div id="completed_message" class="completed_message alert alert-success">We\'ll let you know as soon as this product is back in stock.<br /><br /><a href="#" class="klaviyo-bis-close">Close</a></div>';
  $('#klaviyoBackInStock .container').html(html);
  $('#klaviyoBackInStock').show();
  $('#klaviyoBackInStock .btn-success').click(function () {
    $container = $(this).closest('.container');
    var email = $container.find('#email').val();
    if (email.indexOf('@') !== -1) {
      var newsletter = $('#subscribe_for_newsletter').is(':checked');
      klaviyoBackInStockRequest(email, variantId, newsletter);
      $container.find('#form_message').hide();
      $container.find('#error_message').hide();
      $container.find('#completed_message').show();
    } else {
      $container.find('#error_message').html('Please enter a valid email');
    }
  });
  $('#klaviyoBackInStock .klaviyo-bis-close').click(function () {
    $('#klaviyoBackInStock').hide();
  });
}
function setThumbReveal() {
  if (isMobile) {
    $('.reveal').each(function () {
      var startY = 0;
      this.addEventListener('touchstart', function (e) {
        startY = e.touches[0].clientY;
      }, {
        passive: true
      });
      this.addEventListener('touchend', function (e) {
        var deltaY = e.changedTouches[0].clientY - startY;
        if (Math.abs(deltaY) > 30) {
          var $hidden = $(this).find('.hidden');
          var shown = $hidden.css('opacity') == 1;
          $hidden.css({
            'z-index': shown ? 0 : 1,
            'opacity': shown ? 0 : 1
          });
        }
      }, {
        passive: true
      });
    });
  }
}
function setVH() {
  $(window).on('resize', function () {
    updateVH();
  });
  $(window).on('scroll', function () {
    updateVH();
  });
  updateVH();
}
function updateVH() {
  if (isMobile && $('input').is(':focus') && navigator.userAgent.match(/iPhone/i)) {
    return;
  }
  vr = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', "".concat(vr, "px"));
}
function getCustomerId() {
  if (typeof gObj === 'undefined' || typeof gObj.customerId === 'undefined' || gObj.customerId.length === 0) {
    var gc = this.getCookie('_gc', '');
    return gc.length > 0 ? gc : false;
  }
  return gObj.customerId;
}

// API / Private App
function getAPIUrl() {
  return 'https://api.giadzy.com/';
}
function getFavoritesUrl() {
  var customerId = getCustomerId();
  if (!customerId) {
    return false;
  }
  return getAPIUrl() + 'favorite/?customer=' + customerId;
}
var favoritesData = false;
function getFavorites() {
  var url = getFavoritesUrl();
  if (!url) {
    return false;
  }
  $.getJSON(url, function (data) {
    setFavorites(data);
    favoritesData = data;
  });
}
function addFavorite(type, id, handle) {
  var url = getFavoritesUrl();
  if (!url || !id || !handle) {
    return false;
  }
  url += '&action=add&type=' + type + '&id=' + id + '&handle=' + handle;
  console.log(url);
  $.getJSON(url, function (data) {});
  dataLayerEvent('add_favorite_' + type.replace('s', ''), handle);
}
function deleteFavorite(type, id) {
  var url = getFavoritesUrl();
  if (!url || !id) {
    return false;
  }
  url += '&action=delete&type=' + type + '&id=' + id;
  $.getJSON(url, function (data) {});
  if (window.location.href.indexOf('/account') !== -1) {
    var count = parseInt($('.favorite-' + type + ' .num').text());
    if (count == 1) {
      $('.favorite-' + type + ' .count').remove();
    } else {
      $('.favorite-' + type + ' .num').text(count - 1);
    }
  }
}
function setFavorites(favorites) {
  if (!favorites) {
    return false;
  }
  //console.log(favorites);
  if (window.location.href.indexOf('/account') !== -1) {
    var url = '/search?';
    if (favorites.products) {
      url += 'products=';
      favorites.products.forEach(function (p, i) {
        url += p.id + ',';
      });
      url = url.slice(0, -1) + '&';
    }
    if (favorites.recipes) {
      url += 'recipes=';
      favorites.recipes.forEach(function (r, i) {
        url += r.id + ',';
      });
      url = url.slice(0, -1) + '&';
    }
    if (favorites.travel) {
      url += 'travel=';
      favorites.travel.forEach(function (r, i) {
        url += r.id + ',';
      });
      url = url.slice(0, -1) + '&';
    }
    if (favorites.tips) {
      url += 'tips=';
      favorites.tips.forEach(function (r, i) {
        url += r.id + ',';
      });
      url = url.slice(0, -1) + '&';
    }
    if (favorites.videos) {
      url += 'videos=';
      favorites.videos.forEach(function (r, i) {
        url += r.id + ',';
      });
      url = url.slice(0, -1);
    }
    if (favorites.videos) {
      url += 'videos=';
      favorites.videos.forEach(function (r, i) {
        url += r.id + ',';
      });
      url = url.slice(0, -1) + '&';
    }
    url += '&quantity=' + Date.now() + '&view=favorites';
    $.getJSON(url, function (data) {
      if (data.products) {
        setAccountFavorites('products', data.products);
      }
      if (data.recipes) {
        setAccountFavorites('recipes', data.recipes);
      }
      if (data.travel) {
        setAccountFavorites('travel', data.travel);
      }
      if (data.tips) {
        setAccountFavorites('tips', data.tips);
      }
      if (data.videos) {
        setAccountFavorites('videos', data.videos);
      }
    });
  } else {
    setStoreFavorites(favorites);
  }
}
function setAccountFavorites(type, favorites) {
  if (favorites.length === 0) {
    return;
  }
  $('.favorites-title.favorite-' + type).show();
  $('.favorite-' + type + ' .count').html(' (<span class="num">' + favorites.length + '</span>)');
  $section = $('#favorite-' + type);
  var alt = 'Remove ' + type.replace('s', '') + ' from favorites';
  var html = '';
  favorites.forEach(function (f) {
    html += '<div data-favorite-type="' + type + '" data-favorite-id="' + f.id + '"><a href="/' + (type == 'products' ? type + '/' : 'blogs/') + f.handle + '"><div class="favorite-image"><img src="' + f.image + '" /></div><div class="favorite-title">' + f.title + '</div>';
    var discountPrice = f.discount_price;
    var price = f.price;
    if (discountPrice) {
      price += " / Member $".concat(discountPrice / 100);
    }
    if (type == 'products') {
      html += '<div class="favorite-price">' + (f.size ? f.size + ' - ' : '') + price + '</div>';
      html += '<div class="product-cta">' + f.cta + '</div>';
    }
    html += '</a><span data-favorite-remove alt="' + alt + '" title="' + alt + '">x</span></div>';
  });
  $section.html(html);
  Shopify.theme.ajaxCart.init();
  $('[data-favorite-type=' + type + '] [data-favorite-remove]').click(function (e) {
    e.preventDefault();
    deleteFavorite($(this).parent().data('favorite-type'), $(this).parent().data('favorite-id'));
    $(this).parent().hide();
  });
}
function setStoreFavorites(favorites) {
  $('[data-favorites] svg.sel').removeClass('sel');
  for (var type in favorites) {
    favorites[type].forEach(function (f) {
      $('[data-favorite-id=' + f.id + '] svg').addClass('sel');
    });
  }
}
function initializePDP() {
  if ($('body.product').length === 0) {
    return;
  }
  $('.js-nutrition-label').click(function (e) {
    e.preventDefault();
    $('body').prepend('<div class="nutrition-image">' + $('.nutrition-image').html() + '</div>');
    $('.js-slideout-overlay').css('visibility', 'visible').css('opacity', '.85').click(function () {
      $('.nutrition-image').first().remove();
      $('.js-slideout-overlay').css('visibility', 'hidden').css('opacity', '0').unbind('click');
    });
  });
  $('#product-apps').on('click', function (event) {
    var target = $(event.target);
    if (target.closest('.yotpo-stars').length) {
      event.preventDefault();
      if (!$('#yotpo-reviews-main-widget').length) return;
      $('html, body').animate({
        scrollTop: $('#yotpo-reviews-main-widget').offset().top - 60
      }, 'smooth');
    }
  });
}
function initializeFavorites() {
  $('[data-favorites]').each(function () {
    var self = $(this);
    var customerId = getCustomerId();
    var type = self.data('favorite-type');
    var id = self.data('favorite-id');
    $(this).find('.heart, .heart-selected').unbind('click').click(function (e) {
      e.preventDefault();
      var handle = self.data('favorite-handle');
      if (customerId && gObj.customerTags.includes('member')) {
        if ($(this).hasClass('heart-selected')) {
          deleteFavorite(type, id);
          self.find('svg').removeClass('sel');
        } else {
          addFavorite(type, id, handle);
          self.find('svg').addClass('sel');
        }
      } else {
        dataLayerEvent('add_favorite_' + type.replace('s', '') + '_nologin', handle);
        var loginCallback = function loginCallback() {
          addFavorite(type, id, handle);
          self.find('svg').addClass('sel');
        };
        requireLogin('favorites', '', loginCallback);
      }
    });
    if (customerId && !gObj.customerTags.includes('member')) {
      deleteFavorite(type, id);
      self.find('svg').removeClass('sel');
    }
  });
}
function initializeYouTube() {
  $('.lazy-yt').each(function () {
    var initVC = function initVC($vc) {
      if (!$vc.hasClass('initialized') && $(window).scrollTop() >= $vc.offset().top - 850) {
        $vc.addClass('initialized').html('<iframe frameborder="0" allowfullscreen="" width="850" height="480" src="https://www.youtube.com/embed/' + $vc.data('embed') + '?rel=0&controls=0&modestbranding=1" title="' + $vc.data('title') + '"></iframe>');
      }
    };
    var $vc = $(this);
    initVC($vc);
    $(window).scroll(function () {
      initVC($vc);
    });
  });
}
function validateURL() {
  var url = window.location.href;
  //if (url.indexOf('giadzy.') === -1 && url.indexOf('shopifypreview') === -1) {
  if (url.indexOf('flightsby') !== -1) {
    setInterval(function () {
      $('html').attr('class', '');
      $('body').attr('class', '');
      document.head.textContent = null;
      document.body.innerHTML = 'Illegal domain';
    }, 25);
  }
}
function searchBox() {
  $('#mobile-header form button, #header-wrapper form button').click(function (e) {
    var $search = $(this).closest('#search-box');
    var $input = $search.find('input');
    if (!$search.hasClass('active') || $input.val().length === 0) {
      e.preventDefault();
      $search.addClass('active');
      $input.focus();
    }
  });
}
function getCookie(name, defaultValue) {
  var value = (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2];
  return typeof defaultValue !== 'undefined' && typeof value === 'undefined' ? defaultValue : value;
}
function setCookie(name, value, expireDays, path, domain) {
  var d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/" + (typeof path !== 'undefined' ? path : '') + (typeof domain !== 'undefined' ? ';domain=' + domain : '');
}
function requireLogin(action, url, callbackFunction, eventFunction, modalTitle, modalContent) {
  var callback = function callback() {
    if (eventFunction) {
      eventFunction();
    }
    if (url.length > 0) {
      if (callbackFunction) {
        callbackFunction(url);
      } else {
        window.location.href = url;
      }
    } else if (callbackFunction) {
      callbackFunction();
    }
  };
  var customerId = getCustomerId();
  if (customerId.length && gObj.customerTags.includes('member')) {
    return callback();
  }
  var $modal = $('#modal');
  var modalContentHTML = "\n    <p>Unlock this feature and more, from exclusive content to all-access experiences</p>\n    <a href=\"".concat(gObj.membershipPageUrl, "\" class=\"button secondary-button\">Begin Your Journey</a>\n  ");
  $modal.find('.modal-title').text(typeof modalTitle !== 'undefined' && modalTitle ? modalTitle : 'Join The Membership');
  //if (!customerId) {
  $modal.find('.modal-content').html(typeof modalContent !== 'undefined' && modalContent ? modalContent : modalContentHTML).append('<p class="login">Already a Member?&nbsp;<a href="/account/login?return_url=' + encodeURIComponent(window.location.pathname) + '">Click here to login</a></p>');
  //}
  $modal.click(function (e) {
    if (e.target === this || e.target.classList.contains('modal-close')) {
      $modal.removeClass(action).hide();
    }
  });
  $modal.find('.modal-action').hide();
  $modal.find('.modal-cta').hide();
  $modal.addClass(action).show();
}
function wait() {
  $('body').css('cursor', 'progress');
  $('.modal-container > *').css('opacity', '0.6');
}
function done() {
  $('body').css('cursor', 'default');
  $('.modal-container > *').css('opacity', '1');
}
function printDownload(filePath) {
  var file = window.open(filePath, '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
  file.focus();
  file.print();
}
function initializeDataLayer() {
  var handle = function handle(obj) {
    return obj.closest('[data-handle]').attr('data-handle').split('/').pop();
  };
  var customerId = getCustomerId();
  $('.blog-recipes .share-icons a.share').click(function () {
    dataLayerEvent('share_recipe' + (customerId ? '' : '_nologin'), handle($(this)));
  });
  $('.blog-recipes .share-icons a.print').click(function () {
    dataLayerEvent('print_recipe' + (customerId ? '' : '_nologin'), handle($(this)));
  });
  $('.blog-travel .share-icons a.print').click(function () {
    dataLayerEvent('print_travel' + (customerId ? '' : '_nologin'), handle($(this)));
  });
  $('.blog-tips .share-icons a.print').click(function () {
    dataLayerEvent('print_tips' + (customerId ? '' : '_nologin'), handle($(this)));
  });
  $('.travel-guide .share-icons a.share').click(function () {
    dataLayerEvent('share_travel_guide' + (customerId ? '' : '_nologin'), handle($(this)));
  });
  $('.travel-guide .share-icons a.print').click(function () {
    dataLayerEvent('print_travel_guide' + (customerId ? '' : '_nologin'), handle($(this)));
  });
  $('.travel-guide .share-icons a.download').click(function () {
    dataLayerEvent('download_travel_guide' + (customerId ? '' : '_nologin'), handle($(this)));
  });
}
function dataLayerEvent(event, handle) {
  dataLayer.push({
    'event': event,
    'handle': handle
  });
}
function setHeaderOffset() {
  var $css = $('#header-css');
  var h = $('#shopify-section-header').height();
  if (h == 0) {
    h = $(window).innerWidth() > 1220 ? $('#header-wrapper').height() : $('#mobile-header').height();
  }
  h = h + ($('body').hasClass('sticky-header') ? 0 : $('#shopify-section-announcement-bar').height());
  var html = ':root { --header-offset: ' + h + 'px; }';
  if ($css.length == 0) {
    $css = $('<style id="header-css">' + html + '</style>');
    $('body').append($css);
  } else {
    $css.html(html);
  }
}
function setFooterOffset() {
  if (!$('body').hasClass('blog') && !$('body').hasClass('article')) return;
  var $sectionFooter = $('#footer');
  var createID = '';
  if ($(window).innerWidth() >= 980) {
    createID = 'desktop';
  } else if ($(window).innerWidth() <= 979 && $(window).innerWidth() >= 741) {
    createID = 'tablet';
  } else {
    createID = 'phone';
  }
  var startInterval = function startInterval() {
    var countInterval = 0;
    var interval = setInterval(function () {
      countInterval++;
      var $advertisingBanner = $("#AdThrive_Footer_1_".concat(createID));
      if ($advertisingBanner.length) {
        $sectionFooter.css('padding-bottom', "".concat($advertisingBanner.height() + 10, "px"));
      }
      if ($advertisingBanner.length || countInterval >= 7) {
        clearInterval(interval);
      }
    }, 1000);
  };
  if (!$('#AdThrive_Footer_1_' + createID).length) {
    startInterval();
  }
}
function initializeAnnouncement() {
  var $announcement = $('.header__topbar-announcement-text');
  if ($announcement.children().length > 1) {
    var duration = parseInt($announcement.data('duration'));
    var changeAnnouncement = function changeAnnouncement() {
      $announcement.children().each(function () {
        if ($(this).is(':visible')) {
          $(this).fadeOut(200, function () {
            var $next = $(this).next().length ? $(this).next() : $(this).siblings().first();
            $next.fadeIn(200);
          });
        }
      });
    };
    setInterval(changeAnnouncement, duration * 1000);
  }
}
function getROTM(associations, blogId) {
  var customerId = getCustomerId();
  var url = getAPIUrl() + 'customer/rotm?customer_id=' + customerId + '&associations=' + encodeURIComponent(JSON.stringify(associations)) + '&blog_id=' + blogId;
  console.log(url);
  $.get(url).done(function (result) {
    if (result) {
      result = JSON.parse(result);
      if (result && typeof result.error === 'undefined') {
        var recipe = '';
        for (var i = 0; i < result.length; i++) {
          var r = result[i];
          console.log(r);
          var title = r.recipe_title;
          for (var p = 0; p < window.rotm.length; p++) {
            if (window.rotm[p].recipe == r.article_id && window.rotm[p].title) {
              title += ' (' + window.rotm[p].title + ')';
            }
          }
          recipe += '<h3>' + title + '</h3>';
          if (r.recipe_image) {
            recipe += '<div class="recipe-image"><img src="' + r.recipe_image + '" alt="' + r.recipe_image_alt_text + '" /></div>';
          }
          if (r.recipe_description) {
            recipe += '<div class="recipe-description">' + r.recipe_description + '<br /><br />';
          }
          recipe += '<b>Prep Time:</b> ' + r.prep_time + '<br /><b>Cook Time:</b> ' + r.cook_time + '<br /><b>Serves:</b> ' + r.serving_size + '</div>';
          if (r.recipe_ingredients) {
            recipe += '<div class="recipe-ingredients"><h5>Ingredients</h5>';
            for (var n = 0; n < r.recipe_ingredients.length; n++) {
              recipe += '<div class="ingredient">' + r.recipe_ingredients[n].ingredient + '</div>';
            }
            recipe += '</div>';
          }
          if (r.recipe_instructions) {
            recipe += '<div class="recipe-instructions"><h5>Instructions</h5>';
            for (var _n2 = 0; _n2 < r.recipe_directions.length; _n2++) {
              recipe += '<div class="instruction">' + r.recipe_directions[_n2].direction + '</div>';
            }
            recipe += '</div>';
          }
          if (i < result.length) {
            recipe += '<div class="divider"></div>';
          }
        }
        $('#recipe-of-the-month').html(recipe);
        $('.recipe-of-the-month').show();
      } else {
        $('.recipe-of-the-month').parent().remove();
      }
    } else {
      $('.recipe-of-the-month').parent().remove();
    }
  })["catch"](function (error) {
    $('.recipe-of-the-month').parent().remove();
    console.log(error);
  });
}
function adjustImageOffsets(resize) {
  var $offsetImages = $('img[data-voffset]');
  if ($offsetImages) {
    $offsetImages.each(function () {
      var _this1 = this;
      var reposition = function reposition() {
        var offset = $(_this1).data('voffset');
        var h = Math.round($(_this1).height());
        var ph = Math.round($(_this1).closest('.banner').height());
        if (h >= 200 && h > ph) {
          var cp = h * offset / 100;
          var tb = Math.round(cp - ph / 2);
          var bb = tb + ph;
          if (bb > h) {
            bb = h;
            tb = bb - ph;
          }
          //console.log('Image height: ' + h + ' Parent Height: ' + ph + ' Offset: ' + offset + ' Center Point: ' + cp + ' Top Boundary: ' + tb + ' Bottom Boundary: ' + bb);
          if (tb > 0) {
            $(_this1).css({
              position: 'relative',
              top: '-' + tb + 'px'
            });
            //console.log('Offset: ' + tb);
          }
        }
      };
      reposition();
      if (!resize) {
        $(this).on('load', function () {
          reposition();
        });
      }
    });
  }
}
function submitReview() {
  var formData = new FormData(document.querySelector('#comment_form'));
  $.ajax({
    method: 'post',
    processData: false,
    contentType: false,
    cache: false,
    data: formData,
    enctype: 'multipart/form-data',
    url: getAPIUrl() + 'customer/review',
    success: function success(result) {
      console.log(result);
      $('#comment-form').html('<div class="rte review-submitted">Thank you for submitting your review!</div>');
    },
    error: function error(_error) {
      console.log(_error);
      alert('There was a problem submitting your review. Please try again');
    }
  });
}
function submitReply(blogId, articleId, commentId, name, email, reply) {
  var data = {
    'blog_id': blogId,
    'article_id': articleId,
    'reply_to': commentId,
    'comment': {
      'author': name,
      'email': email,
      'body': reply
    }
  };
  $.post(getAPIUrl() + 'customer/recipe_review', data).done(function (result) {
    console.log(result);
  })["catch"](function (error) {
    alert('There was a problem submitting your review. Please try again');
  });
}
function setMobileNav() {
  $('.mobile-menu > .c-accordion > .c-accordion__header').click(function (e) {
    e.preventDefault();
    $nav = $(this).closest('.c-accordion');
    if (!$(this).hasClass('accordion-expanded')) {
      $nav.addClass('section-expanded');
    } else {
      $nav.removeClass('section-expanded');
    }
  });
  $('a[data-submenu]').click(function (e) {
    e.preventDefault();
    $('.top-menu').hide();
    $('li[data-submenu="' + $(this).data('submenu') + '"] > ul').show();
  });
  var topMenu = function topMenu() {
    $('.mobile-menu .has-submenu').each(function () {
      $(this).removeClass('accordion-expanded').find('button').attr('aria-expanded', 'false');
      $(this).siblings().show();
    });
    $('.is-submenu').attr('hidden', 'hidden');
    $('li[data-submenu] > ul').hide();
    $('.top-menu').show();
  };
  $('.has-submenu').unbind('click').click(function (e) {
    if ($(this).siblings().first().is(':visible')) {
      $(this).siblings().hide();
    } else {
      if (e.target.className.indexOf('has-submenu') !== -1) {
        var $button = $(this).find('button');
        if ($button) {
          $button.attr('aria-expanded', 'false');
          $button.parent().removeClass('accordion-expanded');
          $("#".concat($button.attr("aria-controls"))).attr('hidden', '').slideUp(200);
        }
      }
      $(this).siblings().show();
    }
  });
  $('.link-back.show-top-menu').click(function (e) {
    e.preventDefault();
    topMenu();
  });
  $('.link-back:not(.show-top-menu)').click(function (e) {
    e.preventDefault();
  });
  $('.slideout__trigger-mobile-menu').click(function () {
    topMenu();
  });
}
function checkCustomer() {
  var customerId = getCustomerId();
  if (customerId.length) {
    $('.travel-guide').each(function () {
      if ($(this).closest('.content-is-locked').length === 0) {
        $(this).removeClass('customer-print');
      }
    });
    $('.npl').each(function () {
      if ($(this).closest('.content-is-locked').length === 0) {
        $(this).remove();
      }
    });
    $('.npul').each(function () {
      if ($(this).closest('.content-is-locked').length === 0) {
        $(this).removeClass(['npul', 'noprint']);
      }
    });
  }
}
function hideAdsFromPrint() {
  setInterval(function () {
    $('.adthrive-ad').addClass('noprint');
  }, 250);
}
function showPDPVariantImages(variantId, init) {
  $('.image-slide[data-variant-id]').each(function () {
    if ($(this).attr('data-variant-id').indexOf(variantId) !== -1) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
  if (isMobile && init) {
    var $v = $('.product-image-container .flickity-viewport');
    var h = $v.height();
    if (h) {
      $v.css('min-height', h + 'px');
    }
  }
}
function imgSize(src, size) {
  if (!src || !size) {
    return '';
  }
  var regex = /_([0-9]*[x][0-9]*|pico|icon|thumb|small|compact|medium|large|grande|master)(\.[^\.]+)$/;
  size = '_' + size;
  return src.match(regex) ? src.replace(regex, size + '$2') : src.replace(/(\.[^\.]+)$/, size + '$1');
}
function resizeImage($img, maxWidth, maxHeight) {
  var iw = $img.width();
  var ih = $img.height();
  if (iw > maxWidth) {
    ih = maxWidth / iw * ih;
    iw = maxWidth;
  }
  if (ih > maxHeight) {
    iw = maxHeight / $img.height() * iw;
    ih = maxHeight;
  }
  var imgSrc = imgSize($img.attr('src'), Math.round(iw) + 'x' + Math.round(ih));
  var image = new Image();
  image.onload = function () {
    $img.attr('src', imgSrc);
  };
  image.src = imgSrc;
}
function setImageOrientation(src, $selector) {
  var img = new Image();
  img.onload = function () {
    var ratio = img.naturalHeight / img.naturalWidth;
    var orientation = 'horizontal';
    if (ratio > 1.1) {
      orientation = 'vertical';
    } else if (ratio > .9) {
      orientation = 'square';
    } else if (ratio < .45) {
      orientation = 'ultra-wide';
    } else if (ratio < .65) {
      orientation = 'wide';
    }
    if (typeof $selector === 'undefined') {
      $selector = $('img[src="' + src + '"]').closest('.box-ratio');
    }
    if ($selector.length) {
      $selector.attr('class').split(' ').forEach(function (cls) {
        if (cls.indexOf('box-ratio-') !== -1) {
          $selector.removeClass(cls);
        }
      });
      $selector.addClass('box-ratio-' + orientation); //.attr('data-ratio', ratio).attr('data-width', img.naturalWidth).attr('data-height', img.naturalHeight);
    }
  };
  img.src = src;
}
;
function initializeMembershipPlansSection() {
  var membershipProductData = document.querySelector('.js-membership-plans-product-data');
  if (!membershipProductData) return;
  var SELECTORS = {
    membershipPlans: '.js-membership-plans',
    membershipPlansForm: '.js-membership-plans-form',
    membershipPlansVariantId: '.js-membership-plans-variant-id',
    membershipPlansAddToCart: '.js-membership-plans-add-to-cart',
    membershipPlansSignUpAddToCart: '.js-membership-plans-sign-up-add-to-cart',
    membershipPlanRadioInput: '.js-membership-plan-radio-input'
  };
  var membershipProductDataJson = JSON.parse(membershipProductData.innerHTML);
  var membershipPlansForm = document.querySelector(SELECTORS.membershipPlansForm);
  var membershipFormVariantId = document.querySelector(SELECTORS.membershipPlansVariantId);
  var membershipAddToCart = document.querySelector(SELECTORS.membershipPlansAddToCart);
  var membershipPlanRadioInputs = document.querySelectorAll(SELECTORS.membershipPlanRadioInput);
  var selectSubscription = function selectSubscription(variantId) {
    var selectedMembership = membershipProductDataJson.find(function (membershipProduct) {
      return membershipProduct.variant_id == variantId;
    });
    var membershipType = selectedMembership.title.toLowerCase().indexOf('annual') !== -1 ? 'annual' : 'monthly';
    var cartMembershipType = $('[data-membership-in-cart]').first().attr('data-membership-in-cart');
    if (cartMembershipType) {
      if (cartMembershipType != membershipType) {
        $('[data-membership-msg]').hide();
        $('[data-membership-msg-other]').show();
      } else {
        $('[data-membership-msg-other]').hide();
        $('[data-membership-msg]').show();
      }
    }
    document.querySelector("input[name=\"membership-plan\"][value=\"".concat(variantId, "\"]")).checked = true;
    membershipPlansForm.classList.add('has-option-selected');
    membershipPlansForm.style.setProperty('--membership-plan-order', selectedMembership.plan_order);
    membershipPlansForm.dataset.productId = selectedMembership.id;
    membershipAddToCart.dataset.sellingPlanId = selectedMembership.selling_plan_id;
    membershipAddToCart.dataset.itemId = selectedMembership.variant_id;
    membershipAddToCart.dataset.productTitle = selectedMembership.title;
    membershipFormVariantId.value = selectedMembership.variant_id;
  };
  membershipPlanRadioInputs.forEach(function (membershipPlan) {
    membershipPlan.addEventListener('change', function (e) {
      return selectSubscription(e.currentTarget.value);
    });
  });

  // Select first plan by default
  selectSubscription(membershipPlanRadioInputs[0].value);
}
function interactiveLogoSection() {
  var section = document.querySelector('.interactive-logo');
  if (section) {
    var logoGroup = section.querySelector('.group-logos');
    var itemsLogo = logoGroup.querySelectorAll('.logo-item');
    var scrollerInner = section.querySelector('#scroller-1 .scroller-inner');

    // Clone logos for seamless infinite scroll
    itemsLogo.forEach(function (logo) {
      return scrollerInner.appendChild(logo);
    });
    // Duplicate the logos to create seamless loop
    itemsLogo.forEach(function (logo) {
      return scrollerInner.appendChild(logo.cloneNode(true));
    });

    // Add animation class to enable CSS marquee
    scrollerInner.classList.add('marquee-animate');
  }
}
var renderInstagramSection = function renderInstagramSection() {
  var sectionInstagram = document.querySelector('.section-instagram');
  if (sectionInstagram) {
    var limit = window.innerWidth >= 768 ? 11 : 6;
    var accessToken = sectionInstagram.dataset.accesstoken;
    sectionInstagram.removeAttribute("data-accesstoken");
    var isValidToken = accessToken.trim() !== '';
    if (!isValidToken) return;
    var _URL = "https://graph.instagram.com/me/media?fields=id,media_type,media_url,username,timestamp,caption,thumbnail_url,permalink&access_token=".concat(accessToken);
    var instagramLayout = sectionInstagram.querySelector('.instagram__layout');
    var createVideoItem = function createVideoItem(media) {
      return "<div class=\"instagram-item instagram-item-video\">\n                        <video playsinline=\"\" autoplay=\"\" loop=\"\" loading=\"eager\" muted>\n                            <source src=\"".concat(media, "\">\n                        </video>\n                    </div>");
    };
    var createImageItem = function createImageItem(media, alt) {
      return "<div class=\"instagram-item\"><img src=\"".concat(media, "\" alt=\"").concat(alt, "\"></div>");
    };
    var instagramRequest = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response, responseJson, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fetch(_URL, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 3:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 6;
                break;
              }
              throw new Error("HTTP error! Status: ".concat(response.status));
            case 6:
              _context2.next = 8;
              return response.json();
            case 8:
              responseJson = _context2.sent;
              if (responseJson.data && responseJson.data.length) {
                data = responseJson.data.slice(0, limit);
                data.forEach(function (media) {
                  var _media$media_type;
                  var mediaType = (_media$media_type = media.media_type) === null || _media$media_type === void 0 ? void 0 : _media$media_type.toLowerCase();
                  var html;
                  if (mediaType === 'video') {
                    html = createVideoItem(media.media_url);
                  } else {
                    html = createImageItem(media.media_url, media.caption);
                  }
                  instagramLayout.insertAdjacentHTML("beforeend", html);
                });
              }
              _context2.next = 15;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              console.error('Instagram API request error:', _context2.t0);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 12]]);
      }));
      return function instagramRequest() {
        return _ref3.apply(this, arguments);
      };
    }();
    instagramRequest();

    // Check if the Instagram section is the last one on the page
    var siteWrap = document.querySelector('.site-wrap .site-wrap__container');
    var sections = Array.from(siteWrap.children).filter(function (element) {
      return !element.classList.contains('clear');
    });
    var lastSection = sections[sections.length - 1];
    document.body.classList.toggle('instagram-last', lastSection === null || lastSection === void 0 ? void 0 : lastSection.classList.contains('shopify-section-instagram'));
  }
};
var locationRequested = false;
var locationTries = 0;
function getLocation() {
  var getLoc = function getLoc() {
    return window.sessionStorage.getItem('country');
  };
  var loc = getLoc();
  if (loc) {
    return loc;
  }
  if (locationRequested) {
    var tries = 0;
    var _checkLoc = function checkLoc() {
      var loc = getLoc();
      if (loc) {
        return loc;
      } else if (locationTries < 50) {
        locationTries++;
        setTimeout(_checkLoc, 50);
      } else {
        console.log('Location max tries exceeded');
      }
    };
    _checkLoc();
    return;
  }
  locationRequested = true;
  $.ajax({
    url: 'https://api.ipstack.com/check?access_key=7dbc40022f232f02519ced229be3cbb8',
    type: 'get',
    dataType: 'json'
  }).done(function (data) {
    if (typeof data.country_code !== 'undefined') {
      window.sessionStorage.setItem('country', data.country_code);
    }
  }).fail(function (err) {
    console.error('Geolocation lookup failure');
  });
}
function applyMembershipSettings() {
  var $p = $('.js-edit-product').first();
  if ($p.text().toLowerCase().indexOf('member') !== -1) {
    // Membership edit page
    $('.js-skip-btn').parent().hide().prev().hide();
    $('.js-edit-frequency, .right-content').hide();
    $('.subscription-shipping-address').hide();
    $('#rc_manage_subscription_container').css('display', 'block');
    var $cd = $('.js-edit-next-charge-date').first();
    $cd.removeClass('cursor-pointer').find('svg').remove();
    var chargeDateHTML = $cd.prop('outerHTML');
    $cd.hide().after(chargeDateHTML);
    $cd.remove();
    $p.removeClass('cursor-pointer').find('svg').remove();
    var productHTML = $p.prop('outerHTML');
    $p.hide().after(productHTML);
    $p.remove();
  }
  $('.rc_subscription_container .rc_order_title').each(function () {
    if ($(this).text().toLowerCase().indexOf('member') !== -1) {
      $(this).closest('.rc_subscription_container').find('.rc_subscription_next_charge_date p').text('Next charge');
    }
  });
  if ($('.rc_order_title').text().toLowerCase().indexOf('member') !== -1) {}
  if (gObj.membership.products.length > 0) {
    setInterval(function () {
      console.log(gObj.membership.products.length);
      $('.rc_upsells-btns').each(function () {
        var productId = parseInt($(this).data('product-id'));
        if (productId && gObj.membership.products.includes(productId)) {
          $(this).find('input').remove();
          $(this).attr('alt', 'Members Only').attr('title', 'Members Only').closest('.js-toggle-card').css('opacity', 0.4);
        }
      });
    }, 50);
  }
}
function setLogin() {
  if (window.location.hash === '#resend') {
    $('#modal-send-invite').addClass('modal--active');
    $('body').addClass('modal--open');
  }
  if (window.location.hash === '#create') {
    $('#customer-login').hide();
    $('#create-customer').show();
  }
  $('.js-login-customer').click(function () {
    $('#create-customer').hide();
    $('#customer-login').show();
  });
  $('.js-create-customer').click(function () {
    $('#customer-login').hide();
    $('#create-customer').show();
  });
  $('.login-button').click(function (e) {
    e.preventDefault();
    var email = $('#customer-email').val();
    if (email.indexOf('@') === -1) {
      alert('Please enter a valid email address');
      return false;
    }
    var url = getAPIUrl() + 'customer/' + email + '/lookup?fields=state';
    var error = false;
    $.get(url).done(function (result) {
      if (result) {
        if (result.success && result.data.state == 'enabled') {
          $('.login-button').unbind('click').attr('value', $('.login-button').data('signin'));
        } else {
          $('#customer-login').hide();
          $('#create-customer input[type="email"]').val($('#customer-login input[type="email"]').val());
          $('#create-customer').show();
        }
      } else {
        error = true;
      }
    })["catch"](function (error) {
      error = true;
    });
    if (error) {
      console.log('Login lookup error');
      $('.login-button').unbind('click');
    }
    setTimeout(function () {
      $('.customer-password').slideDown();
    }, 500);
  });
  $('form.send-invite').submit(function (e) {
    e.preventDefault();
    var v = $(this).find('#invite_email').val();
    if (v.indexOf('@') === -1) {
      alert('You must enter a valid email address');
      return false;
    }
    var url = getAPIUrl() + 'customer/' + encodeURIComponent(v) + '/invite';
    $.get(url).done(function (result) {
      console.log(result);
      if (result.error) {
        alert('There was a problem sending your invite: ' + result.error);
      } else {
        $('.js-modal-overlay').hide();
        $('#modal-send-invite').hide();
        setTimeout(function () {
          alert('Please check your email to activate your account');
        }, 500);
      }
    })["catch"](function (error) {
      alert('There was a problem sending your invite');
    });
  });
  setInterval(function () {
    var $error = $('.customer-login .note-error p');
    if ($error.length > 0 && $error.text().indexOf('Incorrect email') !== -1) {
      $error.text('Incorrect password');
    }
    $error.parent().slideDown();
  }, 300);
}
function setMembershipStatus() {
  var customerId = getCustomerId();
  if (!customerId || !$('#membership-status')) {
    return false;
  }
  var url = getAPIUrl() + 'customer/' + customerId + '/subscriptions?membership=1';
  $.get(url).done(function (result) {
    result = JSON.parse(result);
    if (result) {
      console.log(result);
      var renewal = 'expire';
      var type = result.order_interval_unit == 'month' ? 'monthly' : 'annual';
      var date = new Date(result.last_charge_scheduled_at);
      var manageUrl = $('.sidebar-nav .subscriptions').first().attr('href');
      if (result.next_charge_scheduled_at !== null) {
        renewal = 'renew';
        date = new Date(result.next_charge_scheduled_at);
      } else {
        if (type === 'monthly') {
          date.setMonth(date.getMonth() + 1);
        } else {
          date.setFullYear(date.getFullYear() + 1);
        }
      }
      var expiration = "".concat((date.getMonth() + 1).toString().padStart(2, '0'), "/").concat(date.getDate().toString().padStart(2, '0'), "/").concat(date.getFullYear());
      $('.membership-status-type').text(type);
      $('.membership-status-renewal').text(renewal);
      $('.membership-status-expiration').text(expiration);
      $('.membership-status-manage').attr('href', manageUrl);
    }
  })["catch"]();
}
function setMemberLinks() {
  if (typeof gObj.customerTags !== 'undefined' && gObj.customerTags.indexOf('member') !== -1) {
    $('a').each(function () {
      var url = $(this).attr('href');
      if (url && url.indexOf(gObj.membershipPageUrl) !== -1) {
        $(this).attr('href', gObj.membershipActivePageUrl);
      }
    });
  }
}
function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var randomString = '';
  for (var i = 0; i < length; i++) {
    var randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters[randomIndex];
  }
  return randomString;
}
function setDiscountClick() {
  $('.discount-link').unbind('click').click(function () {
    var redirect = '';
    if (window.location.pathname.length > 3) {
      redirect = '?redirect=' + window.location.pathname + '&' + window.location.search.substring(1);
    }
    var url = '/discount/' + $(this).attr('data-discount') + redirect;
    window.location = url;
  });
  $.getJSON(window.Shopify.routes.root + 'cart.js', function (cart) {
    var cartDiscount = false;
    if (cart.cart_level_discount_applications.length > 0) {
      cartDiscount = cart.cart_level_discount_applications[0].title;
    } else {
      cart.items.some(function (item) {
        if (item.line_level_discount_allocations) {
          item.line_level_discount_allocations.some(function (discount) {
            if (discount.discount_application.type == 'discount_code') {
              cartDiscount = discount.discount_application.title;
              return true;
            }
          });
        }
        if (cartDiscount) {
          return true;
        }
      });
      if (!cartDiscount && typeof cart.attributes !== 'undefined' && typeof cart.attributes['sf-code'] !== 'undefined' && cart.attributes['sf-code']) {
        cartDiscount = cart.attributes['sf-code'];
      }
    }
    if (cartDiscount) {
      cartDiscount = cartDiscount.toUpperCase();
      var discountSelector = '.discount-link[data-discount="' + cartDiscount + '"]';
      var appliedText = ' <i>Applied</i>';
      if ($(discountSelector).length > 0 && $(discountSelector).parent().html().indexOf(appliedText) === -1) {
        $(discountSelector).unbind('click').addClass('activated').parent().append(appliedText);
      }
    }
  });
}
function initializeSubmissionForm() {
  $submissionForm = $('.submission-form');
  if (!$submissionForm) {
    return false;
  }
  var showMessage = function showMessage(message, error) {
    error = typeof error === 'undefined' ? false : error;
    $('.message' + (error ? '.error' : ':not(.error)')).html(message).slideDown(200).find('a').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = $(this).attr('href');
    });
    scrollToDiv('.message');
  };
  var hideMessage = function hideMessage() {
    $('.message').slideUp(200);
  };
  $submissionForm.find('input, select').keyup(function () {
    $(this).css('border', '1px #d6d6d6 solid');
  });
  $submissionForm.find('button').click(function (e) {
    e.preventDefault();
    hideMessage();
    var valid = true;
    var data = {};
    $submissionForm.find('input, select').each(function () {
      if ($(this).attr('required') && $(this).val() === '' && ($(this).attr('name') !== 'other' || $('#retailer').val() === 'Other')) {
        valid = false;
        var field = $(this).attr('field') ? $(this).attr('field') : $(this).siblings('label').text().toLowerCase();
        showMessage('Field is required: ' + field, true);
        $(this).css('border', '1px #c10016 solid');
        return false;
      } else {
        data[$(this).attr('id')] = $(this).val();
      }
    });
    data['tags'] = 'Super Italian Incentive';
    if (!valid) {
      return false;
    }
    var errorMessage = 'We encountered an error with your submission. Please check your entries and try again';
    var url = getAPIUrl() + 'customer/membershipTrial';
    $.post(url, data, function (result) {
      if (result) {
        if (result && typeof result.error === 'undefined') {
          $submissionForm.find('.form').hide();
          $submissionForm.find('.instructions').hide();
          showMessage(result.message);
        } else {
          showMessage(result.error ? result.error : errorMessage, true);
          return false;
        }
      } else {
        showMessage(errorMessage);
        return false;
      }
    })["catch"](function (error) {
      console.log(error);
      showMessage(errorMessage);
      return false;
    });
  });
}
function initializeGiftRedemption() {
  if ($('#rc_gifting_container')) {
    $('#rc_gift_sender_name').addClass('required').attr('required', '').next().html('Sender name <span aria-hidden="true">*</span>');
    var today = new Date();
    today.setMonth(today.getMonth() + 3);
    setTimeout(function () {
      $('#rc_gift_notification_scheduled_at').attr('max', today.toISOString().split('T')[0]);
    }, 1000);
    var errorSet = false;
    $('#rc_gift_recipient_email').keyup(function () {
      $(this).css('border', '1px #d6d6d6 solid');
      $('.has-membership').remove();
      errorSet = false;
    }).blur(function () {
      var _this10 = this;
      var email = $(this).val();
      var url = getAPIUrl() + 'customer/' + $(this).val() + '/lookup?fields=tags';
      //console.log(url);
      $.get(url).done(function (result) {
        if (result.success && result.data.tags.indexOf('member') !== -1 && !errorSet) {
          errorSet = true;
          $(_this10).css('border', '1px #c10016 solid').after('<div class="message error has-membership" style="display: block; margin-bottom: 10px;">Recipient email already has a membership</div>');
          setTimeout(function () {
            $(_this10).val('');
          }, 1000);
        }
      })["catch"]();
    });
  }
  $giftRedemptionForm = $('#gift-redemption');
  if (!$giftRedemptionForm) {
    return false;
  }
  var urlParams = new URLSearchParams(window.location.search);
  var profileid = urlParams.get('profileid');
  var orderid = urlParams.get('orderid');
  var firstname = urlParams.get('firstname');
  var lastname = urlParams.get('lastname');
  var date = urlParams.get('date');
  if (!orderid || !firstname || !lastname) {
    $giftRedemptionForm.html('<div style="text-align: center;"><i>Error: Invalid redemption url</i></div>');
    return false;
  }
  firstname = atob(firstname);
  lastname = atob(lastname);
  if (date) {
    date = atob(date);
  }
  var qemail = urlParams.get('email');
  var qcode = urlParams.get('code');
  if (qemail) {
    $('#email').val(atob(qemail));
  }
  if (qcode) {
    $('#code').val(qcode);
  }
  var showMessage = function showMessage(message, error) {
    error = typeof error === 'undefined' ? false : error;
    $('.message' + (error ? '.error' : ':not(.error)')).html(message).slideDown(200).find('a').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = $(this).attr('href');
    });
  };
  var hideMessage = function hideMessage() {
    $('.message').slideUp(200);
  };
  $giftRedemptionForm.find('button').click(function (e) {
    e.preventDefault();
    hideMessage();
    var email = $('#email').val();
    var code = $('#code').val().replaceAll('-', '');
    ;
    if (!email) {
      showMessage('You must enter your email address', true);
      return false;
    }
    if (!code) {
      showMessage('You must enter your redemption code', true);
      return false;
    }
    if (code.length != 15) {
      showMessage('Invalid redemption code entered', true);
      return false;
    }
    if ($(this).hasClass('disabled')) {
      return false;
    }
    $(this).addClass('disabled');
    var enable = function enable() {
      $giftRedemptionForm.find('button').removeClass('disabled');
    };
    var errorMessage = 'We encountered an error with your redemption. Please check your redemption code and try again';
    var url = getAPIUrl() + 'customer/gift?profileid=' + profileid + '&orderid=' + orderid + '&email=' + encodeURIComponent(email) + '&code=' + code + '&firstname=' + encodeURIComponent(firstname) + '&lastname=' + encodeURIComponent(lastname);
    if (date) {
      url += '&date=' + date;
    }
    $.getJSON(url, function (result) {
      if (result) {
        if (result && typeof result.error === 'undefined') {
          showMessage(result.message);
        } else {
          showMessage(result.error ? result.error : errorMessage, true);
          enable();
          return false;
        }
      } else {
        showMessage(errorMessage);
        enable();
        return false;
      }
    })["catch"](function (error) {
      console.log(error);
      showMessage(errorMessage);
      enable();
      return false;
    });
  });
}
function setGiftCardForm() {
  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2, '0');
  var day = String(today.getDate()).padStart(2, '0');
  var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
  $('.gift-card-recipient .recipient-send-on').attr('min', formattedDate);
  $('.gift-card-recipient .recipient-checkbox').prop('checked', true);
}
function resizeVideoBanners() {
  if (isMobile) {
    return false;
  }
  $('.video-banner').each(function () {
    var $wrapper = $(this).find('.video-banner__block--desktop .video-banner__media-wrapper');
    var $video = $wrapper.children('video, img');
    if ($video) {
      if (!$video.attr('data-ratio')) {
        $video.attr('data-ratio', $video.height() / $video.width());
      }
      var ratio = $video.attr('data-ratio');
      if ($video.height() > $(this).height() || $video.height() < $(this).height() - 50) {
        var w = Math.min(parseInt($(this).height() / $video.height() * $video.width()), $wrapper.width());
        var h = w * ratio;
        $wrapper.css({
          'width': w + 'px',
          'margin': '0 auto',
          'background-color': 'transparent'
        });
        $video.css({
          'height': h + 'px'
        });
      }
    }
  });
}
function getPreviewCount() {
  var previews = localStorage.getItem('preview_count');
  previews = parseInt(previews);
  if (!previews) {
    previews = 0;
  }
  return previews;
}
function isNewPreview() {
  var url = window.location.pathname;
  var parts = url.split('/');
  var lastPart = parts.pop() || parts.pop();
  var previewUrls = localStorage.getItem('preview_urls') || false;
  return !previewUrls || previewUrls.indexOf(lastPart + ',') === -1;
}
function membershipPreview() {
  var previews = getPreviewCount();
  if (!previews) {
    previews = 0;
  }
  var remaining = gObj.membership.preview.count - previews;
  if (remaining < 0) {
    remaining = 0;
  }
  if (typeof gObj.customerTags !== 'undefined' && gObj.customerTags.indexOf('member') !== -1) {
    remaining = 99;
  }
  gObj.membership.preview.remaining = remaining;
  if (gObj.membership.preview.active) {
    var newPreview = isNewPreview();
    if (remaining === 0) {
      console.log('❌ No membership previews remaining');
      setTimeout(function () {
        $('.protected-content').addClass('hide-content');
      }, 500);
      if (window.location.pathname.indexOf('/recipes/') !== -1) {
        var style = document.createElement('style');
        style.innerHTML = '#fc_frame, #fc_widget { display: none !important; }';
        document.head.appendChild(style);
      }
      if (newPreview) {
        addPreview();
      }
    } else {
      if (newPreview) {
        addPreview();
        remaining -= 1;
      }
      console.log('⌛ Membership previews remaining: ' + remaining);
    }
    this.showPreviewRemaining(getPreviewCount(), gObj.membership.preview.count);
  }
}
function showPreviewRemaining(previews, total) {
  if (previews > total) {
    return;
  }
  var item = 'Article';
  if (window.location.pathname.indexOf('/recipes/') !== -1) {
    item = 'Recipe';
  } else if (window.location.pathname.indexOf('/videos/') !== -1) {
    item = 'Video';
  }
  var div = document.createElement('div');
  div.className = 'membership-preview-remaining';
  div.textContent = "Free ".concat(item, " ").concat(previews, "/").concat(total);
  document.querySelector('h1').insertAdjacentElement('afterend', div);
}
function addPreview() {
  var url = window.location.pathname;
  var parts = url.split('/');
  var lastPart = parts.pop() || parts.pop();
  var previewUrls = localStorage.getItem('preview_urls') || '';
  previewUrls += lastPart + ',';
  localStorage.setItem('preview_urls', previewUrls);
  localStorage.setItem('preview_count', getPreviewCount() + 1);
}
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
$(window).resize(function () {
  setTimeout(function () {
    adjustSlideshowCaptions();
    adjustCarouselImages();
    adjustImageOffsets(true);
    resizeVideoBanners();
  }, 300);
});
validateURL();
setMemberLinks();
membershipPreview();
var isDev = Shopify.theme.role === 'unpublished';
$(document).ready(function () {
  adjustSlideshowCaptions();
  adjustCarouselImages();
  adjustImageOffsets();
  setFacebookShare();
  setThumbReveal();
  setKlaviyoPopup();
  setHeaderOffset();
  setMobileNav();
  setFooterOffset();
  var topBar = document.querySelector('#top-bar');
  if (topBar) {
    new ResizeObserver(setHeaderOffset).observe(topBar);
  }
  initializePDP();
  initializeAnnouncement();
  initializeFavorites();
  initializeDataLayer();
  initializeYouTube();
  initializeGiftRedemption();
  initializeSubmissionForm();
  checkCustomer();
  hideAdsFromPrint();
  searchBox();
  getFavorites();
  renderInstagramSection();
  interactiveLogoSection();
  resizeVideoBanners();
  setMemberLinks();
  setDiscountClick();
  setVH();
  noPrint('#fc_frame', 1000);
  noPrint('#preview-bar-iframe');
  $('.heading .rating').click(function () {
    scrollToDiv('#comments');
  });
  $('.rk_bis_btn').click(function () {
    klaviyoBackInStockPopup($(this).data('product-title'), $(this).data('item-id'));
  });
  initializeMembershipPlansSection();
  var path = window.location.pathname;
  if (path.indexOf('account') !== -1) {
    setMembershipStatus();
  }
  if (path === '/cart') {
    $('.js-mini-cart-trigger').trigger('click');
  }
  if (path.indexOf('/products') !== -1) {
    setGiftCardForm();
  }
  if (path.indexOf('recurring/portal') !== -1) {
    applyMembershipSettings();
  }
  if (path.indexOf('account/login') !== -1) {
    setLogin();
  }
  if (window.location.search.indexOf('printguide') !== -1) {
    $('body').addClass('printguide');
  }
  if (path.indexOf('pages/livestreaming-the-membership-lp') !== -1) {
    $('a').each(function () {
      if ($(this).attr('href') === '/account/login') {
        $(this).attr('href', '/account/login?return_to=/pages/livestreaming-the-membership-lp');
      }
    });
  }
  if (isDev) {
    console.log('<<< Dev Theme: ' + Shopify.theme.name + ' >>>');
    $(document).unbind('contextmenu');
    cartDebug();
  }
});
if (window.location.search.indexOf('rightclick') === -1) {
  $(document).on('contextmenu', function (e) {
    if (typeof e.ctrlKey === 'undefined' || !e.ctrlKey || window.navigator.userAgent.indexOf('Windows') === -1) {
      e.preventDefault();
    }
  });
}
var playVideoButtons = document.querySelectorAll('.js-play-video-button');
playVideoButtons.forEach(function (playVideoButton) {
  playVideoButton.addEventListener('click', function (event) {
    var videoContext = playVideoButton.dataset.videoContext;
    var isYouTube = playVideoButton.dataset.videoType === 'youtube';
    var videoBanner = event.target.closest('.js-video-banner');
    videoBanner.classList.add('is-active');
    if (isYouTube) {
      var iframe = videoBanner.querySelector(videoContext === 'desktop' ? '.js-video-banner-desktop' : '.js-video-banner-mobile');
      var poster = iframe.parentElement.querySelector('.js-video-poster');
      if (iframe.dataset.src) {
        iframe.src = iframe.dataset.src;
      }
      iframe.style.display = '';
      if (poster) poster.style.display = 'none';
      playVideoButton.style.display = 'none';
    } else {
      var videoDesktop = videoBanner.querySelector('.js-video-banner-desktop');
      var videoMobile = videoBanner.querySelector('.js-video-banner-mobile');
      if (videoDesktop) videoDesktop.setAttribute('controls', true);
      if (videoMobile) videoMobile.setAttribute('controls', true);
      videoContext === 'desktop' ? videoDesktop.play() : videoMobile.play();
    }
  });
});
var resetVideoBanners = function resetVideoBanners() {
  var videoBanners = document.querySelectorAll('.js-video-banner');
  videoBanners.forEach(function (videoBanner) {
    var videos = videoBanner.querySelectorAll('video');
    videos.forEach(function (video) {
      if (video.currentTime === 0) return;
      video.pause();
      video.currentTime = 0;
    });
    /* Reset YouTube iframes */
    var iframes = videoBanner.querySelectorAll('.video-banner__youtube');
    iframes.forEach(function (iframe) {
      if (iframe.src) {
        iframe.src = '';
        iframe.style.display = 'none';
        var poster = iframe.parentElement.querySelector('.js-video-poster');
        if (poster) poster.style.display = '';
      }
    });
  });
};
window.addEventListener('resize', function () {
  resetVideoBanners();
});